import React, { useState, useEffect, useRef } from "react";
import { FaEye,FaEdit,FaDownload, FaTimes,FaTimesCircle, FaCheck,FaStar,FaStarHalfAlt, FaRegStar} from "react-icons/fa";
import image1 from "../assets/house.png";
import { CiSearch } from "react-icons/ci";
import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import Bed from "../assets/beds.png";
import "jspdf-autotable"; // Import the autotable plugin
import { FaFileExcel, FaFilePdf } from "react-icons/fa";
import axios from "axios"; // Import axios
import { BaseUrl } from "../App";

// import { Circles } from "react-loader-spinner";

import { FadeLoader } from 'react-spinners';


function AppointmentS() {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  console.log(selectedAppointment);
  //(selectedAppointment);
  const [abcdiscountedTotal, setdiscountedTotal] = useState(null);
  const [abcfinelamount, setfinelamount] = useState(null);
  const [abctotelamount, settotelamount] = useState(null);

  const [order_id_appointment, setorder_id_appointment] = useState(0);
  //(order_id_appointment);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [totalTime, setTotalTime] = useState(0); // To track total time
  const [showCancelRecurrence, setShowCancelRecurrence] = useState(false);
  const [isServiceOpen, setIsServiceOpen] = useState(false); // Toggle "Choose Services"
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedFrequency, setSelectedFrequency] = useState("Weekly");
  const [officeresidential, setofficeResidential] = useState(false);
  const [officecommercial, officesetCommercial] = useState(false);
  const [showEditServiceModal, setShowEditServiceModal] = useState(false);
  const [residential, setResidential] = useState(false);
  const [commercial, setCommercial] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ratings, setRatings] = useState();
  const [appointments, setAppointments] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(0);
  const [text, setText] = useState();
  const [showBookingSummary, setShowBookingSummary] = useState(false);
  const [showBookingSummary2, setShowBookingSummary2] = useState(false);
  const [editdataid, seteditdataid] = useState();
  console.log(editdataid);
  const [services, setServices] = useState([]);
  //(services);
  const [damagedFloors, setDamagedFloors] = useState(0);
  const [doorJams, setDoorJams] = useState(0);
  const [packing, setPacking] = useState(0);
  const [storeroom, setStoreroom] = useState(0);
  const [selectedservices, setselectedservices] = useState(0);
  const [area, setArea] = useState(0);
  const [officearea, setOfficeArea] = useState(0);
  const [extraDamagedFloors, setExtraDamagedFloors] = useState(0);
  const [extraDoorJams, setExtraDoorJams] = useState(0);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [Disamount, setDisamount] = useState(0);
  const [officeextraDamagedFloors, setofficeExtraDamagedFloors] = useState(0);
  const [officeextraDoorJams, setofficeExtraDoorJams] = useState(0);
  const [showImageSection, setShowImageSection] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  //(selectedService);
  const [bookingBill, setBookingBill] = useState([]);
  //(bookingBill);
  const [bedroom, setBedroom] = useState(0);
  const [bathroom, setBathroom] = useState(0);
  const [tax, settax] = useState(0);
  const [quantities, setQuantities] = useState([0, 0, 0]);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [maintotelamount, setmaintotelamount] = useState(0);

  //(selectedMethod);
  const [userDetails, setUserDetails] = useState(null);
  const [bookingappointment, setbookingappointment] = useState([]);
  const [subtotale, setsubtotale] = useState(0);
  const [adminData, setAdminData] = useState(null);
  const [userSelectedMethods, setUserSelectedMethods] = useState(null);
  const [userSelectedMethodsId, setUserSelectedMethodsId] = useState(null);
  const [userSelectedMethodsUnitsId, setUserSelectedMethodsUnitsId] =
    useState(null);
  const [userSelectedMethodsSmqty, setUserSelectedMethodsSmqty] =
    useState(null);
  const [isRatingModalOpen, setIsRatingModalOpen] = useState(false);
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [rating, setRating] = useState(0); // Rating value (1 to 5)
  const [hoveredRating, setHoveredRating] = useState(null); // To track hover state
  const [review, setReview] = useState(""); // Review text
  const [userSelectedAddon, setUserSelectedAddon] = useState(null);
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState("");
  const [notes, setNote] = useState("");
  const [time, setTime] = useState("");
  const currentDate = new Date();
  const bookingDate = new Date(selectedAppointment?.booking_date_time);
  const [allsetdata, setallsetdata] = useState();
  const [totelamount, setTotelamount] = useState(0); // Already declared as abctotelamount, but misspelled
  const [disType, setDisType] = useState(null)

  console.log(allsetdata);
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);

  
  const calculateTotal = () => {
    const existingTotal = bookingBill.reduce(
      (total, item) => total + item.s_m_rate,
      0
    );
  

    return existingTotal;
  };


  const getbooking = async (id) => {
    if (!id) {
      console.error("❌ No order_id provided for get_service_cart_list API");
      return null;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        {
          action: "get_service_cart_list",
          api_key: "1",
          order_id: id,
        }
      );

      if (response.status === 200 && response.data.status === "true") {
        return response.data.response; // Return fresh data
      } else {
        console.error("❌ Unexpected response:", response.data);
        return null;
      }
    } catch (error) {
      console.error("🚨 Error fetching get_service_cart_list:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

const parseCurrency = (str) => {
  if (!str || typeof str !== "string") return 0;
  return parseFloat(str.replace(/[^0-9.-]+/g, "")) || 0;
};

const totalAmount = parseCurrency(allsetdata?.total_amount); // ₹82.00 -> 82
const discountAmount = parseCurrency(allsetdata?.discount); // ₹8.00 -> 8
const taxAmount = parseCurrency(allsetdata?.cart_tax); // ₹10.00 -> 10
// const frequentDiscount = parseCurrency(allsetdata?.frequent_discount); // - ₹1.00 -> -1
const frequencyMapData = {
  Once: 0,
  Weekly: 15,
  "Bi-Weekly": 12.5,
  Monthly: 10,
};
const total = calculateTotal(); // Sum of s_m_rate from bookingBill
const subTotalEdit = total; // Use bookingBill total instead of totalAmount
// const discountedTotal = discountAmount + Math.abs(frequentDiscount); // Combine discount and frequent_discount
console.log(allsetdata?.discount_typename)
const discountedTotal = subTotalEdit / frequencyMapData[allsetdata?.discount_typename] ; // Combine discount and frequent_discount
const finelamount = subTotalEdit - discountedTotal + taxAmount;

console.log({
  totalAmount,
  discountAmount,
  taxAmount,
  // frequentDiscount,
  total,
  subTotalEdit,
  discountedTotal,
  finelamount,
});
  const diffInMonths =
    (bookingDate.getFullYear() - currentDate.getFullYear()) * 12 +
    bookingDate.getMonth() -
    currentDate.getMonth();

  // Check if the booking is more than one month in the future
  const isMoreThanOneMonthAway =
    diffInMonths > 1 ||
    (diffInMonths === 1 && bookingDate.getDate() > currentDate.getDate());

    // const calculateDaysDifference = (appointmentDate) => {
    //   const currentDate = new Date();
    //   const bookingDate = new Date(appointmentDate);
    //   const timeDiff = bookingDate - currentDate;
    //   const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    //   return daysDiff;
    // };
    const calculateDaysDifference = (appointmentDate) => {
      const bookingDate = new Date(appointmentDate);
      const timeDiff = bookingDate - currentDate;
      return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    };
  const methodSelectedRef = useRef(false);
  const [Services_frequently_discount, setServices_frequently_discount] =
    useState([]);
  const [propertyQuantities, setPropertyQuantities] = useState({
    Build_walls: 0,
    Build_doors: 0,
    Build_windows: 0,
  });
  const [officeQuantities, setOfficeQuantities] = useState({
    desk: 0,
    window: 0,
  });


  const fetchRatings = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(`${BaseUrl}/backend/api/accept.appointment.php`, {
        action: 'get_ratings',
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      console.log(response.data)

      // Check if the response is successful
      if (response.data.status === 'true' && response.data.statuscode === 200) {
        setRatings(response.data.response); // Store the ratings data
      } else {
        setError(response.data.response || 'Failed to fetch ratings');
      }
    } catch (err) {
      setError(err.message || 'An error occurred while fetching ratings');
    } finally {
      setLoading(false);
    }
  };

  // Fetch ratings when the component mounts
  useEffect(() => {
    fetchRatings();
  }, []);

  const addItemToBill = (units_id, itemName, quantity, pricePerItem) => {
    setBookingBill((prevBill) => {
      const existingItemIndex = prevBill.findIndex(
        (item) => item.units_id === units_id && item.type === "method_units"
      );
      let updatedBill = [...prevBill];
  
      if (existingItemIndex !== -1) {
        if (quantity > 0) {
          updatedBill[existingItemIndex] = {
            ...updatedBill[existingItemIndex],
            s_m_qty: quantity,
            s_m_rate: quantity * parseFloat(pricePerItem),
          };
        } else {
          updatedBill.splice(existingItemIndex, 1);
        }
      } else if (quantity > 0) {
        updatedBill.push({
          type: "method_units",
          service_id: selectedService,
          method_id: selectedMethod?.method_id,
          units_id: units_id,
          name: itemName,
          s_m_qty: quantity,
          s_m_rate: quantity * parseFloat(pricePerItem),
        });
      }
  
      calculateDiscountedTotal(updatedBill);
      return updatedBill;
    });
  };
  const frequencyMap = {
    Once: 0,
    Weekly: 15,
    "Bi-Weekly": 12.5,
    Monthly: 10,
  };

  const calculateDiscountedTotal = (updatedBill = bookingBill) => {
    // Calculate subtotal from bookingBill
    const subtotal = updatedBill.reduce((sum, item) => sum + (parseFloat(item.s_m_rate) || 0), 0);
    setsubtotale(subtotal);
  
    // Determine discount type (use API's discount_typename or fallback to selectedFrequency)
    const discountType = allsetdata?.discount_typename || selectedFrequency;
    
    // Get discount percentage from frequencyMap (default to 0 if not found)
    const discountPercentage = frequencyMap[discountType] || 0;
    
    // Calculate discount based on subtotal and percentage
    const calculatedDiscount = subtotal * (discountPercentage / 100);
  
    // Use API tax value (fallback to 0 if not provided)
    const apiTax = parseCurrency(allsetdata?.cart_tax) || 0;
  
    // Calculate final total: subtotal - discount + tax
    const finalTotal = subtotal - calculatedDiscount + apiTax;
  
    // Update state
    settotelamount(subtotal);
    setDisamount(calculatedDiscount);
    settax(apiTax);
    setfinelamount(finalTotal);
    setdiscountedTotal(calculatedDiscount);
  
    return finalTotal;
  };
  const [icon, setIcon] = useState("+"); // State to control the icon (either "+" or "-")
  const handleImageSectionToggle = () => {
    setShowImageSection((prev) => !prev);
    setIcon((prev) => (prev === "+" ? "-" : "+"));
  };
  const [formData, setFormData] = useState({
    serviceLocation: "",
    zipCode: "",
    selectedService: "",
    image: image1,
    showHouseOptions: false,
    showPlumbingOptions: false,
    showCarpenterOptions: false,
    showOfficeOptions: false,
    bedroomCount: "",
    bathroomCount: "",
  });
  const navigate = useNavigate();

 // Replace this section in your existing code around line 600-650 (where paginatedData and related logic is defined)

// Filtered Data
const filteredData = appointments.filter(
  (row) =>
    row.order_id.toLowerCase().includes(searchQuery.toLowerCase()) || // Filter by order_id
    row.appointment_date.includes(searchQuery) || // Filter by appointment_date
    row.appointment_time.includes(searchQuery) // Filter by appointment_time
);

// Total Entries
const totalEntries = filteredData.length;

// Pagination Logic
const startIndex =
  (currentPage - 1) *
  (entriesPerPage === "All" ? totalEntries : entriesPerPage);

// Paginated Data with Ascending Order Sorting (Earliest First)
const paginatedData = (
  entriesPerPage === "All"
    ? filteredData
    : filteredData.slice(startIndex, startIndex + entriesPerPage)
)
  .filter((item, index, self) => {
    const uniqueKey = `${item.order_id}-${item.appointment_date}`;
    return (
      index ===
      self.findIndex(
        (t) => `${t.order_id}-${t.appointment_date}` === uniqueKey
      )
    );
  })
  .sort((a, b) => {
    const dateA = new Date(a.appointment_date); // Note: a first
    const dateB = new Date(b.appointment_date); // Note: b second
    if (dateA < dateB) return -1; // Earliest dates first
    if (dateA > dateB) return 1;
    if (a.order_id < b.order_id) return -1; // Lower order_id first
    if (a.order_id > b.order_id) return 1;
    return 0;
  });
// Total Pages Calculation
const totalPages =
  entriesPerPage === "All" ? 1 : Math.ceil(totalEntries / entriesPerPage);

// Handlers
const handleSearch = (e) => setSearchQuery(e.target.value);

const handleEntriesChange = (e) => {
  setEntriesPerPage(e.target.value === "All" ? "All" : Number(e.target.value));
  setCurrentPage(1); // Reset to the first page
};

const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));

const handleNextPage = () =>
  setCurrentPage((prev) => Math.min(prev + 1, totalPages));

// Add this useEffect to set default entriesPerPage to 10 on component mount
useEffect(() => {
  setEntriesPerPage(10); // Set default to 10 entries
}, []); // Runs only once when component mounts


  // const generateInvoice = async (userId, allsetdata) => {
  //   console.log(allsetdata);

  //   // Retrieve user details from your state (ensure this returns an object)
  //   const user = userDetails;
  //   if (!user) {
  //     console.error("User details not found");
  //     return; // Exit if user details are not available
  //   }

  //   //("Appointment Data:", appointment);
  //   const doc = new jsPDF();

  //   // Company details (static in this example)
  //   const companyDetails = {
  //     name: "MegaClean",
  //     address: "123 Clean St, Riyadh",
  //     phone: "+1005555555",
  //   };

  //   // **Company Header**
  //   doc.setFontSize(16);
  //   doc.setFont("helvetica", "bold");
  //   doc.text(companyDetails.name, 20, 20);
  //   doc.setFontSize(10);
  //   doc.setFont("helvetica", "normal");
  //   doc.text(companyDetails.address, 20, 30);
  //   doc.text(companyDetails.phone, 20, 37);

  //   // **Invoice Header**
  //   doc.setFontSize(14);
  //   doc.setFont("helvetica", "bold");
  //   // Adjust x-coordinate based on page width for right alignment
  //   doc.text("INVOICE", doc.internal.pageSize.width - 60, 20);
  //   doc.setFontSize(10);
  //   doc.setFont("helvetica", "normal");
  //   // Use dynamic date if available, or fallback to current date
  //   const invoiceDate =
  //     allsetdata?.invoice_date || new Date().toLocaleDateString();
  //   doc.text(
  //     `Invoice Date: ${invoiceDate}`,
  //     doc.internal.pageSize.width - 60,
  //     30
  //   );
  //   // Use dynamic order ID from allsetdata? data
  //   doc.text(
  //     `Order ID: ${allsetdata?.order_id || "N/A"}`,
  //     doc.internal.pageSize.width - 60,
  //     37
  //   );

  //   // **Customer Details**
  //   doc.setFontSize(12);
  //   doc.setFont("helvetica", "bold");
  //   doc.text("Customer Details", 20, 55);
  //   doc.setFontSize(10);
  //   doc.setFont("helvetica", "normal");
  //   doc.text(
  //     `Name: ${user.first_name || "N/A"} ${user.last_name || ""}`,
  //     20,
  //     65
  //   );
  //   doc.text(`Email: ${user.user_email || "N/A"}`, 20, 72);
  //   doc.text(`Phone: ${user.phone || "N/A"}`, 20, 79);
  //   // Concatenate address fields ensuring commas only if fields exist
  //   const addressParts = [user.address, user.city, user.state, user.zip].filter(
  //     Boolean
  //   );
  //   doc.text(`Address: ${addressParts.join(", ") || "N/A"}`, 20, 86);

  //   let yPosition = 105;

  //   // **Service Table Header**
  //   const tableTop = yPosition;
  //   doc.setFillColor(51, 51, 51);
  //   doc.setTextColor(255, 255, 255);

  //   // Draw table header background cells
  //   doc.rect(20, tableTop, 100, 8, "F"); // Service Name column
  //   doc.rect(120, tableTop, 25, 8, "F"); // Quantity column
  //   doc.rect(145, tableTop, 25, 8, "F"); // Unit Price column
  //   doc.rect(170, tableTop, 25, 8, "F"); // Total column

  //   // Add table header texts
  //   doc.setFontSize(10);
  //   doc.setFont("helvetica", "bold");
  //   doc.text("Service Name", 22, tableTop + 6);
  //   doc.text("Qty", 128, tableTop + 6);
  //   doc.text("Unit Price", 147, tableTop + 6);
  //   doc.text("Total", 172, tableTop + 6);

  //   // Reset text color for the table body
  //   doc.setTextColor(0, 0, 0);
  //   yPosition = tableTop + 15;

  //   // **Service Details** (dynamic values with fallbacks)
  //   const serviceTitle = allsetdata?.service_title || "N/A";
  //   const serviceUnit = allsetdata?.units_title || "";
  //   const serviceQty = allsetdata?.method_unit_id || "N/A";
  //   const unitPrice = allsetdata?.method_unit_qty_rate || "N/A";
  //   const totalPrice =
  //     allsetdata?.method_unit_id && allsetdata?.method_unit_qty_rate
  //       ? `$${(
  //           parseFloat(allsetdata?.method_unit_id) *
  //           parseFloat(allsetdata?.method_unit_qty_rate)
  //         ).toFixed(2)}`
  //       : "N/A";

  //   doc.setFont("helvetica", "normal");
  //   doc.text(
  //     `${serviceTitle} ${serviceUnit ? `(${serviceUnit})` : ""}`,
  //     22,
  //     yPosition
  //   );
  //   doc.text(String(serviceQty), 128, yPosition);
  //   doc.text(String(unitPrice), 147, yPosition);
  //   doc.text(String(totalPrice), 172, yPosition);

  //   // **Add-ons Section**
  //   yPosition += 20;
  //   doc.setFont("helvetica", "bold");
  //   doc.text("Add-ons", 20, yPosition);
  //   doc.setFont("helvetica", "normal");
  //   yPosition += 10;

  //   // Process add-ons if available
  //   if (allsetdata?.addon_service_name) {
  //     const addons = allsetdata?.addon_service_name.split(",");
  //     const addonQty = allsetdata?.addons_service_qty
  //       ? allsetdata?.addons_service_qty.split(",")
  //       : [];
  //     const addonRate = allsetdata?.addons_service_rate
  //       ? allsetdata?.addons_service_rate.split(",")
  //       : [];
  //     const addonUnits = allsetdata?.addon_service_name
  //       ? allsetdata?.addon_service_name.split(",")
  //       : [];
  //     const addonPrice = allsetdata?.addons_service_rate
  //       ? allsetdata?.addons_service_rate.split(",")
  //       : [];

  //     addons.forEach((addon, i) => {
  //       const currentUnit = addonUnits[i] || "N/A";
  //       const currentQty = addonQty[i] || "N/A";
  //       const currentRate = addonRate[i] || "N/A";
  //       const crrentprice = addonPrice[i] || "N/A";
  //       doc.text(String(currentQty), 128, yPosition);
  //       doc.text(`${addon} (${currentUnit})`, 22, yPosition);
  //       doc.text(String(crrentprice), 147, yPosition);

  //       doc.text(String(currentRate), 172, yPosition);

  //       yPosition += 10;
  //     });
  //   } else {
  //     doc.text("No Add-ons available", 22, yPosition);
  //     yPosition += 10;
  //   }
  //   yPosition += 15;
  //   doc.setFont("helvetica", "bold");
  //   doc.text("Summary", 20, yPosition);
  //   yPosition += 10;

  //   const cleanCurrency = (value) => {
  //     if (!value) return 0;
  //     return parseFloat(value.toString()?.replace(/[^0-9.]/g, "")) || 0;
  //   };

  //   // Dynamic summary items using API response values directly
  //   const subtotal = cleanCurrency(allsetdata?.amount) || 0; // Using amount as subtotal
  //   const frequently_discount_amount =
  //     cleanCurrency(allsetdata?.discount) || 0; // Direct discount value
  //   // const couponDiscount = cleanCurrency(allsetdata?.frequent_discount) || 0;  // Using frequent_discount as coupon
  //   const taxAmount = cleanCurrency(allsetdata?.cart_tax) || 0; // Direct tax value

  //   const summaryItems = [
  //     { label: "Subtotal", value: `${Number(subtotal).toFixed(2)}` },

  //     {
  //       label: "Discount",
  //       value: `${Number(frequently_discount_amount).toFixed(2)}`,
  //     },
  //     { label: "Tax", value: `${Number(taxAmount).toFixed(2)}` },
  //   ];

  //   doc.setFont("helvetica", "normal");
  //   summaryItems.forEach((item) => {
  //     doc.text(item.label, 120, yPosition);
  //     doc.text(item.value, 172, yPosition);
  //     yPosition += 8;
  //   });

  //   // **Total Calculation**
  //   yPosition += 5;
  //   doc.setFillColor(240, 240, 240);
  //   doc.rect(115, yPosition - 6, 80, 8, "F");
  //   doc.setFont("helvetica", "bold");
  //   // Use total_amount directly from API response instead of calculating
  //   const totalPayment = cleanCurrency(allsetdata?.total_amount) || 0;
  //   doc.text("Total", 120, yPosition);
  //   doc.text(`${Number(totalPayment).toFixed(2)}`, 172, yPosition);

  //   // **Footer with Booking Date**
  //   yPosition += 25;
  //   doc.setFont("helvetica", "normal");
  //   const bookingDate = allsetdata?.booking_date_time || "N/A";
  //   doc.text(`Booked On: ${bookingDate}`, 20, yPosition);

  //   yPosition += 10;
  //   doc.setFont("helvetica", "bold");
  //   doc.text("Thank you for choosing MegaClean!", 20, yPosition);

  //   // Page number at bottom right
  //   doc.setFont("helvetica", "normal");
  //   doc.setFontSize(10);
  //   doc.text(
  //     "Page 1 of 1",
  //     doc.internal.pageSize.width - 30,
  //     doc.internal.pageSize.height - 10
  //   );

  //   // Save the generated invoice as a PDF file
  //   doc.save(`Invoice_${userId}.pdf`);
  // };
  const generateInvoice = async (userId, allsetdata) => {
    const user = userDetails;
    if (!user || !allsetdata) return;

    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("MegaClean", 20, 20);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("123 Clean St, Riyadh", 20, 30);
    doc.text("+1005555555", 20, 37);

    doc.setFontSize(14);
    doc.text("INVOICE", doc.internal.pageSize.width - 60, 20);
    doc.setFontSize(10);
    doc.text(`Invoice Date: ${new Date().toLocaleDateString()}`, doc.internal.pageSize.width - 60, 30);
    doc.text(`Order ID: ${allsetdata.order_id}`, doc.internal.pageSize.width - 60, 37);

    doc.setFontSize(12);
    doc.text("Customer Details", 20, 55);
    doc.setFontSize(10);
    doc.text(`Name: ${user.first_name || "N/A"} ${user.last_name || ""}`, 20, 65);
    doc.text(`Email: ${user.user_email || "N/A"}`, 20, 72);
    doc.text(`Phone: ${user.phone || "N/A"}`, 20, 79);
    doc.text(`Address: ${[user.address, user.city, user.state, user.zip].filter(Boolean).join(", ") || "N/A"}`, 20, 86);

    let yPosition = 105;
    doc.autoTable({
      startY: yPosition,
      head: [['Service Name', 'Qty', 'Unit Price', 'Total']],
      body: allsetdata.cart_items.map(item => [
        item.method_name || item.addon_name,
        item.s_m_qty,
        `${parseFloat(item.s_m_rate / item.s_m_qty).toFixed(2)}`,
        `${item.s_m_rate}`
      ]),
    });

    yPosition = doc.lastAutoTable.finalY + 15;
    doc.setFont("helvetica", "bold");
    doc.text("Summary", 20, yPosition);
    yPosition += 10;

    const subtotal = allsetdata.cart_items.reduce((sum, item) => sum + parseFloat(item.s_m_rate), 0);
    doc.setFont("helvetica", "normal");
    doc.text("Subtotal", 120, yPosition);
    doc.text(`${subtotal.toFixed(2)}`, 172, yPosition);
    yPosition += 8;
    doc.text("Discount", 120, yPosition);
    doc.text(`-${parseCurrency(allsetdata.discount).toFixed(2)}`, 172, yPosition);
    yPosition += 8;
    doc.text("Tax", 120, yPosition);
    doc.text(`${parseCurrency(allsetdata.cart_tax).toFixed(2)}`, 172, yPosition);
    yPosition += 8;
    doc.text("Total", 120, yPosition);
    doc.text(`${parseCurrency(allsetdata.total_amount).toFixed(2)}`, 172, yPosition);

    doc.save(`Invoice_${userId}.pdf`);
  };
  const toggleServicePanel = () => {
    setIsServiceOpen((prev) => !prev); // Toggle this panel
    if (!isServiceOpen) {
      // If opening this panel
      setIsCalendarOpen(false); // Close others
      setIsFormOpen(false);
    }
  };
  const openRatingMenuaaa = (row) => {
    //("hello");
    setSelectedAppointment(row); // Store the selected row data
    setIsRatingModalOpen(true); // Open the modal
  };
  const closeRatingMenu = () => {
    setIsRatingModalOpen(false); // Close the modal
  };
  const handleSaveRating = async () => {
    setLoading(true);

    // Ensure selectedAppointment has valid data
    if (!selectedAppointment) {
      console.error("No appointment selected.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/accept.appointment.php`,
        {
          action: "add_rating_review",
          api_key: "1", // Your API key
          order_id: selectedAppointment.order_id, // Pass order_id
          staff_id: selectedAppointment.staff_ids, // Pass staff_id
          rating: rating, // Convert rating to string if necessary
          review: review, // User review text
        }
      );

      // Check if the response is successful
      if (response.data.status === "true") {
        setSuccessMessage("Add Rating Review Successfully!");
        setShowRatingModal(false); // Close the modal
        fetchRatings()
        // Reset rating and review state
        setRating(0);
        setReview("");

        // Refresh appointment list
        fetchAppointments(sessionStorage.getItem("userId"));
      } else {
        console.error("Error saving rating:", response.data);
      }
    } catch (error) {
      console.error("Error during API call:", error);
    } finally {
      setLoading(false); // Ensure loading is stopped in all cases
      closeRatingModal();
    }
  };

  // Close rating modal
  const closeRatingModal = () => {
    setIsRatingModalOpen(false);
    setRating(0);
    setReview("");
  };
  const handleSaveCancel = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/appointment_reject.php`,
        {
          action: "reject_appointment",
          api_key: "1",
          order_id: selectedAppointment.order_id,
          reject_reason: cancelReason,
        }
      );

      if (response.data.response) {
        setSuccessMessage("Reject Appointment Successfully!");
      } else {
        console.error("Error rejecting appointment:", response.data);
      }
    } catch (error) {
      console.error("Error during API call:", error);
    } finally {
      setLoading(false); // Ensure loading stops in all cases
      setShowCancelModal(false); // Ensure modal is closed
    }
  };

  const handleUpdate = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/appointment_reshedule.php`,
        {
          action: "reschedule_appointment",
          api_key: "1",
          order_id: selectedAppointment.order_id,
          date,
          notes,
          time,
        }
      );

      if (response.data.response) {
        setSuccessMessage("Reschedule Appointment Successfully!");
      } else {
        console.error("Error rescheduling appointment:", response.data);
      }
    } catch (error) {
      console.error("Error during API call:", error);
    } finally {
      setLoading(false); // Ensure loading stops in all cases
      closeModal(); // Ensure modal is closed
    }
  };

  const handleReviewChange = (e) => {
    setReview(e.target.value);
  };
  // Handle Cancel
  const handleCancelRating = () => {
    setIsRatingModalOpen(false);
  };

  // const removeItem = (idx) => {
  //   setBookingBill((prevBill) => prevBill.filter((_, index) => index !== idx));
  // };
  const removeItem = (idx) => {
    setBookingBill((prevBill) => {
      const itemToRemove = prevBill[idx];
      const updatedBill = prevBill.filter((_, index) => index !== idx);
  
      // If removing a submethod
      if (itemToRemove.type === "method_units") {
        // No direct state to reset for dropdown, it will reset to "" automatically
      }
  
      // If removing an add-on
      if (itemToRemove.type === "addon") {
        const addonIndex = services
          .find((s) => s.service_id === selectedService)
          ?.addons.findIndex((a) => a.addon_id === itemToRemove.units_id);
        if (addonIndex !== undefined) {
          setQuantities((prev) => {
            const newQuantities = [...prev];
            newQuantities[addonIndex] = 0;
            return newQuantities;
          });
          setUserSelectedAddon((prev) =>
            prev.filter((id) => id !== itemToRemove.units_id)
          );
        }
      }
  
      return updatedBill;
    });
  };
  const handleMethodSelection = (method, id) => {
    //("****************************", method, id);
    switch ((method?.method_title, id)) {
      case "Residential Services":
        setResidential(true);
        setCommercial(false);
        setofficeResidential(false);
        officesetCommercial(false);
        break;
      case "Commercial Services":
        setResidential(false);
        setCommercial(true);
        setofficeResidential(false);
        officesetCommercial(false);
        break;
      case "Property Based":
        setResidential(false);
        setCommercial(false);
        setofficeResidential(true);
        officesetCommercial(false);
        break;
      case "Area Based (Feet)":
        setResidential(false);
        setCommercial(false);
        setofficeResidential(false);
        officesetCommercial(true);
        break;
      default:
        // Reset all states if no match is found
        setResidential(false);
        setCommercial(false);
        setofficeResidential(false);
        officesetCommercial(false);
    }
    setSelectedMethod(method, id);
  };
  const handleCancel = () => {
    setShowAppointmentModal(false); // Close the appointment modal
    setShowCancelModal(true); // Open the cancel modal
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Log the value for the selected bedroom
    if (name === "bedroomCount") {
      //(`Selected Bedroom: ${value}`);
    }
  };
  useEffect(() => {
    calculateDiscountedTotal(); // Calculate discounted total whenever discount or total changes
  }, [
    selectedService,
    bookingBill,
    propertyQuantities,
    area,
    damagedFloors,
    doorJams,
    officeQuantities,
    officearea,
    packing,
    storeroom,
  ]);
  useEffect(() => {
    const updateOrAddToBill = (itemName, quantity, pricePerItem) => {
      const existingItemIndex = bookingBill.findIndex(
        (item) => item.name === itemName
      );
      if (existingItemIndex !== -1) {
        const updatedBill = [...bookingBill];
        if (quantity > 0) {
          updatedBill[existingItemIndex] = {
            ...updatedBill[existingItemIndex],
            quantity,
            price: quantity * pricePerItem,
          };
        } else {
          updatedBill.splice(existingItemIndex, 1); // Remove the item if quantity is zero
        }
        setBookingBill(updatedBill);
      } else if (quantity > 0) {
        setBookingBill([
          ...bookingBill,
          {
            type: "addon",
            s_m_qty: quantity,
            s_m_rate: quantity * pricePerItem,
          },
        ]);
      }
    };
    updateOrAddToBill("Bedrooms", bedroom, 5);
    updateOrAddToBill("Bathrooms", bathroom, 5);
  }, [bedroom, bathroom]);
  const handleBedroomChange = (unitId, value) => {
    setBedroom((prevSelections) => ({
      ...prevSelections,
      [unitId]: value,
    }));
  };
  const openEditServiceModal = async (row) => {
    setLoading(true);
    setorder_id_appointment(row.order_id);
    setBookingBill([]);
    setTotalTime(0);
    setSelectedService(null);
    setSelectedMethod(null);
    setUserSelectedMethods([]);
    setUserSelectedMethodsId([]);
    setUserSelectedMethodsUnitsId([]);
    setUserSelectedMethodsSmqty([]);
    setUserSelectedAddon([]);
    setQuantities([0, 0, 0]);
    setallsetdata(null);
  
    try {
      const bookingResponse = await getbooking(row.order_id);
      if (bookingResponse) {
        setallsetdata(bookingResponse);
        setSelectedAppointment(bookingResponse);
        setShowEditServiceModal(true);
  
        // Extract cart items and service/method details
        const cartItems = bookingResponse.cart_items || [];
        const serviceIds = [...new Set(cartItems.map(item => item.service_id))];
        const methodIds = cartItems
          .filter(item => item.type === "method_units")
          .map(item => item.method_id);
        const unitsIds = cartItems.map(item => item.units_id);
        const s_m_qty = cartItems.map(item => parseInt(item.s_m_qty) || 0);
        const addonIds = cartItems
          .filter(item => item.type === "addon")
          .map(item => item.units_id);
  
        // Set selected service and method
        setUserSelectedMethods(serviceIds);
        setUserSelectedMethodsId(methodIds);
        setUserSelectedMethodsUnitsId(unitsIds);
        setUserSelectedMethodsSmqty(s_m_qty);
        setUserSelectedAddon(addonIds);
  
        setSelectedService(serviceIds[0] || bookingResponse.service_id);
        const selectedServiceData = services.find(
          s => s.service_id === serviceIds[0]
        );
        const selectedMethodData = selectedServiceData?.methods.find(
          m => methodIds.includes(m.method_id)
        );
        if (selectedMethodData) {
          handleMethodSelection(selectedMethodData, selectedMethodData.method_id);
        }
  
        // Initialize bookingBill from cart_items
        const newBookingBill = cartItems.map(item => ({
          type: item.type,
          service_id: item.service_id,
          method_id: item.method_id || null,
          units_id: item.units_id,
          name: item.method_name || item.addon_name || "Unknown",
          s_m_qty: parseInt(item.s_m_qty) || 0,
          s_m_rate: parseFloat(item.s_m_rate) || 0,
        }));
        setBookingBill(newBookingBill);
  
        // Initialize addon quantities
        const addonQuantities = selectedServiceData?.addons?.map(addon => {
          const addonItem = cartItems.find(
            item => item.type === "addon" && item.units_id === addon.addon_id
          );
          return addonItem ? parseInt(addonItem.s_m_qty) || 0 : 0;
        }) || [0, 0, 0];
        setQuantities(addonQuantities);
  
        // Calculate financials
        const subtotal = cartItems.reduce(
          (sum, item) => sum + (parseFloat(item.s_m_rate) || 0),
          0
        );
        const discountType = bookingResponse.discount_typename || selectedFrequency;
        const discountPercentage = frequencyMap[discountType] || 0;
        const calculatedDiscount = subtotal * (discountPercentage / 100);
        const tax = parseCurrency(bookingResponse.cart_tax) || 0;
        const total = subtotal - calculatedDiscount + tax;
  
        setsubtotale(subtotal);
        setDisamount(calculatedDiscount);
        settax(tax);
        settotelamount(subtotal);
        setfinelamount(total);
        setdiscountedTotal(calculatedDiscount);
  
        // Set total time
        setTotalTime(parseInt(bookingResponse.order_duration) || 0);
      }
    } catch (error) {
      console.error("Error fetching booking:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddonSelection = (addonId) => {
    // Check if the add-on is already selected
    if (userSelectedAddon.includes(addonId)) {
      // If selected, remove it
      setUserSelectedAddon(userSelectedAddon.filter((id) => id !== addonId));
    } else {
      // If not selected, add it
      setUserSelectedAddon([...userSelectedAddon, addonId]);
    }
  };

  const closeEditServiceModal = () => {
    setShowEditServiceModal(false);
  };
  const openCancelRecurrencePopup = () => {
    setShowCancelRecurrence(true);
    setShowAppointmentModal(false);
  };
  const closeCancelRecurrencePopup = () => {
    setShowCancelRecurrence(false);
    setShowAppointmentModal(false);
  };
  const openAppointmentModal = (appointment) => {
    // console.log(appointment);
    setSelectedAppointment(appointment);
    setShowAppointmentModal(true);
    setShowRescheduleModal(false); // Ensure Reschedule modal is closed when Appointment modal is opened
  };
  const openRescheduleModal = () => {
    setShowAppointmentModal(false); // Close My Appointment modal
    setShowRescheduleModal(true);
    if (selectedAppointment && selectedAppointment.amount) {
      setAmount(selectedAppointment.amount);
    }
  };
  const closeModal = () => {
    setShowAppointmentModal(false);
    setShowRescheduleModal(false);
    setShowEditServiceModal(false);
  };
  const handleClick = () => {
    navigate("admin");
  };
  const handleShowBookingSummary = () => {
    setShowBookingSummary(true);
  };

  const handleSubmit = async () => {
    setLoading(true);
    const hasAtLeastOneUnit = bookingBill.some(item => item.method_id);
    if (!hasAtLeastOneUnit) {
      alert("You must select at least one unit.");
      setLoading(false);
      return;
    }

    const formattedBookingBill = bookingBill.map(item => ({
      type: item.type || "method_units",
      service_id: selectedService,
      method_id: item.method_id,
      units_id: item.units_id,
      s_m_qty: item.s_m_qty,
      s_m_rate: item.s_m_rate,
    }));

    const frequencyMapIds = { Once: 1, Weekly: 2, "Bi-Weekly": 3, Monthly: 4 };
    const frequent_discount1 = allsetdata?.discount_typename || selectedFrequency;
    setDisType(allsetdata?.discount_typename)
    const discountID = frequencyMapIds[frequent_discount1] || null;

    const formattedData = {
      action: "edit_booking_info",
      api_key: "1",
      order_id: order_id_appointment,
      amount: subtotale.toFixed(2),
      taxes: tax.toFixed(2),
      discount: Disamount.toFixed(2),
      net_amount: finelamount.toFixed(2),
      frequent_discount: discountID,
      frequent_discount_amount: "0.00",
      ct_cart: { method: formattedBookingBill },
      time_duration: totalTime.toString(),
    };

    try {
      const response = await axios.post(`${BaseUrl}/backend/api/book_appointment.php`, formattedData);
      if (response.data.status === "true") {
        setSuccessMessage("Appointment Updated Successfully!");
        const updatedBookingData = await getbooking(order_id_appointment);
        if (updatedBookingData) {
          setallsetdata(updatedBookingData);
          setAppointments(prev => prev.map(appointment =>
            appointment.order_id === order_id_appointment ? { ...appointment, ...updatedBookingData } : appointment
          ));
        }
        setShowEditServiceModal(false);
      }
    } catch (error) {
      console.error("Error updating booking:", error);
      alert("An error occurred while updating the booking.");
    } finally {
      setLoading(false);
    }
  };
  const handleQuantityChange = (idx, increment, addon_name, addon_price, max_quantity) => {
    const newQuantities = [...quantities];
    if (increment) {
      if (newQuantities[idx] >= max_quantity) {
        alert(`Maximum quantity of ${max_quantity} reached for ${addon_name}`);
        return;
      }
      newQuantities[idx] += 1;
    } else {
      newQuantities[idx] = Math.max(0, newQuantities[idx] - 1);
    }
    setQuantities(newQuantities);
  
    const quantity = newQuantities[idx];
    const totalPrice = quantity * addon_price;
  
    setBookingBill((prevBill) => {
      const addon = services
        .find((s) => s.service_id === selectedService)
        ?.addons[idx];
      const addonId = addon?.addon_id;
      const existingItemIndex = prevBill.findIndex(
        (item) => item.type === "addon" && item.units_id === addonId
      );
      let updatedBill = [...prevBill];
  
      if (existingItemIndex !== -1) {
        if (quantity > 0) {
          updatedBill[existingItemIndex] = {
            ...updatedBill[existingItemIndex],
            s_m_qty: quantity,
            s_m_rate: totalPrice,
          };
        } else {
          updatedBill.splice(existingItemIndex, 1);
        }
      } else if (quantity > 0) {
        updatedBill.push({
          type: "addon",
          service_id: selectedService,
          method_id: selectedMethod?.method_id || null,
          units_id: addonId,
          name: addon_name,
          s_m_qty: quantity,
          s_m_rate: totalPrice,
        });
      }
  
      calculateDiscountedTotal(updatedBill);
      return updatedBill;
    });
  };

  const handleClosebookingSummary = () => {
    setShowBookingSummary(false);
    setShowBookingSummary2(false);
    setShowEditServiceModal(false);

    // Reset states to clear stale data
    setBookingBill([]);
    setTotalTime(0);
    setSelectedService(null);
    setSelectedMethod(null);
    setUserSelectedMethods([]);
    setUserSelectedMethodsId([]);
    setUserSelectedMethodsUnitsId([]);
    setUserSelectedMethodsSmqty([]);
    setUserSelectedAddon([]);
    setQuantities([0, 0, 0]);
    setallsetdata(null);
  };
  const handleExcelExport = () => {
    const columns = ["Order", "Service Name", "Order Date", "Order Time"];
    const rows = appointments.map((row) => [
      row.order_id, // Dynamic order_id
      row.title,
      row.appointment_date, // Dynamic appointment_date
      row.appointment_time, // Dynamic appointment_time
    ]);
    const ws = XLSX.utils.aoa_to_sheet([columns, ...rows]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "appointments");
    XLSX.writeFile(wb, "appointments.xlsx");
  };
  const handlePdfExport = () => {
    const doc = new jsPDF();
    const columns = ["Order", "Service Name", "Order Date", "Order Time"];
    const rows = appointments.map((row) => [
      row.order_id, // Dynamic order_id
      row.title,
      row.appointment_date, // Dynamic appointment_date
      row.appointment_time, // Dynamic appointment_time
    ]);
    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 20,
      theme: "grid",
      margin: { horizontal: 10 },
      headStyles: { fillColor: [0, 123, 255], textColor: 255 },
    });
    doc.save("appointments.pdf");
  };

  const handleCancelRecurrence = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/accept.appointment.php`,
        {
          action: "add_rec",
          api_key: "1",
          order_id: selectedAppointment.order_id,
          rec_id: selectedAppointment.recurring_id,
          status: "P",
        }
      );

      if (response.data.response) {
        setSuccessMessage("Add Recurring Successfully!");
      } else {
        console.error("Error adding recurring:", response.data);
      }
    } catch (error) {
      console.error("Error during API call:", error);
    } finally {
      setLoading(false); // Ensure loading stops in all cases
      closeCancelRecurrencePopup(); // Ensure popup is closed
    }
  };

  useEffect(() => {
    const userId = sessionStorage.getItem("userId"); // Retrieve user ID from sessionStorage
    if (userId) {
      fetchAppointments(userId); // Fetch appointments first
      fetchUserDetails(userId); // Fetch user details after
    } else {
      // console.log("No user ID found, handle accordingly");
      setLoading(false); // Stop loading spinner if no user ID
    }
  }, []);
   const fetchAppointments = async (userId) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/user_appointment_list.php`,
        {
          action: "get_user_appointments_list",
          api_key: "1",
          user_type: "client",
          user_id: userId,
        }
      );
      if (response.data.status === "true") {
        console.log("Appointments Data:", response.data.response); // Debug here
        setAppointments(response.data.response);
        const userAppointment = response.data.response[0];
        if (userAppointment) {
          const selectedService = userAppointment.service_id;
          setSelectedService(selectedService);
          setAmount(userAppointment.amount || "");
        }
      }
    } catch (error) {
      console.error("Error fetching appointments:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchUserDetails = async (userId) => {
    setLoading(true);
    // console.log("Fetching user details for userId:", userId); // Log userId to verify it's passed correctly
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/customer_list.php`,
        {
          action: "all_customer_list", // Action key to get all customer details
          api_key: "1", // API key
        }
      );
      // console.log("API response for user details:", response.data); // Log the response to see what's returned
      const user = response.data.response.find((user) => user.id === userId);
      if (user) {
        setUserDetails(user); // Set the user details if found
      } else {
        console.error("User not found in the response");
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const userId = sessionStorage.getItem("userId"); // Retrieve user ID from localStorage
    // console.log("Retrieved userId from localStorage: ", userId);
    if (userId) {
      fetchAppointments(userId); // Fetch appointments
      fetchServices(); // Fetch services
    } else {
      // console.log("No user ID found, handle accordingly");
      setLoading(false); // Stop loading spinner if no user ID
    }
  }, [showEditServiceModal]); // Dependency on modal open state
  const fetchServices = async () => {
    // console.log("Fetching services...");
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/services.php`,
        { action: "all_services", api_key: "1" },
        { headers: { "Content-Type": "application/json" } }
      );
      // console.log("API response for services:", response.data);
      if (response.data.status === "true") {
        setServices(response.data.response);
      } else {
        console.error("Error fetching services:", response.data);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleRatingChange = (value, isHalf = false) => {
    const rating = isHalf ? value - 0.5 : value;
    setRating(rating);
    console.log(rating)
  };
  const renderStars = (value) => {
    const stars = [];
    const fullStars = Math.floor(value);
    const hasHalfStar = value % 1 !== 0;

    // Full stars
    for (let i = 1; i <= 5; i++) {
      if (i <= fullStars) {
        stars.push(
          <FaStar key={`star-${i}`} className="text-yellow-500 text-3xl" />
        );
      } else if (i === fullStars + 1 && hasHalfStar) {
        stars.push(
          <FaStarHalfAlt
            key={`star-${i}`}
            className="text-yellow-500 text-3xl"
          />
        );
      } else {
        stars.push(
          <FaRegStar key={`star-${i}`} className="text-gray-300 text-3xl" />
        );
      }
    }
    return stars;
  };

  console.log(selectedAppointment?.order_id)

  const filteredRatings = ratings?.filter(
    (ratingItem) => String(ratingItem?.order_id) === String(selectedAppointment?.order_id)
  );
  
  console.log(filteredRatings)


  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
        <div className="container mx-auto p-6">
                  {successMessage && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
              <span className="block sm:inline">{successMessage}</span>
            </div>
          )}

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
              <span className="block sm:inline">{error}</span>
            </div>
          )}

          <h1 className="text-2xl font-semibold mb-6">My Appointment</h1>
          <div className="flex flex-col sm:flex-row justify-between items-center mb-4 space-y-4 sm:space-y-0">
            <div className="flex flex-col sm:flex-row sm:items-center w-full space-y-4 sm:space-y-0 sm:space-x-6">
              {/* Search Bar */}
              <div className="relative w-full sm:w-80 md:w-96">
                <input
                  type="text"
                  placeholder="Search Staff..."
                  value={searchQuery}
                  onChange={handleSearch}
                  className="p-3 w-full rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 pl-10"
                />
                <CiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
              </div>

              {/* Buttons (Excel & PDF) */}
              <div className="flex flex-wrap justify-center sm:justify-start space-x-2 sm:ml-4">
                <button
                  onClick={handleExcelExport}
                  className="bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold text-sm sm:text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-blue-600 hover:to-blue-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
                >
                  <FaFileExcel className="text-2xl" />
                  Excel
                </button>
                <button
                  onClick={handlePdfExport}
                  className="bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold text-sm sm:text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-red-600 hover:to-red-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
                >
                  <FaFilePdf className="text-2xl" /> PDF
                </button>
              </div>
            </div>

            {/* Entries Per Page */}
            <div className="flex items-center space-x-2">
              <span>Show</span>
              <select
                value={entriesPerPage}
                onChange={handleEntriesChange}
                className="p-2 border border-gray-300 rounded-md"
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value="All">All</option>
              </select>
              <span>entries</span>
            </div>
          </div>

          {/* // Mobile View (Cards) */}
          <div className="block sm:hidden">
            {paginatedData.map((row, index) => {
              const orderDate = new Date(row.appointment_date);
              const orderDateFormatted = orderDate.toLocaleDateString();
              const orderTimeFormatted = orderDate.toLocaleTimeString();
              const isComplete = row.booking_status === "CO";
              const currentDate = new Date();
              const daysDifference = calculateDaysDifference(row.booking_date_time);
              const isWithin15Days = daysDifference >= 0 && daysDifference <= 15;
              const isPastBooking = new Date(row.booking_date_time) < new Date();

              return (
                <div
                  key={index}
                  className="bg-white rounded-lg shadow-md p-4 mb-4 border border-gray-100 hover:shadow-lg transition-shadow duration-200"
                >
                  <div className="mb-3 pb-2 border-b border-gray-100">
                    <h2 className="text-lg font-semibold text-gray-800">
                      Order ID: {row.order_id}
                    </h2>
                    <div className="text-sm text-gray-600 mt-1 flex flex-col gap-1">
                      <p>Date: {orderDateFormatted}</p>
                      <p>Time: {orderTimeFormatted}</p>
                    </div><div className="text-sm text-gray-600 mt-1 flex flex-col gap-1">
                      Service Title :{row.title}
                      </div>
                  </div>

                  <div className="flex flex-wrap gap-2 mb-2">
                    <button
                      className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-blue-600 bg-blue-50 hover:bg-blue-100 transition-colors duration-200"
                      onClick={() => openAppointmentModal(row)}
                    >
                      <FaEye className="text-blue-500" />
                      <span>View Details</span>
                    </button>

                    {!isPastBooking && !isWithin15Days && (
                      <button
                        onClick={() => openEditServiceModal(row)}
                        className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-amber-600 bg-amber-50 hover:bg-amber-100 transition-colors duration-200"
                      >
                        <FaEdit className="text-amber-500" />
                        <span>Edit Booking</span>
                      </button>
                    )}
                  </div>

                  <div className="flex flex-wrap gap-2">
                    {row.recurrence_status === "Y" && (
                      <button
                        onClick={openCancelRecurrencePopup}
                        className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-red-600 bg-red-50 hover:bg-red-100 transition-colors duration-200"
                      >
                        <FaTimes className="text-red-500" />
                        <span>Cancel Recurrence</span>
                      </button>
                    )}

                    <button
                      onClick={async () => {
                        const userId = sessionStorage.getItem("userId");

                        if (!userId) {
                          console.error("❌ User ID not found in localStorage");
                          return;
                        }

                        if (!row?.order_id) {
                          console.error("❌ Order ID missing in row data");
                          return;
                        }

                        try {
                          // 🛠️ Fetch booking data
                          const bookingData = await getbooking(row.order_id);

                          console.log("📢 bookingData received:", bookingData);

                          if (!bookingData) {
                            console.error(
                              "❌ Booking data is null or undefined"
                            );
                            return;
                          }

                          // 🛠️ Call generateInvoice with the correct data
                          generateInvoice(userId, bookingData);
                        } catch (error) {
                          console.error(
                            "🚨 Error fetching booking data:",
                            error
                          );
                        }
                      }}
                      className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-green-600 bg-green-50 hover:bg-green-100 transition-colors duration-200"
                    >
                      <FaDownload className="text-green-500" />
                      Generate Invoice
                    </button>

                    {isComplete && (
                      <button
                        onClick={() => openRatingMenuaaa(row)}
                        className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-purple-600 bg-purple-50 hover:bg-purple-100 transition-colors duration-200"
                      >
                        <FaStar className="text-purple-500" />
                        <span>Rate Service</span>
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* // Tablet & Laptop View (Table) */}
          <div className="hidden sm:block">
            <div className="overflow-x-auto rounded-lg shadow">
              <table className="min-w-full bg-white">
                <thead>
                  <tr className="bg-gray-50 border-b border-gray-200">
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                      Order ID
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                      Date
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                      Time
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                      Service Title
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                      Booking Details
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {paginatedData.map((row, index) => {
                    const daysDifference = calculateDaysDifference(row.booking_date_time);
                    const isWithin15Days = daysDifference >= 0 && daysDifference <= 15;
                    const isPastBooking = new Date(row.booking_date_time) < new Date();
                    const orderDate = new Date(row.appointment_date);
                    const orderDateFormatted = orderDate.toLocaleDateString();
                    const orderTimeFormatted = row.appointment_time;
                    const isComplete = row.booking_status === "CO";
                    const currentDate = new Date();
                    // const isPastBooking = orderDate < currentDate;

                    return (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-4 py-3 text-sm text-gray-900 font-medium">
                          {row.order_id}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">
                          {orderDateFormatted}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">
                          {orderTimeFormatted}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">
                          {row?.title}
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex flex-wrap gap-2">
                            <button
                              className="flex items-center gap-1 px-2 py-1 text-xs rounded text-blue-600 bg-blue-50 hover:bg-blue-100 transition-colors duration-200"
                              onClick={() => openAppointmentModal(row)}
                            >
                              <FaEye className="text-blue-500 " />
                              <span className="text-sm">View Details</span>
                            </button>

                            {!isPastBooking && !isWithin15Days &&(
                              <button
                                onClick={() => {
                                  // seteditdataid(row.order_id)
                                  getbooking(row.order_id);
                                  openEditServiceModal(row);
                                }}
                                className="flex items-center gap-1 px-2 py-1 text-xs rounded text-amber-600 bg-amber-50 hover:bg-amber-100 transition-colors duration-200"
                              >
                                <FaEdit className="text-amber-500" />
                                <span className="text-sm">Edit Service</span>
                              </button>
                            )}
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex flex-wrap gap-2">
                            {row.recurrence_status === "Y" && (
                              <button
                                onClick={openCancelRecurrencePopup}
                                className="flex items-center gap-1 px-2 py-1 text-xs rounded text-red-600 bg-red-50 hover:bg-red-100 transition-colors duration-200"
                              >
                                <FaTimes className="text-red-500" />
                                <span>Cancel</span>
                              </button>
                            )}

                            <button
                              onClick={async () => {
                                const userId = sessionStorage.getItem("userId");

                                if (!userId) {
                                  console.error(
                                    "❌ User ID not found in localStorage"
                                  );
                                  return;
                                }

                                if (!row?.order_id) {
                                  console.error(
                                    "❌ Order ID missing in row data"
                                  );
                                  return;
                                }

                                try {
                                  // 🛠️ Fetch booking data
                                  const bookingData = await getbooking(
                                    row.order_id
                                  );

                                  console.log(
                                    "📢 bookingData received:",
                                    bookingData
                                  );

                                  if (!bookingData) {
                                    console.error(
                                      "❌ Booking data is null or undefined"
                                    );
                                    return;
                                  }

                                  // 🛠️ Call generateInvoice with the correct data
                                  generateInvoice(userId, bookingData);
                                } catch (error) {
                                  console.error(
                                    "🚨 Error fetching booking data:",
                                    error
                                  );
                                }
                              }}
                              className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-green-600 bg-green-50 hover:bg-green-100 transition-colors duration-200"
                            >
                              <FaDownload className="text-green-500" />
                              Generate Invoice
                            </button>

                            {isComplete && (
                              <button
                                onClick={() => openRatingMenuaaa(row)}
                                className="flex items-center gap-1 px-2 py-1 text-xs rounded text-purple-600 bg-purple-50 hover:bg-purple-100 transition-colors duration-200"
                              >
                                <FaStar className="text-purple-500" />
                                <span className="text-sm">Rate</span>
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {isRatingModalOpen && selectedAppointment && (
              <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
                <div className="bg-white p-6 rounded-lg sm:w-[500px] md:w-[600px] lg:w-[700px]">
                  {filteredRatings.length > 0 ? (
                    <div className="mt-4">
                      <h3 className="text-lg font-semibold">Ratings:</h3>
                      <ul>
                        {filteredRatings.map((ratingItem) => (
                          <li key={ratingItem.id} className="border-b border-gray-200 py-2">
                            <div className="flex items-center">
                              <div className="flex">
                                {renderStars(ratingItem.rating)}
                              </div>
                              <div className="ml-2">{ratingItem.review}</div>
                            </div>
                          </li>
                        ))}
                      </ul>
                      <button
                        onClick={handleCancelRating}
                        className="px-4 py-2 mt-4 bg-gray-500 text-white rounded-md"
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <>
                      <div className="flex items-center mt-4">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <div key={star} className="relative">
                        {/* Full star button */}
                        <button
                          onClick={() => handleRatingChange(star)}
                          onMouseEnter={() => setHoveredRating(star)}
                          onMouseLeave={() => setHoveredRating(null)}
                          className="focus:outline-none relative z-10"
                        >
                          {renderStars(hoveredRating || rating)[star - 1]}
                        </button>

                        {/* Half star button - overlay on left half */}
                        <button
                          onClick={() => handleRatingChange(star, true)}
                          onMouseEnter={() => setHoveredRating(star - 0.5)}
                          onMouseLeave={() => setHoveredRating(null)}
                          className="absolute left-0 top-0 w-1/2 h-full focus:outline-none z-20"
                        />
                      </div>
                    ))}

                    {/* Rating display */}
                    <div className="ml-4 p-2 border border-gray-300 rounded-md text-lg font-semibold text-gray-700">
                      {hoveredRating ? hoveredRating.toFixed(1) : rating.toFixed(1)}
                    </div>
                  </div>

                  <div className="mt-4">
                    <textarea
                      value={review}
                      onChange={handleReviewChange}
                      rows="4"
                      placeholder="Write your review..."
                      className="w-full p-2 border border-gray-300 rounded-md mt-2"
                    />
                  </div>
                    <div className="flex justify-end mt-4 space-x-4">
                      <button
                        onClick={handleCancelRating}
                        className="px-4 py-2 bg-gray-500 text-white rounded-md"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleSaveRating}
                        className="px-4 py-2 bg-blue-500 text-white rounded-md"
                      >
                        Save
                      </button>
                    </div>
                    </>
                  )}
                </div>
              </div>
            )}

          <div className="flex justify-end items-center space-x-4 p-2">
            <button
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className="px-4 py-2 bg-blue-500 text-white rounded-md"
            >
              Previous
            </button>
            <span>{`Page ${currentPage} of ${totalPages}`}</span>
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="px-4 py-2 bg-blue-500 text-white rounded-md"
            >
              Next
            </button>
          </div>
          {showAppointmentModal && (  
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50 p-4">
              <div
                className="bg-white p-6 rounded-lg w-full max-w-xs sm:max-w-md md:max-w-lg lg:max-w-2xl xl:max-w-4xl max-h-[90vh] overflow-y-auto"
                style={{ zIndex: showRescheduleModal ? 49 : 50 }}
              >
                {(() => {
        const daysDifference = calculateDaysDifference(selectedAppointment.booking_date_time);
        const isWithin15Days = daysDifference >= 0 && daysDifference <= 15;
        const isPastBooking = new Date(selectedAppointment.booking_date_time) < new Date();

        return (
          <>
            {/* Header */}
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-semibold">Appointment Details</h2>
              <button onClick={closeModal} className="text-red-500">
                <FaTimesCircle />
              </button>
            </div>
              

                {/* Mobile View (Cards) */}
                <div className="block sm:hidden">
                  <div className="flex flex-col space-y-3 mt-4">
                    <div>
                      <strong>Order:</strong> {selectedAppointment.order_id}
                    </div>
                    <div>
                      <strong>Service:</strong> {selectedAppointment.title}
                    </div>
                    <div>
                      <strong>Booking Date & Time:</strong>{" "}
                      {new Date(
                        selectedAppointment?.booking_date_time
                      ).toLocaleString()}
                    </div>
                    <div>
                      <strong>More Details:</strong>
                      <div className="space-y-1">
                        <div>
                          <strong>Method:</strong>{" "}
                          {selectedAppointment.method_name}
                        </div>
                        <div>
                          <strong>Units:</strong> {selectedAppointment.units}
                        </div>
                        <div>
                          <strong>Add-ons:</strong> {selectedAppointment.addons}
                        </div>
                      </div>
                    </div>
                    <div>
                      <strong>Status:</strong>{" "}
                      {selectedAppointment.booking_status === "A"
                        ? "Active"
                        : selectedAppointment.booking_status === "RS"
                        ? "Rescheduled"
                        : selectedAppointment.booking_status === "C"
                        ? "Confirm"
                        : selectedAppointment.booking_status === "CO"
                        ? "Completed"
                        : selectedAppointment.booking_status === "CS"
                        ? "Rejected By Provider"
                        : selectedAppointment.booking_status === "R"
                        ? `Rejected: ${
                            selectedAppointment.reject_reason ||
                            "No reason provided"
                          }`
                        : ""}
                    </div>
                    <div className="flex space-x-2">
                    {selectedAppointment.booking_status === "A" && !isPastBooking && !isWithin15Days && (
                          <>
                            <button
                              onClick={openRescheduleModal}
                              className="text-yellow-500 flex items-center gap-2 p-2 border rounded-md hover:bg-yellow-100"
                            >
                              <FaEdit />
                              Reschedule
                            </button>
                            <button
                              onClick={handleCancel}
                              className="text-red-500 flex items-center gap-2 p-2 border rounded-md hover:bg-red-100"
                            >
                              <FaTimesCircle />
                              Cancel
                            </button>
                          </>
                        )}
                      {selectedAppointment.booking_status === "CO" && (
                        <button className="text-green-500 flex items-center gap-2 p-2 border rounded-md hover:bg-green-100">
                          <FaCheck /> Completed
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Tablet & Laptop View (Table) */}
                <div className="hidden sm:block mt-4">
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="p-3 border text-left">Order</th>
                          <th className="p-3 border text-left">Service</th>
                          <th className="p-3 border text-left">
                            Booking Date & Time
                          </th>
                          <th className="p-3 border text-left">More Details</th>
                          <th className="p-3 border text-left">Status</th>
                          <th className="p-3 border text-left">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="p-3 border">
                            {selectedAppointment.order_id}
                          </td>
                          <td className="p-3 border">
                            {selectedAppointment.title}
                          </td>
                          <td className="p-3 border">
                            {new Date(
                              selectedAppointment?.booking_date_time
                            ).toLocaleString()}
                          </td>
                          <td className="p-3 border">
                            <div className="space-y-1">
                              <div>
                                <strong>Method:</strong>{" "}
                                {selectedAppointment.method_name}
                              </div>
                              <div>
                                <strong>Units:</strong>{" "}
                                {selectedAppointment.units}
                              </div>
                              <div>
                                <strong>Add-ons:</strong>{" "}
                                {selectedAppointment.addons}
                              </div>
                            </div>
                          </td>
                          <td className="p-3 border">
                            {selectedAppointment.booking_status === "A"
                              ? "Active"
                              : selectedAppointment.booking_status === "RS"
                              ? "Rescheduled"
                              : selectedAppointment.booking_status === "C"
                              ? "Confirm"
                              : selectedAppointment.booking_status === "CO"
                              ? "Completed"
                              : selectedAppointment.booking_status === "CS"
                              ? "Rejected By Provider"
                              : selectedAppointment.booking_status === "R"
                              ? `Rejected: ${
                                  selectedAppointment.reject_reason ||
                                  "No reason provided"
                                }`
                              : ""}
                          </td>
                          <td className="p-3 border">
                            <div className="flex space-x-2">
                            {selectedAppointment.booking_status === "A" && !isPastBooking && !isWithin15Days && (
                                  <>
                                    <button
                                      onClick={openRescheduleModal}
                                      className="text-yellow-500 flex items-center gap-2 p-2 border rounded-md hover:bg-yellow-100"
                                    >
                                      <FaEdit />
                                      Reschedule
                                    </button>
                                    <button
                                      onClick={handleCancel}
                                      className="text-red-500 flex items-center gap-2 p-2 border rounded-md hover:bg-red-100"
                                    >
                                      <FaTimesCircle />
                                      Cancel
                                    </button>
                                  </>
                                )}
                              {selectedAppointment.booking_status === "CO" && (
                                <button className="text-green-500 flex items-center gap-2 p-2 border rounded-md hover:bg-green-100">
                                  <FaCheck /> Completed
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                </>
              );
            })()}
              </div>
            </div>
          )}

          {showCancelModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-60">
              <div className="bg-white p-6 rounded-lg sm:w-96 md:w-[400px] lg:w-[500px]">
                <div className="flex justify-between items-center">
                  <h2 className="text-xl font-semibold">Cancel Appointment</h2>
                  <button
                    onClick={() => setShowCancelModal(false)}
                    className="text-red-500"
                  >
                    <FaTimesCircle />
                  </button>
                </div>
                <div className="mt-4">
                  <label className="block">Cancellation Reason</label>
                  <textarea
                    className="w-full p-2 border border-gray-300 rounded-md mb-4"
                    placeholder="Enter cancellation reason..."
                    value={cancelReason}
                    onChange={(e) => setCancelReason(e.target.value)}
                  />
                  <div className="flex justify-end">
                    <button
                      onClick={() => {
                        handleSaveCancel();
                      }}
                      className="bg-green-500 text-white py-2 px-4 rounded-md mr-2"
                    >
                      Save
                    </button>
                    <button
                      onClick={() => setShowCancelModal(false)}
                      className="bg-gray-300 text-black py-2 px-4 rounded-md"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showEditServiceModal && (
            <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl h-auto max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white z-10 px-6 py-4 border-b flex justify-between items-center">
                  <h2 className="text-xl font-semibold text-gray-800">
                    Edit Booking
                  </h2>
                  <button
                    onClick={handleClosebookingSummary}
                    className="text-gray-500 hover:text-gray-700 transition-colors p-2 rounded-full hover:bg-gray-100"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 p-6">
                  {/* Left Column - Booking Form */}
                  <div className="lg:col-span-2">
                    <form onSubmit={handleSubmit} className="space-y-6">
                      {/* Service Selection Panel */}
                      <div className="bg-white rounded-lg shadow-md border border-gray-100">
                        <div
                          className="flex justify-between items-center bg-gradient-to-r from-blue-500 to-blue-600 p-4 rounded-t-lg cursor-pointer text-white"
                          onClick={toggleServicePanel}
                        >
                          <h3 className="font-medium">Choose Services</h3>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="6 9 12 15 18 9"></polyline>
                          </svg>
                        </div>

                        <div className="p-4">
                          {/* Services Grid */}
                          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
                            {services?.map((service) => (
                              <div
                                key={service.service_id}
                                onClick={() => {
                                  if (service.service_id) {
                                    setSelectedService(service.service_id);
                                  } else {
                                    console.error(
                                      "Service ID is missing",
                                      service
                                    );
                                  }
                                }}
                                className={`cursor-pointer border rounded-lg overflow-hidden shadow-sm transition-all duration-200 hover:shadow-md ${
                                  userSelectedMethods.includes(
                                    service.service_id
                                  )
                                    ? "ring-2 ring-blue-400"
                                    : ""
                                } ${
                                  selectedService === service.service_id
                                    ? "ring-2 ring-blue-500 transform scale-[1.02]"
                                    : ""
                                }`}
                              >
                                <div className="relative">
                                  <img
                                    src={service?.service_image}
                                    className="w-full h-32 object-cover"
                                    // alt={service?.service_title || "Service"}
                                  />
                                  <div className="absolute inset-0 flex items-center justify-center text-white font-medium bg-black bg-opacity-40 text-center p-2">
                                    {service?.service_title}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>

                          {/* Selected Service Details */}
                          {selectedService && (
                            <div className="mt-6 space-y-6">
                              {services
                                .filter((s) => s.service_id === selectedService)
                                ?.map((service) => (
                                  <div key={service.service_id}>
                                    {/* Units Section */}
                                    {service.units &&
                                      service.units.length > 0 && (
                                        <div className="bg-gray-50 p-4 rounded-lg mb-6">
                                          <h3 className="font-medium text-gray-700 mb-4">
                                            Units
                                          </h3>
                                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            {service.units?.map((unit) => (
                                              <div
                                                key={unit.units_id}
                                                className="flex items-center space-x-4"
                                              >
                                                <div className="w-full">
                                                  <div className="flex items-center space-x-2 mb-2">
                                                    <label className="block font-medium text-gray-700">
                                                      {unit.unit_title}
                                                    </label>
                                                    <img
                                                      src={Bed}
                                                      className="w-5 h-5"
                                                      alt="Unit Icon"
                                                    />
                                                  </div>
                                                  <select
                                                    className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 bg-white"
                                                    value={
                                                      bedroom[unit.units_id] ||
                                                      unit.unit_min
                                                    }
                                                    onChange={(e) =>
                                                      handleBedroomChange(
                                                        unit.units_id,
                                                        parseInt(e.target.value)
                                                      )
                                                    }
                                                  >
                                                    {Array.from(
                                                      {
                                                        length:
                                                          unit.unit_max -
                                                          unit.unit_min +
                                                          1,
                                                      },
                                                      (_, i) => (
                                                        <option
                                                          key={
                                                            i + unit.unit_min
                                                          }
                                                          value={
                                                            i + unit.unit_min
                                                          }
                                                        >
                                                          {i}
                                                        </option>
                                                      )
                                                    )}
                                                  </select>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      )}

                                    {/* Methods Section */}
                                    {service.methods &&
                                      service.methods.length > 0 && (
                                        <div className="space-y-6">
                                          <div>
                                            <h3 className="font-medium text-gray-700 mb-3">
                                              Methods
                                            </h3>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                              {service.methods?.map(
                                                (method) => (
                                                  <button
                                                    type="button"
                                                    key={method.method_id}
                                                    onClick={() => {
                                                      handleMethodSelection(
                                                        method,
                                                        method.method_id
                                                      );
                                                    }}
                                                    className={`p-3 border rounded-lg text-center transition-all duration-200 ${
                                                      (selectedMethod &&
                                                        selectedMethod.method_id ===
                                                          method.method_id) ||
                                                      userSelectedMethodsId.includes(
                                                        method.method_id
                                                      )
                                                        ? "bg-blue-500 text-white border-blue-500 shadow-md"
                                                        : "bg-white hover:bg-blue-50 border-gray-200"
                                                    }`}
                                                  >
                                                    {method?.method_title}
                                                  </button>
                                                )
                                              )}
                                            </div>
                                          </div>
                                         {selectedMethod && (
                                          <div className="mt-6">
                                            {selectedMethod.submethods && selectedMethod.submethods.length > 0 ? (
                                              <div className="space-y-4">
                                                <h3 className="font-medium text-gray-700">Options</h3>
                                                {selectedMethod.submethods.map((submethod) => {
                                                  const bookedItem = bookingBill.find(
                                                    (item) => item.units_id === submethod.unit_id && item.type === "method_units"
                                                  );
                                                  return (
                                                    <div
                                                      key={submethod.unit_id}
                                                      className={`${
                                                        userSelectedMethodsUnitsId.includes(submethod.unit_id)
                                                          ? "border-blue-200 bg-blue-50"
                                                          : "border-gray-200"
                                                      } p-4 border rounded-lg shadow-sm transition-all duration-300`}
                                                    >
                                                      <h4 className="font-medium text-gray-700 mb-3">
                                                        {submethod.unit_title} (₹{submethod.unit_price})
                                                      </h4>
                                                      <div className="mb-4">
                                                        <label className="block font-medium mb-2">Select Quantity</label>
                                                        <select
                                                          className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                          value={bookedItem?.s_m_qty || ""}
                                                          onChange={(e) => {
                                                            const quantity = parseInt(e.target.value, 10) || 0;
                                                            addItemToBill(
                                                              submethod.unit_id,
                                                              submethod.unit_title,
                                                              quantity,
                                                              submethod.unit_price
                                                            );
                                                          }}
                                                        >
                                                          <option value="">Select Quantity</option>
                                                          {[...Array(submethod.unit_max - submethod.unit_min + 1).keys()].map(
                                                            (qty) => {
                                                              const quantity = qty + 1;
                                                              return (
                                                                <option key={quantity} value={quantity}>
                                                                  {quantity}
                                                                </option>
                                                              );
                                                            }
                                                          )}
                                                        </select>
                                                      </div>
                                                    </div>
                                                  );
                                                })}
                                              </div>
                                            ) : (
                                              <p className="text-gray-500 italic">No options available for this method.</p>
                                            )}
                                          </div>
                                        )}
                                        </div>
                                      )}
                                      {selectedMethod && service.addons?.length > 0 && (
                                        <div className="mt-8">
                                          <h3 className="font-medium text-gray-700 mb-4">Add-ons</h3>
                                          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                            {service.addons.map((addon, index) => (
                                              <div
                                                key={addon.addon_id}
                                                className={`border rounded-lg overflow-hidden shadow-sm transition-all duration-200 ${
                                                  userSelectedAddon.includes(addon.addon_id)
                                                    ? "border-blue-300 bg-blue-50"
                                                    : "border-gray-200 bg-white hover:border-blue-200"
                                                }`}
                                                onClick={() => handleAddonSelection(addon.addon_id)}
                                              >
                                                <div className="p-4">
                                                  <div className="text-center mb-3">
                                                    <p className="font-medium text-gray-800">{addon.addon_name}</p>
                                                  </div>
                                                  <div className="text-center mb-4">
                                                  <p className="text-lg mb-2">Price: ₹{addon.addon_price}</p>
                                                             {quantities[index] >= addon.addon_maxqty && (
                                                             <p className="text-xs text-red-500 mb-3">
                                                                 {addon.addon_name} are Max {addon.addon_maxqty} reached
                                                                </p>
                                                             )}  
                                                  </div>
                                                  <div className="flex items-center justify-center gap-3">
                                                    <button
                                                      type="button"
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleQuantityChange(
                                                          index,
                                                          false,
                                                          addon.addon_name,
                                                          addon.addon_price,
                                                          addon.addon_maxqty
                                                        );
                                                      }}
                                                      className="p-1 w-8 h-8 flex items-center justify-center bg-red-100 text-red-600 rounded-full hover:bg-red-200 transition-colors"
                                                    >
                                                      -
                                                    </button>
                                                    <span className="text-lg font-medium w-8 text-center">
                                                      {quantities[index]}
                                                    </span>
                                                    <button
                                                      type="button"
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleQuantityChange(
                                                          index,
                                                          true,
                                                          addon.addon_name,
                                                          addon.addon_price,
                                                          addon.addon_maxqty
                                                        );
                                                      }}
                                                      className="p-1 w-8 h-8 flex items-center justify-center bg-green-100 text-green-600 rounded-full hover:bg-green-200 transition-colors"
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      )}
                                                                
                                    {selectedAppointment && (
                                    <div className="mt-8">
                                      <h3 className="font-medium text-gray-700 mb-4">Select Provider</h3>
                                      <div className="flex flex-wrap gap-4">
                                        {selectedAppointment.staff_names ? (
                                          selectedAppointment.staff_names.split(",").map((name, index) => (
                                            <div key={index} className="text-center">
                                              <div className="w-20 h-20 bg-blue-500 text-white rounded-full flex items-center justify-center text-xl font-semibold">
                                                Provider
                                              </div>
                                              <p className="mt-2 text-gray-700">{name.trim() || "N/A"}</p>
                                            </div>
                                          ))
                                        ) : (
                                          <p className="text-gray-500 italic">No staff assigned.</p>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  </div>
                                ))}
                            </div>
                          )}

                          {/* Frequency Selection */}
                        </div>
                      </div>

                      {/* Submit Button */}
                      <div className="flex justify-center">
                        <button
                          type="submit"
                          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition duration-200 shadow-md hover:shadow-lg"
                        >
                          Submit Booking
                        </button>
                      </div>
                    </form>
                  </div>

                  {/* Right Column - Booking Summary */}
                  <div className="lg:col-span-1">
                    <div className="bg-white border rounded-lg shadow-lg p-6 sticky top-24">
                      <h2 className="text-lg font-bold text-gray-800 border-b pb-3 mb-4">
                        Booking Summary
                      </h2>

                      {/* Date and Time */}
                      <div className="space-y-4 mb-6">
                        <div className="flex items-center text-sm text-gray-600">
                          <div className="flex items-center space-x-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <rect
                                x="3"
                                y="4"
                                width="18"
                                height="18"
                                rx="2"
                                ry="2"
                              ></rect>
                              <line x1="16" y1="2" x2="16" y2="6"></line>
                              <line x1="8" y1="2" x2="8" y2="6"></line>
                              <line x1="3" y1="10" x2="21" y2="10"></line>
                            </svg>
                            <span className="font-medium text-gray-700">
                              Date & Time:
                            </span>
                            <div>
                              {selectedDate && selectedTime ? (
                                <p>
                                  {selectedDate} @ {selectedTime}
                                </p>
                              ) : allsetdata?.booking_date_time ? (
                                <p>{allsetdata?.booking_date_time}</p>
                              ) : (
                                <p className="text-gray-400 italic">
                                  Not selected
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Frequency */}
                        <div className="flex items-center text-sm text-gray-600">
                          <div className="flex items-center space-x-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                            </svg>
                            <span className="font-medium text-gray-700">
                              Frequency:
                            </span>
                            <p>
                              {allsetdata?.discount_typename
                                ? allsetdata?.discount_typename
                                : selectedFrequency}
                            </p>
                          </div>
                        </div>

                        {/* Duration */}
                        <div className="flex items-center text-sm text-gray-600">
                          <div className="flex items-center space-x-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <polyline points="12 6 12 12 16 14"></polyline>
                            </svg>
                            <span className="font-medium text-gray-700">
                              Duration:{" "}
                              {allsetdata?.order_duration
                                ? `${Math.round(
                                    allsetdata?.order_duration / 60
                                  )} Hours`
                                : "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                              <div className="mb-6">
                                <h3 className="font-bold text-gray-800 mb-3">Cart Items:</h3>
                                {bookingBill.length === 0 ? (
                                  <div>
                                    <div className="flex items-center text-sm text-gray-600">
                                      <span className="font-medium text-gray-700">Service:</span>
                                      <p>{allsetdata?.service_id || "N/A"}</p>
                                    </div>
                                    {allsetdata?.cart_items?.map((item, idx) => (
                                      <div key={idx} className="flex items-center text-sm text-gray-600">
                                        <span className="font-medium text-gray-700">
                                          {item.type === "method_units" ? "Method" : "Addon"}:
                                        </span>
                                        <p>{item.method_name || "N/A"} (x{item.s_m_qty}) - ₹{item.s_m_rate}</p>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                              
                              <ul className="space-y-2">
                              {bookingBill.map((item, idx) => (
                                <li
                                  key={idx}
                                  className="flex justify-between items-center py-2 border-b border-gray-100"
                                >
                                  <span className="text-gray-700">{item.name}</span>
                                  <span className="text-gray-700">
                                    <span className="text-gray-500 text-sm">(x{item.s_m_qty})</span>
                                  </span>
                                  <div className="flex gap-4">
                                    <span>₹{item.s_m_rate}</span>
                                    <span onClick={() => removeItem(idx)} className="text-red-500 cursor-pointer">
                                      X
                                    </span>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                        <div className="border-t pt-4">
                        <div className="flex justify-between mb-2">
                          <p>Sub Total:</p>
                          <p>₹{subtotale.toFixed(2)}</p>
                        </div>
                        <div className="flex justify-between mb-2">
                          <p>Discount:</p>
                          <p>- ₹{discountedTotal.toFixed(2)}</p>
                        </div>
                        <div className="flex justify-between mb-4">
                          <p>Tax:</p>
                          <p>₹{tax.toFixed(2)}</p>
                        </div>
                        <div className="flex justify-between font-bold text-lg">
                          <p>Total:</p>
                          <p>₹{finelamount.toFixed(2)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Cancel Recurrence Modal */}
          {showCancelRecurrence && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 p-4">
              <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-semibold text-gray-800">
                    Cancel Recurrence?
                  </h2>
                  <button
                    onClick={() => closeCancelRecurrencePopup(false)}
                    className="text-gray-500 hover:text-red-500 transition-colors"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="15" y1="9" x2="9" y2="15"></line>
                      <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                  </button>
                </div>
                <div className="mt-2 mb-6">
                  <p className="text-gray-600">
                    Are you sure you want to cancel the recurrence of this
                    appointment?
                  </p>
                </div>
                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => setShowCancelRecurrence(false)}
                    className="bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-4 rounded-lg transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      handleCancelRecurrence();
                    }}
                    className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg shadow-sm hover:shadow-md transition-all"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Reschedule Modal */}
          {showRescheduleModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 p-4">
              <div className="bg-white rounded-xl shadow-xl max-w-lg w-full p-6">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-semibold text-gray-800">
                    Reschedule Appointment
                  </h2>
                  <button
                    onClick={closeModal}
                    className="text-gray-500 hover:text-red-500 transition-colors"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="15" y1="9" x2="9" y2="15"></line>
                      <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                  </button>
                </div>

                <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Amount
                  </label>
                  <input
                    type="text"
                    className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                    placeholder="Amount"
                    value={amount} // Display the fetched amount
                    onChange={(e) => setAmount(e.target.value)} // Allow user to modify if needed
                    disabled // Disable input since this value is fetched from the API  
                  />
                </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Select Date
                      </label>
                      <input
                        type="date"
                        className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                        value={date}
                        onChange={(e) => {
                          setDate(e.target.value);
                        }}
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Select Time
                      </label>
                      <input
                        type="time"
                        className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                        value={time}
                        onChange={(e) => {
                          setTime(e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Note
                    </label>
                    <textarea
                      className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 min-h-24"
                      placeholder="Write a note..."
                      value={notes}
                      onChange={(e) => setNote(e.target.value)}
                    ></textarea>
                  </div>

                  <div className="flex justify-end mt-6">
                    <button
                      onClick={() => {
                        handleUpdate();
                      }}
                      className="bg-green-600 hover:bg-green-700 text-white py-2 px-6 rounded-lg shadow-sm hover:shadow-md transition-all"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
     
    </div>
  );
}
export default AppointmentS;



//ye jo code hai esme Edit booking me thoda problem jo me 11-04-2025


// import React, { useState, useEffect, useRef } from "react";
// import {
//   FaEye,
//   FaEdit,
//   FaDownload,
//   FaTimes,
//   FaTimesCircle,
//   FaCheck,
//   FaStar,
//   FaStarHalfAlt,
//   FaRegStar,
// } from "react-icons/fa";
// import image1 from "../assets/house.png";
// import { CiSearch } from "react-icons/ci";
// import { jsPDF } from "jspdf";
// import * as XLSX from "xlsx";
// import { useNavigate } from "react-router-dom";
// import Bed from "../assets/beds.png";
// import "jspdf-autotable"; // Import the autotable plugin
// import { FaFileExcel, FaFilePdf } from "react-icons/fa";
// import axios from "axios"; // Import axios
// import { BaseUrl } from "../App";
// 
// import { Circles } from "react-loader-spinner";

// function AppointmentS() {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [entriesPerPage, setEntriesPerPage] = useState(10);
//   const [showAppointmentModal, setShowAppointmentModal] = useState(false);
//   const [showRescheduleModal, setShowRescheduleModal] = useState(false);
//   const [selectedAppointment, setSelectedAppointment] = useState(null);
//   console.log(selectedAppointment);
//   //(selectedAppointment);
//   const [abcdiscountedTotal, setdiscountedTotal] = useState(null);
//   const [abcfinelamount, setfinelamount] = useState(null);
//   const [abctotelamount, settotelamount] = useState(null);

//   const [order_id_appointment, setorder_id_appointment] = useState(0);
//   //(order_id_appointment);
//   const [showCancelModal, setShowCancelModal] = useState(false);
//   const [cancelReason, setCancelReason] = useState("");
//   const [totalTime, setTotalTime] = useState(0); // To track total time
//   const [showCancelRecurrence, setShowCancelRecurrence] = useState(false);
//   const [isServiceOpen, setIsServiceOpen] = useState(false); // Toggle "Choose Services"
//   const [isCalendarOpen, setIsCalendarOpen] = useState(false);
//   const [isFormOpen, setIsFormOpen] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [selectedTime, setSelectedTime] = useState(null);
//   const [selectedFrequency, setSelectedFrequency] = useState("Weekly");
//   const [officeresidential, setofficeResidential] = useState(false);
//   const [officecommercial, officesetCommercial] = useState(false);
//   const [showEditServiceModal, setShowEditServiceModal] = useState(false);
//   const [residential, setResidential] = useState(false);
//   const [commercial, setCommercial] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [ratings, setRatings] = useState();
//   const [appointments, setAppointments] = useState([]);
//   const [selectedDiscount, setSelectedDiscount] = useState(0);
//   const [text, setText] = useState();
//   const [showBookingSummary, setShowBookingSummary] = useState(false);
//   const [showBookingSummary2, setShowBookingSummary2] = useState(false);
//   const [editdataid, seteditdataid] = useState();
//   console.log(editdataid);
//   const [services, setServices] = useState([]);
//   //(services);
//   const [damagedFloors, setDamagedFloors] = useState(0);
//   const [doorJams, setDoorJams] = useState(0);
//   const [packing, setPacking] = useState(0);
//   const [storeroom, setStoreroom] = useState(0);
//   const [selectedservices, setselectedservices] = useState(0);
//   const [area, setArea] = useState(0);
//   const [officearea, setOfficeArea] = useState(0);
//   const [extraDamagedFloors, setExtraDamagedFloors] = useState(0);
//   const [extraDoorJams, setExtraDoorJams] = useState(0);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [error, setError] = useState("");
//   const [Disamount, setDisamount] = useState(0);
//   const [officeextraDamagedFloors, setofficeExtraDamagedFloors] = useState(0);
//   const [officeextraDoorJams, setofficeExtraDoorJams] = useState(0);
//   const [showImageSection, setShowImageSection] = useState(false);
//   const [selectedService, setSelectedService] = useState(null);
//   //(selectedService);
//   const [bookingBill, setBookingBill] = useState([]);
//   //(bookingBill);
//   const [bedroom, setBedroom] = useState(0);
//   const [bathroom, setBathroom] = useState(0);
//   const [tax, settax] = useState(0);
//   const [quantities, setQuantities] = useState([0, 0, 0]);
//   const [selectedMethod, setSelectedMethod] = useState(null);
//   const [maintotelamount, setmaintotelamount] = useState(0);

//   //(selectedMethod);
//   const [userDetails, setUserDetails] = useState(null);
//   const [bookingappointment, setbookingappointment] = useState([]);
//   const [subtotale, setsubtotale] = useState(0);
//   const [adminData, setAdminData] = useState(null);
//   const [userSelectedMethods, setUserSelectedMethods] = useState(null);
//   const [userSelectedMethodsId, setUserSelectedMethodsId] = useState(null);
//   const [userSelectedMethodsUnitsId, setUserSelectedMethodsUnitsId] =
//     useState(null);
//   const [userSelectedMethodsSmqty, setUserSelectedMethodsSmqty] =
//     useState(null);
//   const [isRatingModalOpen, setIsRatingModalOpen] = useState(false);
//   const [showRatingModal, setShowRatingModal] = useState(false);
//   const [rating, setRating] = useState(0); // Rating value (1 to 5)
//   const [hoveredRating, setHoveredRating] = useState(null); // To track hover state
//   const [review, setReview] = useState(""); // Review text
//   const [userSelectedAddon, setUserSelectedAddon] = useState(null);
//   const [amount, setAmount] = useState("");
//   const [date, setDate] = useState("");
//   const [notes, setNote] = useState("");
//   const [time, setTime] = useState("");
//   const currentDate = new Date();
//   const bookingDate = new Date(selectedAppointment?.booking_date_time);
//   const [allsetdata, setallsetdata] = useState();
//   const [totelamount, setTotelamount] = useState(0); // Already declared as abctotelamount, but misspelled

//   console.log(allsetdata);
//   useEffect(() => {
//     let timer;
//     if (error) {
//       timer = setTimeout(() => {
//         setError("");
//       }, 5000); // 5 seconds
//     }
//     return () => clearTimeout(timer);
//   }, [error]);

//   const calculateTotal = () => {
//     const existingTotal = bookingBill.reduce(
//       (total, item) => total + item.s_m_rate,
//       0
//     );
  

//     return existingTotal;
//   };


//   const getbooking = async (id) => {
//     if (!id) {
//       console.error("❌ No order_id provided for get_service_cart_list API");
//       return null;
//     }

//     setLoading(true);
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         {
//           action: "get_service_cart_list",
//           api_key: "1",
//           order_id: id,
//         }
//       );

//       if (response.status === 200 && response.data.status === "true") {
//         return response.data.response; // Return fresh data
//       } else {
//         console.error("❌ Unexpected response:", response.data);
//         return null;
//       }
//     } catch (error) {
//       console.error("🚨 Error fetching get_service_cart_list:", error);
//       return null;
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const parseCurrency = (str) => parseFloat(str?.replace(/[^0-9.-]+/g, ""));
// //   const parseCurrency = (str) => {
// //     if (!str || typeof str !== "string") return 0;
// //     return parseFloat(str.replace(/[^0-9.-]+/g, "")) || 0;
// //   };

// //   // const totalAmount = parseCurrency(allsetdata?.amount);
// //   // const discountAmount = parseCurrency(allsetdata?.discount);
// //   // const taxAmount = parseCurrency(allsetdata?.cart_tax);
// //   const totalAmount = parseCurrency(allsetdata?.total_amount); // ₹82.00 -> 82
// // const discountAmount = parseCurrency(allsetdata?.discount); // ₹8.00 -> 8
// // const taxAmount = parseCurrency(allsetdata?.cart_tax); // ₹10.00 -> 10

// //   const total2 = calculateTotal();

// //   console.log(totalAmount, discountAmount, taxAmount);

// //   const subTotalEdit = totalAmount + total2;

// //   const disEdit = (subTotalEdit * 10) / 100;

// //   const subm = subTotalEdit - disEdit;

// //   console.log(subm, "submmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm");

// //   const totelamount2 = subm + taxAmount;

// //   console.log(
// //     totelamount2,
// //     "totelamountmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm"
// //   );

// //   const frequencyMap = {
// //     Once: 0,
// //     Weekly: 15,
// //     "Bi-Weekly": 12.5,
// //     Monthly: 10,
// //   };

// //   // allsetdata.discount_typename ka corresponding value nikalna
// //   const abcdata = frequencyMap[allsetdata?.discount_typename] || 0;

// //   console.log(abcdata);

// //   const toatelfinalamount = parseCurrency(allsetdata?.total_amount);

// //   const total = calculateTotal();

// //   const discountPercentage = (discountAmount / totalAmount) * 100;
// //   const finalDiscount = discountPercentage.toFixed(2);
// //   // const finalDiscount = 10;

// //   const totelamount = totalAmount + total;

// //   const discountedTotal = (subTotalEdit * abcdata) / 100;

// //   const totalfinalamount = totelamount - discountedTotal;

// //   const finelamount = totalfinalamount + taxAmount;

// //   console.log(totalfinalamount, "totalfinalamount");

// //   console.log(totelamount, "totelamount");
// //   console.log(finelamount, "finelamount");
// //   console.log(discountedTotal, "discountedTotal");
// const parseCurrency = (str) => {
//   if (!str || typeof str !== "string") return 0;
//   return parseFloat(str.replace(/[^0-9.-]+/g, "")) || 0;
// };

// const totalAmount = parseCurrency(allsetdata?.total_amount); // ₹82.00 -> 82
// const discountAmount = parseCurrency(allsetdata?.discount); // ₹8.00 -> 8
// const taxAmount = parseCurrency(allsetdata?.cart_tax); // ₹10.00 -> 10
// const frequentDiscount = parseCurrency(allsetdata?.frequent_discount); // - ₹1.00 -> -1

// const total = calculateTotal(); // Sum of s_m_rate from bookingBill
// const subTotalEdit = total; // Use bookingBill total instead of totalAmount
// const discountedTotal = discountAmount + Math.abs(frequentDiscount); // Combine discount and frequent_discount
// const finelamount = subTotalEdit - discountedTotal + taxAmount;

// console.log({
//   totalAmount,
//   discountAmount,
//   taxAmount,
//   frequentDiscount,
//   total,
//   subTotalEdit,
//   discountedTotal,
//   finelamount,
// });
//   const diffInMonths =
//     (bookingDate.getFullYear() - currentDate.getFullYear()) * 12 +
//     bookingDate.getMonth() -
//     currentDate.getMonth();

//   // Check if the booking is more than one month in the future
//   const isMoreThanOneMonthAway =
//     diffInMonths > 1 ||
//     (diffInMonths === 1 && bookingDate.getDate() > currentDate.getDate());

//     const calculateDaysDifference = (appointmentDate) => {
//       const currentDate = new Date();
//       const bookingDate = new Date(appointmentDate);
//       const timeDiff = bookingDate - currentDate;
//       const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
//       return daysDiff;
//     };
//   const methodSelectedRef = useRef(false);
//   const [Services_frequently_discount, setServices_frequently_discount] =
//     useState([]);
//   const [propertyQuantities, setPropertyQuantities] = useState({
//     Build_walls: 0,
//     Build_doors: 0,
//     Build_windows: 0,
//   });
//   const [officeQuantities, setOfficeQuantities] = useState({
//     desk: 0,
//     window: 0,
//   });


//   const fetchRatings = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       const response = await axios.post(`${BaseUrl}/backend/api/accept.appointment.php`, {
//         action: 'get_ratings',
//       }, {
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       });
//       console.log(response.data)

//       // Check if the response is successful
//       if (response.data.status === 'true' && response.data.statuscode === 200) {
//         setRatings(response.data.response); // Store the ratings data
//       } else {
//         setError(response.data.response || 'Failed to fetch ratings');
//       }
//     } catch (err) {
//       setError(err.message || 'An error occurred while fetching ratings');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch ratings when the component mounts
//   useEffect(() => {
//     fetchRatings();
//   }, []);



//   const addItemToBill = (units_id, itemName, quantity, pricePerItem) => {
//     setBookingBill((prevBill) => {
//       const existingItemIndex = prevBill.findIndex(
//         (item) => item.units_id === units_id && item.type === "method_units"
//       );
//       let updatedBill = [...prevBill];
  
//       if (existingItemIndex !== -1) {
//         // Update existing item
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             ...updatedBill[existingItemIndex],
//             s_m_qty: quantity,
//             s_m_rate: quantity * pricePerItem,
//           };
//         } else {
//           updatedBill.splice(existingItemIndex, 1); // Remove if quantity is 0
//         }
//       } else if (quantity > 0) {
//         // Add new item
//         updatedBill.push({
//           type: "method_units",
//           service_id: selectedService,
//           method_id: selectedMethod.method_id,
//           units_id: units_id,
//           name: itemName,
//           s_m_qty: quantity,
//           s_m_rate: quantity * pricePerItem,
//         });
//       }
  
//       // Recalculate total time
//       const newTotalTime = updatedBill.reduce(
//         (time, item) => time + (item.s_m_qty || 0) * 60,
//         0
//       );
//       setTotalTime(newTotalTime);
  
//       // Recalculate financials
//       calculateDiscountedTotal(updatedBill);
//       return updatedBill;
//     });
//   };

//   // const calculateDiscountedTotal = (data) => {
//   //   const total = calculateTotal(); // Get the total price
//   //   //(total);

//   //   console.log("total", total);

//   //   setsubtotale(total);
//   //   if (isNaN(total)) {
//   //     console.error("Total calculation resulted in NaN:", total);
//   //     return 0;
//   //   }
//   //   setSelectedDiscount(finalDiscount);

//   //   const discountPercentage = selectedDiscount;
//   //   // Get the discount based on the frequency

//   //   console.log("totaltotaltotal", total);

//   //   const discountAmount = (total * discountPercentage) / 100; // Calculate the discount
//   //   const totalAfterDiscount = total; // Subtract the discount from the total
//   //   const taxsum = total === 0 ? 0 : 10;

//   //   setDisamount(discountAmount);
//   //   settax(taxsum);

//   //   console.log(totalAfterDiscount);

//   //   setText(totalAfterDiscount);
//   //   return totalAfterDiscount;
//   // };

//   //(adminData, "adminData");
//   const calculateDiscountedTotal = (updatedBill = bookingBill) => {
//     const total = updatedBill.reduce(
//       (sum, item) => sum + (parseFloat(item.s_m_rate) || 0),
//       0
//     );
//     setsubtotale(total);
  
//     const apiSubtotal = parseCurrency(allsetdata?.amount) || 0;
//     const apiDiscount = parseCurrency(allsetdata?.discount) || 0;
//     const apiFrequentDiscount = Math.abs(parseCurrency(allsetdata?.frequent_discount) || 0);
//     const apiTax = parseCurrency(allsetdata?.cart_tax) || 0;
  
//     const newSubtotal = total; // Use bill total instead of API subtotal
//     const discountedTotal = apiDiscount + apiFrequentDiscount; // Keep API discounts
//     const finelamount = newSubtotal - discountedTotal + apiTax;
  
//     setTotelamount(newSubtotal);
//     setdiscountedTotal(discountedTotal);
//     setfinelamount(finelamount);
//     setDisamount(discountedTotal);
//     settax(apiTax);
  
//     return finelamount;
//   };
//   const [icon, setIcon] = useState("+"); // State to control the icon (either "+" or "-")
//   const handleImageSectionToggle = () => {
//     setShowImageSection((prevState) => !prevState); // Toggle the visibility of the image section
//     setIcon((prevIcon) => (prevIcon === "+" ? "-" : "+"));
//   };
//   const [formData, setFormData] = useState({
//     serviceLocation: "",
//     zipCode: "",
//     selectedService: "",
//     image: image1,
//     showHouseOptions: false,
//     showPlumbingOptions: false,
//     showCarpenterOptions: false,
//     showOfficeOptions: false,
//     bedroomCount: "",
//     bathroomCount: "",
//   });
//   const navigate = useNavigate();

//  // Replace this section in your existing code around line 600-650 (where paginatedData and related logic is defined)

// // Filtered Data
// const filteredData = appointments.filter(
//   (row) =>
//     row.order_id.toLowerCase().includes(searchQuery.toLowerCase()) || // Filter by order_id
//     row.appointment_date.includes(searchQuery) || // Filter by appointment_date
//     row.appointment_time.includes(searchQuery) // Filter by appointment_time
// );

// // Total Entries
// const totalEntries = filteredData.length;

// // Pagination Logic
// const startIndex =
//   (currentPage - 1) *
//   (entriesPerPage === "All" ? totalEntries : entriesPerPage);

// // Paginated Data with Ascending Order Sorting (Earliest First)
// const paginatedData = (
//   entriesPerPage === "All"
//     ? filteredData
//     : filteredData.slice(startIndex, startIndex + entriesPerPage)
// )
//   .filter((item, index, self) => {
//     const uniqueKey = `${item.order_id}-${item.appointment_date}`;
//     return (
//       index ===
//       self.findIndex(
//         (t) => `${t.order_id}-${t.appointment_date}` === uniqueKey
//       )
//     );
//   })
//   .sort((a, b) => {
//     const dateA = new Date(a.appointment_date); // Note: a first
//     const dateB = new Date(b.appointment_date); // Note: b second
//     if (dateA < dateB) return -1; // Earliest dates first
//     if (dateA > dateB) return 1;
//     if (a.order_id < b.order_id) return -1; // Lower order_id first
//     if (a.order_id > b.order_id) return 1;
//     return 0;
//   });
// // Total Pages Calculation
// const totalPages =
//   entriesPerPage === "All" ? 1 : Math.ceil(totalEntries / entriesPerPage);

// // Handlers
// const handleSearch = (e) => setSearchQuery(e.target.value);

// const handleEntriesChange = (e) => {
//   setEntriesPerPage(e.target.value === "All" ? "All" : Number(e.target.value));
//   setCurrentPage(1); // Reset to the first page
// };

// const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));

// const handleNextPage = () =>
//   setCurrentPage((prev) => Math.min(prev + 1, totalPages));

// // Add this useEffect to set default entriesPerPage to 10 on component mount
// useEffect(() => {
//   setEntriesPerPage(10); // Set default to 10 entries
// }, []); // Runs only once when component mounts


//   const generateInvoice = async (userId, allsetdata) => {
//     console.log(allsetdata);

//     // Retrieve user details from your state (ensure this returns an object)
//     const user = userDetails;
//     if (!user) {
//       console.error("User details not found");
//       return; // Exit if user details are not available
//     }

//     //("Appointment Data:", appointment);
//     const doc = new jsPDF();

//     // Company details (static in this example)
//     const companyDetails = {
//       name: "MegaClean",
//       address: "123 Clean St, Riyadh",
//       phone: "+1005555555",
//     };

//     // **Company Header**
//     doc.setFontSize(16);
//     doc.setFont("helvetica", "bold");
//     doc.text(companyDetails.name, 20, 20);
//     doc.setFontSize(10);
//     doc.setFont("helvetica", "normal");
//     doc.text(companyDetails.address, 20, 30);
//     doc.text(companyDetails.phone, 20, 37);

//     // **Invoice Header**
//     doc.setFontSize(14);
//     doc.setFont("helvetica", "bold");
//     // Adjust x-coordinate based on page width for right alignment
//     doc.text("INVOICE", doc.internal.pageSize.width - 60, 20);
//     doc.setFontSize(10);
//     doc.setFont("helvetica", "normal");
//     // Use dynamic date if available, or fallback to current date
//     const invoiceDate =
//       allsetdata?.invoice_date || new Date().toLocaleDateString();
//     doc.text(
//       `Invoice Date: ${invoiceDate}`,
//       doc.internal.pageSize.width - 60,
//       30
//     );
//     // Use dynamic order ID from allsetdata? data
//     doc.text(
//       `Order ID: ${allsetdata?.order_id || "N/A"}`,
//       doc.internal.pageSize.width - 60,
//       37
//     );

//     // **Customer Details**
//     doc.setFontSize(12);
//     doc.setFont("helvetica", "bold");
//     doc.text("Customer Details", 20, 55);
//     doc.setFontSize(10);
//     doc.setFont("helvetica", "normal");
//     doc.text(
//       `Name: ${user.first_name || "N/A"} ${user.last_name || ""}`,
//       20,
//       65
//     );
//     doc.text(`Email: ${user.user_email || "N/A"}`, 20, 72);
//     doc.text(`Phone: ${user.phone || "N/A"}`, 20, 79);
//     // Concatenate address fields ensuring commas only if fields exist
//     const addressParts = [user.address, user.city, user.state, user.zip].filter(
//       Boolean
//     );
//     doc.text(`Address: ${addressParts.join(", ") || "N/A"}`, 20, 86);

//     let yPosition = 105;

//     // **Service Table Header**
//     const tableTop = yPosition;
//     doc.setFillColor(51, 51, 51);
//     doc.setTextColor(255, 255, 255);

//     // Draw table header background cells
//     doc.rect(20, tableTop, 100, 8, "F"); // Service Name column
//     doc.rect(120, tableTop, 25, 8, "F"); // Quantity column
//     doc.rect(145, tableTop, 25, 8, "F"); // Unit Price column
//     doc.rect(170, tableTop, 25, 8, "F"); // Total column

//     // Add table header texts
//     doc.setFontSize(10);
//     doc.setFont("helvetica", "bold");
//     doc.text("Service Name", 22, tableTop + 6);
//     doc.text("Qty", 128, tableTop + 6);
//     doc.text("Unit Price", 147, tableTop + 6);
//     doc.text("Total", 172, tableTop + 6);

//     // Reset text color for the table body
//     doc.setTextColor(0, 0, 0);
//     yPosition = tableTop + 15;

//     // **Service Details** (dynamic values with fallbacks)
//     const serviceTitle = allsetdata?.service_title || "N/A";
//     const serviceUnit = allsetdata?.units_title || "";
//     const serviceQty = allsetdata?.method_unit_id || "N/A";
//     const unitPrice = allsetdata?.method_unit_qty_rate || "N/A";
//     const totalPrice =
//       allsetdata?.method_unit_id && allsetdata?.method_unit_qty_rate
//         ? `$${(
//             parseFloat(allsetdata?.method_unit_id) *
//             parseFloat(allsetdata?.method_unit_qty_rate)
//           ).toFixed(2)}`
//         : "N/A";

//     doc.setFont("helvetica", "normal");
//     doc.text(
//       `${serviceTitle} ${serviceUnit ? `(${serviceUnit})` : ""}`,
//       22,
//       yPosition
//     );
//     doc.text(String(serviceQty), 128, yPosition);
//     doc.text(String(unitPrice), 147, yPosition);
//     doc.text(String(totalPrice), 172, yPosition);

//     // **Add-ons Section**
//     yPosition += 20;
//     doc.setFont("helvetica", "bold");
//     doc.text("Add-ons", 20, yPosition);
//     doc.setFont("helvetica", "normal");
//     yPosition += 10;

//     // Process add-ons if available
//     if (allsetdata?.addon_service_name) {
//       const addons = allsetdata?.addon_service_name.split(",");
//       const addonQty = allsetdata?.addons_service_qty
//         ? allsetdata?.addons_service_qty.split(",")
//         : [];
//       const addonRate = allsetdata?.addons_service_rate
//         ? allsetdata?.addons_service_rate.split(",")
//         : [];
//       const addonUnits = allsetdata?.addon_service_name
//         ? allsetdata?.addon_service_name.split(",")
//         : [];
//       const addonPrice = allsetdata?.addons_service_rate
//         ? allsetdata?.addons_service_rate.split(",")
//         : [];

//       addons.forEach((addon, i) => {
//         const currentUnit = addonUnits[i] || "N/A";
//         const currentQty = addonQty[i] || "N/A";
//         const currentRate = addonRate[i] || "N/A";
//         const crrentprice = addonPrice[i] || "N/A";
//         doc.text(String(currentQty), 128, yPosition);
//         doc.text(`${addon} (${currentUnit})`, 22, yPosition);
//         doc.text(String(crrentprice), 147, yPosition);

//         doc.text(String(currentRate), 172, yPosition);

//         yPosition += 10;
//       });
//     } else {
//       doc.text("No Add-ons available", 22, yPosition);
//       yPosition += 10;
//     }
//     yPosition += 15;
//     doc.setFont("helvetica", "bold");
//     doc.text("Summary", 20, yPosition);
//     yPosition += 10;

//     const cleanCurrency = (value) => {
//       if (!value) return 0;
//       return parseFloat(value.toString()?.replace(/[^0-9.]/g, "")) || 0;
//     };

//     // Dynamic summary items using API response values directly
//     const subtotal = cleanCurrency(allsetdata?.amount) || 0; // Using amount as subtotal
//     const frequently_discount_amount =
//       cleanCurrency(allsetdata?.discount) || 0; // Direct discount value
//     // const couponDiscount = cleanCurrency(allsetdata?.frequent_discount) || 0;  // Using frequent_discount as coupon
//     const taxAmount = cleanCurrency(allsetdata?.cart_tax) || 0; // Direct tax value

//     const summaryItems = [
//       { label: "Subtotal", value: `${Number(subtotal).toFixed(2)}` },

//       {
//         label: "Discount",
//         value: `${Number(frequently_discount_amount).toFixed(2)}`,
//       },
//       { label: "Tax", value: `${Number(taxAmount).toFixed(2)}` },
//     ];

//     doc.setFont("helvetica", "normal");
//     summaryItems.forEach((item) => {
//       doc.text(item.label, 120, yPosition);
//       doc.text(item.value, 172, yPosition);
//       yPosition += 8;
//     });

//     // **Total Calculation**
//     yPosition += 5;
//     doc.setFillColor(240, 240, 240);
//     doc.rect(115, yPosition - 6, 80, 8, "F");
//     doc.setFont("helvetica", "bold");
//     // Use total_amount directly from API response instead of calculating
//     const totalPayment = cleanCurrency(allsetdata?.total_amount) || 0;
//     doc.text("Total", 120, yPosition);
//     doc.text(`${Number(totalPayment).toFixed(2)}`, 172, yPosition);

//     // **Footer with Booking Date**
//     yPosition += 25;
//     doc.setFont("helvetica", "normal");
//     const bookingDate = allsetdata?.booking_date_time || "N/A";
//     doc.text(`Booked On: ${bookingDate}`, 20, yPosition);

//     yPosition += 10;
//     doc.setFont("helvetica", "bold");
//     doc.text("Thank you for choosing MegaClean!", 20, yPosition);

//     // Page number at bottom right
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(10);
//     doc.text(
//       "Page 1 of 1",
//       doc.internal.pageSize.width - 30,
//       doc.internal.pageSize.height - 10
//     );

//     // Save the generated invoice as a PDF file
//     doc.save(`Invoice_${userId}.pdf`);
//   };

//   const toggleServicePanel = () => {
//     setIsServiceOpen((prev) => !prev); // Toggle this panel
//     if (!isServiceOpen) {
//       // If opening this panel
//       setIsCalendarOpen(false); // Close others
//       setIsFormOpen(false);
//     }
//   };
//   const openRatingMenuaaa = (row) => {
//     //("hello");
//     setSelectedAppointment(row); // Store the selected row data
//     setIsRatingModalOpen(true); // Open the modal
//   };
//   const closeRatingMenu = () => {
//     setIsRatingModalOpen(false); // Close the modal
//   };
//   const handleSaveRating = async () => {
//     setLoading(true);

//     // Ensure selectedAppointment has valid data
//     if (!selectedAppointment) {
//       console.error("No appointment selected.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/accept.appointment.php`,
//         {
//           action: "add_rating_review",
//           api_key: "1", // Your API key
//           order_id: selectedAppointment.order_id, // Pass order_id
//           staff_id: selectedAppointment.staff_ids, // Pass staff_id
//           rating: rating, // Convert rating to string if necessary
//           review: review, // User review text
//         }
//       );

//       // Check if the response is successful
//       if (response.data.status === "true") {
//         setSuccessMessage("Add Rating Review Successfully!");
//         setShowRatingModal(false); // Close the modal
//         fetchRatings()
//         // Reset rating and review state
//         setRating(0);
//         setReview("");

//         // Refresh appointment list
//         fetchAppointments(sessionStorage.getItem("userId"));
//       } else {
//         console.error("Error saving rating:", response.data);
//       }
//     } catch (error) {
//       console.error("Error during API call:", error);
//     } finally {
//       setLoading(false); // Ensure loading is stopped in all cases
//       closeRatingModal();
//     }
//   };

//   // Close rating modal
//   const closeRatingModal = () => {
//     setIsRatingModalOpen(false);
//     setRating(0);
//     setReview("");
//   };
//   const handleSaveCancel = async () => {
//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_reject.php`,
//         {
//           action: "reject_appointment",
//           api_key: "1",
//           order_id: selectedAppointment.order_id,
//           reject_reason: cancelReason,
//         }
//       );

//       if (response.data.response) {
//         setSuccessMessage("Reject Appointment Successfully!");
//       } else {
//         console.error("Error rejecting appointment:", response.data);
//       }
//     } catch (error) {
//       console.error("Error during API call:", error);
//     } finally {
//       setLoading(false); // Ensure loading stops in all cases
//       setShowCancelModal(false); // Ensure modal is closed
//     }
//   };

//   const handleUpdate = async () => {
//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_reshedule.php`,
//         {
//           action: "reschedule_appointment",
//           api_key: "1",
//           order_id: selectedAppointment.order_id,
//           date,
//           notes,
//           time,
//         }
//       );

//       if (response.data.response) {
//         setSuccessMessage("Reschedule Appointment Successfully!");
//       } else {
//         console.error("Error rescheduling appointment:", response.data);
//       }
//     } catch (error) {
//       console.error("Error during API call:", error);
//     } finally {
//       setLoading(false); // Ensure loading stops in all cases
//       closeModal(); // Ensure modal is closed
//     }
//   };

//   const handleReviewChange = (e) => {
//     setReview(e.target.value);
//   };
//   // Handle Cancel
//   const handleCancelRating = () => {
//     setIsRatingModalOpen(false);
//   };

//   // const removeItem = (idx) => {
//   //   setBookingBill((prevBill) => prevBill.filter((_, index) => index !== idx));
//   // };
//   const removeItem = (idx) => {
//     setBookingBill((prevBill) => {
//       const itemToRemove = prevBill[idx];
//       const updatedBill = prevBill.filter((_, index) => index !== idx);
  
//       // If removing a submethod
//       if (itemToRemove.type === "method_units") {
//         // No direct state to reset for dropdown, it will reset to "" automatically
//       }
  
//       // If removing an add-on
//       if (itemToRemove.type === "addon") {
//         const addonIndex = services
//           .find((s) => s.service_id === selectedService)
//           ?.addons.findIndex((a) => a.addon_id === itemToRemove.units_id);
//         if (addonIndex !== undefined) {
//           setQuantities((prev) => {
//             const newQuantities = [...prev];
//             newQuantities[addonIndex] = 0;
//             return newQuantities;
//           });
//           setUserSelectedAddon((prev) =>
//             prev.filter((id) => id !== itemToRemove.units_id)
//           );
//         }
//       }
  
//       return updatedBill;
//     });
//   };
//   const handleMethodSelection = (method, id) => {
//     //("****************************", method, id);
//     switch ((method?.method_title, id)) {
//       case "Residential Services":
//         setResidential(true);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Commercial Services":
//         setResidential(false);
//         setCommercial(true);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Property Based":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(true);
//         officesetCommercial(false);
//         break;
//       case "Area Based (Feet)":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(true);
//         break;
//       default:
//         // Reset all states if no match is found
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//     }
//     setSelectedMethod(method, id);
//   };
//   const handleCancel = () => {
//     setShowAppointmentModal(false); // Close the appointment modal
//     setShowCancelModal(true); // Open the cancel modal
//   };
  
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });

//     // Log the value for the selected bedroom
//     if (name === "bedroomCount") {
//       //(`Selected Bedroom: ${value}`);
//     }
//   };
//   useEffect(() => {
//     calculateDiscountedTotal(); // Calculate discounted total whenever discount or total changes
//   }, [
//     selectedService,
//     bookingBill,
//     propertyQuantities,
//     area,
//     damagedFloors,
//     doorJams,
//     officeQuantities,
//     officearea,
//     packing,
//     storeroom,
//   ]);
//   useEffect(() => {
//     const updateOrAddToBill = (itemName, quantity, pricePerItem) => {
//       const existingItemIndex = bookingBill.findIndex(
//         (item) => item.name === itemName
//       );
//       if (existingItemIndex !== -1) {
//         const updatedBill = [...bookingBill];
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             ...updatedBill[existingItemIndex],
//             quantity,
//             price: quantity * pricePerItem,
//           };
//         } else {
//           updatedBill.splice(existingItemIndex, 1); // Remove the item if quantity is zero
//         }
//         setBookingBill(updatedBill);
//       } else if (quantity > 0) {
//         setBookingBill([
//           ...bookingBill,
//           {
//             type: "addon",
//             s_m_qty: quantity,
//             s_m_rate: quantity * pricePerItem,
//           },
//         ]);
//       }
//     };
//     updateOrAddToBill("Bedrooms", bedroom, 5);
//     updateOrAddToBill("Bathrooms", bathroom, 5);
//   }, [bedroom, bathroom]);
//   const handleBedroomChange = (unitId, value) => {
//     setBedroom((prevSelections) => ({
//       ...prevSelections,
//       [unitId]: value,
//     }));
//   };

  
//   // const openEditServiceModal = async (row) => {
//   //   setLoading(true);
//   //   setorder_id_appointment(row.order_id);

//   //   // Reset states to ensure fresh data
//   //   setBookingBill([]);
//   //   setTotalTime(0);
//   //   setSelectedService(null);
//   //   setSelectedMethod(null);
//   //   setUserSelectedMethods([]);
//   //   setUserSelectedMethodsId([]);
//   //   setUserSelectedMethodsUnitsId([]);
//   //   setUserSelectedMethodsSmqty([]);
//   //   setUserSelectedAddon([]);
//   //   setQuantities([0, 0, 0]);
//   //   setallsetdata(null); // Reset allsetdata

//   //   try {
//   //     const response = await axios.post(
//   //       `${BaseUrl}/backend/api/book_appointment.php`,
//   //       {
//   //         action: "get_edit_booking_info",
//   //         api_key: "1",
//   //         order_id: row.order_id,
//   //       }
//   //     );

//   //     if (response.data.status === "true") {
//   //       const bookingData = response.data.response.ct_cart.method;
//   //       setSelectedAppointment(bookingData);
//   //       setShowEditServiceModal(true);

//   //       // Extract data from response
//   //       const serviceIds = bookingData.map((item) => item.service_id);
//   //       const methodIds = bookingData.map((item) => item.method_id);
//   //       const unitsIds = bookingData.map((item) => item.units_id);
//   //       const s_m_qty = bookingData.map((item) => item.s_m_qty);
//   //       const addonIds = bookingData
//   //         .filter((item) => item.type === "addon")
//   //         .map((item) => item.units_id);

//   //       // Set states with fresh data
//   //       setUserSelectedMethods(serviceIds);
//   //       setUserSelectedMethodsId(methodIds);
//   //       setUserSelectedMethodsUnitsId(unitsIds);
//   //       setUserSelectedMethodsSmqty(s_m_qty);
//   //       setUserSelectedAddon(addonIds);

//   //       // Fetch and set latest booking data
//   //       const bookingResponse = await getbooking(row.order_id);
//   //       if (bookingResponse) {
//   //         setallsetdata(bookingResponse);
//   //         // Set selected service from fresh data
//   //         setSelectedService(bookingResponse.service_id || serviceIds[0]);
//   //       }

//   //       // Process methods and set selected method
//   //       const data = services
//   //         .filter((id) => serviceIds.includes(id.service_id))
//   //         .map((md) => md.methods)[0];
//   //       if (data && data[0]) {
//   //         handleMethodSelection(data[0], data[0].method_id);
//   //       }
//   //     }
//   //   } catch (error) {
//   //     console.error("Error fetching booking details:", error);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };
//   // const openEditServiceModal = async (row) => {
//   //   setLoading(true);
//   //   setorder_id_appointment(row.order_id);
  
//   //   // Reset states to ensure fresh data
//   //   setBookingBill([]);
//   //   setTotalTime(0);
//   //   setSelectedService(null);
//   //   setSelectedMethod(null);
//   //   setUserSelectedMethods([]);
//   //   setUserSelectedMethodsId([]);
//   //   setUserSelectedMethodsUnitsId([]);
//   //   setUserSelectedMethodsSmqty([]);
//   //   setUserSelectedAddon([]);
//   //   setQuantities([0, 0, 0]);
//   //   setallsetdata(null); // Reset allsetdata
  
//   //   try {
//   //     // Step 1: Fetch initial booking info (optional, if still needed for other data)
//   //     const response = await axios.post(
//   //       `${BaseUrl}/backend/api/book_appointment.php`,
//   //       {
//   //         action: "get_edit_booking_info",
//   //         api_key: "1",
//   //         order_id: row.order_id,
//   //       }
//   //     );
  
//   //     if (response.data.status === "true") {
//   //       const bookingData = response.data.response.ct_cart.method;
  
//   //       // Step 2: Fetch detailed booking data including staff info
//   //       const bookingResponse = await getbooking(row.order_id);
//   //       if (bookingResponse) {
//   //         setallsetdata(bookingResponse); // Set allsetdata as before
//   //         setSelectedAppointment(bookingResponse); // Update selectedAppointment with get_service_cart_list data
//   //         setShowEditServiceModal(true);
  
//   //         // Extract data from initial response for consistency
//   //         const serviceIds = bookingData.map((item) => item.service_id);
//   //         const methodIds = bookingData.map((item) => item.method_id);
//   //         const unitsIds = bookingData.map((item) => item.units_id);
//   //         const s_m_qty = bookingData.map((item) => item.s_m_qty);
//   //         const addonIds = bookingData
//   //           .filter((item) => item.type === "addon")
//   //           .map((item) => item.units_id);
  
//   //         // Set states with fresh data
//   //         setUserSelectedMethods(serviceIds);
//   //         setUserSelectedMethodsId(methodIds);
//   //         setUserSelectedMethodsUnitsId(unitsIds);
//   //         setUserSelectedMethodsSmqty(s_m_qty);
//   //         setUserSelectedAddon(addonIds);
  
//   //         // Set selected service from detailed response
//   //         setSelectedService(bookingResponse.service_id || serviceIds[0]);
  
//   //         // Process methods and set selected method
//   //         const data = services
//   //           .filter((id) => serviceIds.includes(id.service_id))
//   //           .map((md) => md.methods)[0];
//   //         if (data && data[0]) {
//   //           handleMethodSelection(data[0], data[0].method_id);
//   //         }
//   //       } else {
//   //         console.error("Failed to fetch detailed booking data.");
//   //       }
//   //     } else {
//   //       console.error("Error fetching initial booking info:", response.data);
//   //     }
//   //   } catch (error) {
//   //     console.error("Error fetching booking details:", error);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };
//   const openEditServiceModal = async (row) => {
//     setLoading(true);
//     setorder_id_appointment(row.order_id);
  
//     // Reset states
//     setBookingBill([]);
//     setTotalTime(0);
//     setSelectedService(null);
//     setSelectedMethod(null);
//     setUserSelectedMethods([]);
//     setUserSelectedMethodsId([]);
//     setUserSelectedMethodsUnitsId([]);
//     setUserSelectedMethodsSmqty([]);
//     setUserSelectedAddon([]);
//     setQuantities([0, 0, 0]);
//     setallsetdata(null);
  
//     try {
//       const bookingResponse = await getbooking(row.order_id);
//       if (bookingResponse) {
//         setallsetdata(bookingResponse);
//         setSelectedAppointment(bookingResponse);
//         setShowEditServiceModal(true);
  
//         // Extract data from cart_items
//         const cartItems = bookingResponse.cart_items || [];
//         const serviceIds = [...new Set(cartItems.map((item) => item.service_id))];
//         const methodIds = cartItems.map((item) => item.method_id);
//         const unitsIds = cartItems.map((item) => item.units_id);
//         const s_m_qty = cartItems.map((item) => parseInt(item.s_m_qty) || 0);
//         const addonIds = cartItems
//           .filter((item) => item.type === "addon")
//           .map((item) => item.units_id);
  
//         setUserSelectedMethods(serviceIds);
//         setUserSelectedMethodsId(methodIds);
//         setUserSelectedMethodsUnitsId(unitsIds);
//         setUserSelectedMethodsSmqty(s_m_qty);
//         setUserSelectedAddon(addonIds);
  
//         // Set selected service and method
//         setSelectedService(serviceIds[0] || bookingResponse.service_id);
//         const data = services
//           .filter((id) => serviceIds.includes(id.service_id))
//           .map((md) => md.methods)[0];
//         if (data && data[0]) {
//           handleMethodSelection(data[0], data[0].method_id);
//         }
  
//         // Populate bookingBill with cart_items
//         const newBookingBill = cartItems.map((item) => ({
//           type: item.type,
//           service_id: item.service_id,
//           method_id: item.method_id,
//           units_id: item.units_id,
//           name: item.method_name || "Addon",
//           s_m_qty: parseInt(item.s_m_qty) || 0,
//           s_m_rate: parseFloat(item.s_m_rate) || 0,
//         }));
//         setBookingBill(newBookingBill);
  
//         // Set addon quantities
//         const addonQuantities = services
//           .find((s) => s.service_id === serviceIds[0])
//           ?.addons.map((addon) => {
//             const addonItem = cartItems.find(
//               (item) => item.type === "addon" && item.units_id === addon.addon_id
//             );
//             return addonItem ? parseInt(addonItem.s_m_qty) : 0;
//           }) || [0, 0, 0];
//         setQuantities(addonQuantities);
  
//         // Set total time and financial fields from API
//         setTotalTime(parseInt(bookingResponse.order_duration) || 0);
//         setsubtotale(parseCurrency(bookingResponse.amount) || 0);
//         setDisamount(
//           (parseCurrency(bookingResponse.discount) || 0) +
//             Math.abs(parseCurrency(bookingResponse.frequent_discount) || 0)
//         );
//         settax(parseCurrency(bookingResponse.cart_tax) || 0);
//         setTotelamount(parseCurrency(bookingResponse.total_amount) || 0);
//         setfinelamount(parseCurrency(bookingResponse.total_amount) || 0);
//         setdiscountedTotal(
//           (parseCurrency(bookingResponse.discount) || 0) +
//             Math.abs(parseCurrency(bookingResponse.frequent_discount) || 0)
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching booking details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handleAddonSelection = (addonId) => {
//     // Check if the add-on is already selected
//     if (userSelectedAddon.includes(addonId)) {
//       // If selected, remove it
//       setUserSelectedAddon(userSelectedAddon.filter((id) => id !== addonId));
//     } else {
//       // If not selected, add it
//       setUserSelectedAddon([...userSelectedAddon, addonId]);
//     }
//   };

//   const closeEditServiceModal = () => {
//     setShowEditServiceModal(false);
//   };
//   const openCancelRecurrencePopup = () => {
//     setShowCancelRecurrence(true);
//     setShowAppointmentModal(false);
//   };
//   const closeCancelRecurrencePopup = () => {
//     setShowCancelRecurrence(false);
//     setShowAppointmentModal(false);
//   };
//   const openAppointmentModal = (appointment) => {
//     // console.log(appointment);
//     setSelectedAppointment(appointment);
//     setShowAppointmentModal(true);
//     setShowRescheduleModal(false); // Ensure Reschedule modal is closed when Appointment modal is opened
//   };
//   const openRescheduleModal = () => {
//     setShowAppointmentModal(false); // Close My Appointment modal
//     setShowRescheduleModal(true);
//     if (selectedAppointment && selectedAppointment.amount) {
//       setAmount(selectedAppointment.amount);
//     }
//   };
//   const closeModal = () => {
//     setShowAppointmentModal(false);
//     setShowRescheduleModal(false);
//     setShowEditServiceModal(false);
//   };
//   const handleClick = () => {
//     navigate("admin");
//   };
//   const handleShowBookingSummary = () => {
//     setShowBookingSummary(true);
//   };

//   // const handleSubmit = async () => {
//   //   setLoading(true);

//   //   const hasAtLeastOneUnit = bookingBill.some((item) => item.method_id);
//   //   if (!hasAtLeastOneUnit) {
//   //     alert("You must select at least one unit.");
//   //     setLoading(false);
//   //     return;
//   //   }

//   //   const formattedBookingBill = bookingBill.map((item) => ({
//   //     type: item.type || "method_units",
//   //     service_id: selectedService,
//   //     method_id: item.method_id,
//   //     units_id: item.units_id,
//   //     s_m_qty: item.s_m_qty,
//   //     s_m_rate: item.s_m_rate,
//   //   }));

//   //   const frequencyMap = {
//   //     Once: 1,
//   //     Weekly: 2,
//   //     "Bi-Weekly": 3,
//   //     Monthly: 4,
//   //   };

//   //   const frequent_discount1 =
//   //     allsetdata?.discount_typename || selectedFrequency;
//   //   const discountID = frequencyMap[frequent_discount1] || null;

//   //   const formattedData = {
//   //     action: "edit_booking_info",
//   //     api_key: "1",
//   //     order_id: order_id_appointment,
//   //     amount: totelamount,
//   //     taxes: tax.toFixed(2),
//   //     discount: disEdit,
//   //     net_amount: finelamount,
//   //     frequent_discount: discountID,
//   //     frequent_discount_amount: discountedTotal,
//   //     ct_cart: {
//   //       method: formattedBookingBill,
//   //     },
//   //     time_duration: "40",
//   //   };

//   //   try {
//   //     const response = await axios.post(
//   //       `${BaseUrl}/backend/api/book_appointment.php`,
//   //       formattedData
//   //     );

//   //     if (response.data.status === "true") {
//   //       setSuccessMessage("Appointment Updated successfully!");

//   //       // Fetch fresh data after successful update
//   //       const updatedBookingData = await getbooking(order_id_appointment);
//   //       if (updatedBookingData) {
//   //         setallsetdata(updatedBookingData);

//   //         // Update appointments list
//   //         setAppointments((prevAppointments) =>
//   //           prevAppointments.map((appointment) =>
//   //             appointment.order_id === order_id_appointment
//   //               ? {
//   //                   ...appointment,
//   //                   amount: updatedBookingData?.amount,
//   //                   discount: updatedBookingData?.discount,
//   //                   total_amount: updatedBookingData?.total_amount,
//   //                   booking_date_time: updatedBookingData?.booking_date_time,
//   //                   method_name: updatedBookingData?.method_title,
//   //                   units: updatedBookingData?.units_title,
//   //                   addons: updatedBookingData?.addon_service_name,
//   //                 }
//   //               : appointment
//   //           )
//   //         );
//   //       }

//   //       handleClosebookingSummary();
//   //     } else {
//   //       console.error("Error updating booking:", response.data);
//   //       alert("Failed to update booking. Please try again.");
//   //     }
//   //   } catch (error) {
//   //     console.error("API call failed:", error);
//   //     alert("An error occurred while updating the booking.");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };
//   const handleSubmit = async () => {
//     setLoading(true);
  
//     const hasAtLeastOneUnit = bookingBill.some((item) => item.method_id);
//     if (!hasAtLeastOneUnit) {
//       alert("You must select at least one unit.");
//       setLoading(false);
//       return;
//     }
  
//     const formattedBookingBill = bookingBill.map((item) => ({
//       type: item.type || "method_units",
//       service_id: selectedService,
//       method_id: item.method_id,
//       units_id: item.units_id,
//       s_m_qty: item.s_m_qty,
//       s_m_rate: item.s_m_rate,
//     }));
  
//     const frequencyMap = {
//       Once: 1,
//       Weekly: 2,
//       "Bi-Weekly": 3,
//       Monthly: 4,
//     };
  
//     const frequent_discount1 = allsetdata?.discount_typename || selectedFrequency;
//     const discountID = frequencyMap[frequent_discount1] || null;
  
//     const formattedData = {
//       action: "edit_booking_info",
//       api_key: "1",
//       order_id: order_id_appointment,
//       amount: totelamount.toFixed(2), // Use state value
//       taxes: tax.toFixed(2),
//       discount: Disamount.toFixed(2), // Use Disamount instead of disEdit
//       net_amount: finelamount.toFixed(2), // Use state value
//       frequent_discount: discountID,
//       frequent_discount_amount: discountedTotal.toFixed(2), // Use state value
//       ct_cart: {
//         method: formattedBookingBill,
//       },
//       time_duration: "40",
//     };
  
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         formattedData
//       );
  
//       if (response.data.status === "true") {
//         setSuccessMessage("Appointment Updated successfully!");
  
//         const updatedBookingData = await getbooking(order_id_appointment);
//         if (updatedBookingData) {
//           setallsetdata(updatedBookingData);
//           setAppointments((prevAppointments) =>
//             prevAppointments.map((appointment) =>
//               appointment.order_id === order_id_appointment
//                 ? {
//                     ...appointment,
//                     amount: updatedBookingData?.amount,
//                     discount: updatedBookingData?.discount,
//                     total_amount: updatedBookingData?.total_amount,
//                     booking_date_time: updatedBookingData?.booking_date_time,
//                     method_name: updatedBookingData?.method_title,
//                     units: updatedBookingData?.units_title,
//                     addons: updatedBookingData?.addon_service_name,
//                   }
//                 : appointment
//             )
//           );
//         }
  
//         handleClosebookingSummary();
//       } else {
//         console.error("Error updating booking:", response.data);
//         alert("Failed to update booking. Please try again.");
//       }
//     } catch (error) {
//       console.error("API call failed:", error);
//       alert("An error occurred while updating the booking.");
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handleQuantityChange = (
//     idx,
//     increment,
//     addon_name,
//     addon_price,
//     max_quantity
//   ) => {
//     const newQuantities = [...quantities];
//     if (increment) {
//       if (newQuantities[idx] >= max_quantity) {
//         alert(`Maximum quantity of ${max_quantity} reached for ${addon_name}`);
//         return;
//       }
//       newQuantities[idx] += 1;
//     } else {
//       newQuantities[idx] = Math.max(0, newQuantities[idx] - 1);
//     }
//     setQuantities(newQuantities);
  
//     const quantity = newQuantities[idx];
//     const totalPrice = quantity * addon_price;
  
//     setBookingBill((prevBill) => {
//       const existingItemIndex = prevBill.findIndex(
//         (item) => item.type === "addon" && item.units_id === idx
//       );
//       let updatedBill = [...prevBill];
  
//       if (existingItemIndex !== -1) {
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             ...updatedBill[existingItemIndex],
//             s_m_qty: quantity,
//             s_m_rate: totalPrice,
//           };
//         } else {
//           updatedBill.splice(existingItemIndex, 1);
//         }
//       } else if (quantity > 0) {
//         updatedBill.push({
//           type: "addon",
//           service_id: selectedService,
//           method_id: selectedMethod.method_id,
//           units_id: idx,
//           name: addon_name,
//           s_m_qty: quantity,
//           s_m_rate: totalPrice,
//         });
//       }
  
//       calculateDiscountedTotal(updatedBill);
//       return updatedBill;
//     });
//   };

//   const handleClosebookingSummary = () => {
//     setShowBookingSummary(false);
//     setShowBookingSummary2(false);
//     setShowEditServiceModal(false);

//     // Reset states to clear stale data
//     setBookingBill([]);
//     setTotalTime(0);
//     setSelectedService(null);
//     setSelectedMethod(null);
//     setUserSelectedMethods([]);
//     setUserSelectedMethodsId([]);
//     setUserSelectedMethodsUnitsId([]);
//     setUserSelectedMethodsSmqty([]);
//     setUserSelectedAddon([]);
//     setQuantities([0, 0, 0]);
//     setallsetdata(null);
//   };
//   const handleExcelExport = () => {
//     const columns = ["Order", "Service Name", "Order Date", "Order Time"];
//     const rows = appointments.map((row) => [
//       row.order_id, // Dynamic order_id
//       row.title,
//       row.appointment_date, // Dynamic appointment_date
//       row.appointment_time, // Dynamic appointment_time
//     ]);
//     const ws = XLSX.utils.aoa_to_sheet([columns, ...rows]);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "appointments");
//     XLSX.writeFile(wb, "appointments.xlsx");
//   };
//   const handlePdfExport = () => {
//     const doc = new jsPDF();
//     const columns = ["Order", "Service Name", "Order Date", "Order Time"];
//     const rows = appointments.map((row) => [
//       row.order_id, // Dynamic order_id
//       row.title,
//       row.appointment_date, // Dynamic appointment_date
//       row.appointment_time, // Dynamic appointment_time
//     ]);
//     doc.autoTable({
//       head: [columns],
//       body: rows,
//       startY: 20,
//       theme: "grid",
//       margin: { horizontal: 10 },
//       headStyles: { fillColor: [0, 123, 255], textColor: 255 },
//     });
//     doc.save("appointments.pdf");
//   };

//   const handleCancelRecurrence = async () => {
//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/accept.appointment.php`,
//         {
//           action: "add_rec",
//           api_key: "1",
//           order_id: selectedAppointment.order_id,
//           rec_id: selectedAppointment.recurring_id,
//           status: "P",
//         }
//       );

//       if (response.data.response) {
//         setSuccessMessage("Add Recurring Successfully!");
//       } else {
//         console.error("Error adding recurring:", response.data);
//       }
//     } catch (error) {
//       console.error("Error during API call:", error);
//     } finally {
//       setLoading(false); // Ensure loading stops in all cases
//       closeCancelRecurrencePopup(); // Ensure popup is closed
//     }
//   };

//   useEffect(() => {
//     const userId = sessionStorage.getItem("userId"); // Retrieve user ID from sessionStorage
//     if (userId) {
//       fetchAppointments(userId); // Fetch appointments first
//       fetchUserDetails(userId); // Fetch user details after
//     } else {
//       // console.log("No user ID found, handle accordingly");
//       setLoading(false); // Stop loading spinner if no user ID
//     }
//   }, []);
//   // const fetchAppointments = async (userId) => {
//   //   try {
//   //     const response = await axios.post(
//   //       `${BaseUrl}/backend/api/user_appointment_list.php`,
//   //       {
//   //         action: "get_user_appointments_list",
//   //         api_key: "1",
//   //         user_type: "client",
//   //         user_id: userId,
//   //       }
//   //     );

//   //     if (response.data.status === "true") {
//   //       setAppointments(response.data.response); // Set appointments list
//   //       const userAppointment = response.data.response[0]; // Get the first appointment (or select based on your needs)
//   //       if (userAppointment) {
//   //         const selectedService = userAppointment.service_id; // assuming 'service_id' is available
//   //         setSelectedService(selectedService); // Set the service that was booked by the user
//   //         setAmount(userAppointment.amount || ""); // Assuming 'amount' is a field in the response
//   //       }
//   //     } else {
//   //       console.error("Error fetching appointments:", response.data);
//   //     }
//   //   } catch (error) {
//   //     console.error("Error fetching appointments:", error);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };
//   const fetchAppointments = async (userId) => {
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/user_appointment_list.php`,
//         {
//           action: "get_user_appointments_list",
//           api_key: "1",
//           user_type: "client",
//           user_id: userId,
//         }
//       );
//       if (response.data.status === "true") {
//         console.log("Appointments Data:", response.data.response); // Debug here
//         setAppointments(response.data.response);
//         const userAppointment = response.data.response[0];
//         if (userAppointment) {
//           const selectedService = userAppointment.service_id;
//           setSelectedService(selectedService);
//           setAmount(userAppointment.amount || "");
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching appointments:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const fetchUserDetails = async (userId) => {
//     setLoading(true);
//     // console.log("Fetching user details for userId:", userId); // Log userId to verify it's passed correctly
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/customer_list.php`,
//         {
//           action: "all_customer_list", // Action key to get all customer details
//           api_key: "1", // API key
//         }
//       );
//       // console.log("API response for user details:", response.data); // Log the response to see what's returned
//       const user = response.data.response.find((user) => user.id === userId);
//       if (user) {
//         setUserDetails(user); // Set the user details if found
//       } else {
//         console.error("User not found in the response");
//       }
//     } catch (error) {
//       console.error("Error fetching user details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     const userId = sessionStorage.getItem("userId"); // Retrieve user ID from localStorage
//     // console.log("Retrieved userId from localStorage: ", userId);
//     if (userId) {
//       fetchAppointments(userId); // Fetch appointments
//       fetchServices(); // Fetch services
//     } else {
//       // console.log("No user ID found, handle accordingly");
//       setLoading(false); // Stop loading spinner if no user ID
//     }
//   }, [showEditServiceModal]); // Dependency on modal open state
//   const fetchServices = async () => {
//     // console.log("Fetching services...");
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/services.php`,
//         { action: "all_services", api_key: "1" },
//         { headers: { "Content-Type": "application/json" } }
//       );
//       // console.log("API response for services:", response.data);
//       if (response.data.status === "true") {
//         setServices(response.data.response);
//       } else {
//         console.error("Error fetching services:", response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching services:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handleRatingChange = (value, isHalf = false) => {
//     const rating = isHalf ? value - 0.5 : value;
//     setRating(rating);
//     console.log(rating)
//   };
//   const renderStars = (value) => {
//     const stars = [];
//     const fullStars = Math.floor(value);
//     const hasHalfStar = value % 1 !== 0;

//     // Full stars
//     for (let i = 1; i <= 5; i++) {
//       if (i <= fullStars) {
//         stars.push(
//           <FaStar key={`star-${i}`} className="text-yellow-500 text-3xl" />
//         );
//       } else if (i === fullStars + 1 && hasHalfStar) {
//         stars.push(
//           <FaStarHalfAlt
//             key={`star-${i}`}
//             className="text-yellow-500 text-3xl"
//           />
//         );
//       } else {
//         stars.push(
//           <FaRegStar key={`star-${i}`} className="text-gray-300 text-3xl" />
//         );
//       }
//     }
//     return stars;
//   };

//   console.log(selectedAppointment?.order_id)

//   const filteredRatings = ratings?.filter(
//     (ratingItem) => String(ratingItem?.order_id) === String(selectedAppointment?.order_id)
//   );
  
//   console.log(filteredRatings)


//   return (
//     <div>
//       {loading ? (
//         <div className="flex flex-col items-center justify-center min-h-screen">
//           <Circles height="80" width="80" color="grey" ariaLabel="loading" />
//           <h1 className="mt-2">Please wait...</h1>
//         </div>
//       ) : (
//         <div className="container mx-auto p-6">
//                   {successMessage && (
//             <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
//               <span className="block sm:inline">{successMessage}</span>
//             </div>
//           )}

//           {error && (
//             <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
//               <span className="block sm:inline">{error}</span>
//             </div>
//           )}

//           <h1 className="text-2xl font-semibold mb-6">My Appointment</h1>
//           <div className="flex flex-col sm:flex-row justify-between items-center mb-4 space-y-4 sm:space-y-0">
//             <div className="flex flex-col sm:flex-row sm:items-center w-full space-y-4 sm:space-y-0 sm:space-x-6">
//               {/* Search Bar */}
//               <div className="relative w-full sm:w-80 md:w-96">
//                 <input
//                   type="text"
//                   placeholder="Search Staff..."
//                   value={searchQuery}
//                   onChange={handleSearch}
//                   className="p-3 w-full rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 pl-10"
//                 />
//                 <CiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
//               </div>

//               {/* Buttons (Excel & PDF) */}
//               <div className="flex flex-wrap justify-center sm:justify-start space-x-2 sm:ml-4">
//                 <button
//                   onClick={handleExcelExport}
//                   className="bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold text-sm sm:text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-blue-600 hover:to-blue-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
//                 >
//                   <FaFileExcel className="text-2xl" />
//                   Excel
//                 </button>
//                 <button
//                   onClick={handlePdfExport}
//                   className="bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold text-sm sm:text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-red-600 hover:to-red-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
//                 >
//                   <FaFilePdf className="text-2xl" /> PDF
//                 </button>
//               </div>
//             </div>

//             {/* Entries Per Page */}
//             <div className="flex items-center space-x-2">
//               <span>Show</span>
//               <select
//                 value={entriesPerPage}
//                 onChange={handleEntriesChange}
//                 className="p-2 border border-gray-300 rounded-md"
//               >
//                 <option value={10}>10</option>
//                 <option value={25}>25</option>
//                 <option value={50}>50</option>
//                 <option value="All">All</option>
//               </select>
//               <span>entries</span>
//             </div>
//           </div>

//           {/* // Mobile View (Cards) */}
//           <div className="block sm:hidden">
//             {paginatedData.map((row, index) => {
//               const orderDate = new Date(row.appointment_date);
//               const orderDateFormatted = orderDate.toLocaleDateString();
//               const orderTimeFormatted = orderDate.toLocaleTimeString();
//               const isComplete = row.booking_status === "CO";
//               const currentDate = new Date();
//               const daysDifference = calculateDaysDifference(row.booking_date_time);
//               const isWithin15Days = daysDifference >= 0 && daysDifference <= 15;
//               const isPastBooking = new Date(row.booking_date_time) < new Date();

//               return (
//                 <div
//                   key={index}
//                   className="bg-white rounded-lg shadow-md p-4 mb-4 border border-gray-100 hover:shadow-lg transition-shadow duration-200"
//                 >
//                   <div className="mb-3 pb-2 border-b border-gray-100">
//                     <h2 className="text-lg font-semibold text-gray-800">
//                       Order ID: {row.order_id}
//                     </h2>
//                     <div className="text-sm text-gray-600 mt-1 flex flex-col gap-1">
//                       <p>Date: {orderDateFormatted}</p>
//                       <p>Time: {orderTimeFormatted}</p>
//                     </div><div className="text-sm text-gray-600 mt-1 flex flex-col gap-1">
//                       Service Title :{row.title}
//                       </div>
//                   </div>

//                   <div className="flex flex-wrap gap-2 mb-2">
//                     <button
//                       className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-blue-600 bg-blue-50 hover:bg-blue-100 transition-colors duration-200"
//                       onClick={() => openAppointmentModal(row)}
//                     >
//                       <FaEye className="text-blue-500" />
//                       <span>View Details</span>
//                     </button>

//                     {!isPastBooking && !isWithin15Days && (
//                       <button
//                         onClick={() => openEditServiceModal(row)}
//                         className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-amber-600 bg-amber-50 hover:bg-amber-100 transition-colors duration-200"
//                       >
//                         <FaEdit className="text-amber-500" />
//                         <span>Edit Booking</span>
//                       </button>
//                     )}
//                   </div>

//                   <div className="flex flex-wrap gap-2">
//                     {row.recurrence_status === "Y" && (
//                       <button
//                         onClick={openCancelRecurrencePopup}
//                         className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-red-600 bg-red-50 hover:bg-red-100 transition-colors duration-200"
//                       >
//                         <FaTimes className="text-red-500" />
//                         <span>Cancel Recurrence</span>
//                       </button>
//                     )}

//                     <button
//                       onClick={async () => {
//                         const userId = sessionStorage.getItem("userId");

//                         if (!userId) {
//                           console.error("❌ User ID not found in localStorage");
//                           return;
//                         }

//                         if (!row?.order_id) {
//                           console.error("❌ Order ID missing in row data");
//                           return;
//                         }

//                         try {
//                           // 🛠️ Fetch booking data
//                           const bookingData = await getbooking(row.order_id);

//                           console.log("📢 bookingData received:", bookingData);

//                           if (!bookingData) {
//                             console.error(
//                               "❌ Booking data is null or undefined"
//                             );
//                             return;
//                           }

//                           // 🛠️ Call generateInvoice with the correct data
//                           generateInvoice(userId, bookingData);
//                         } catch (error) {
//                           console.error(
//                             "🚨 Error fetching booking data:",
//                             error
//                           );
//                         }
//                       }}
//                       className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-green-600 bg-green-50 hover:bg-green-100 transition-colors duration-200"
//                     >
//                       <FaDownload className="text-green-500" />
//                       Generate Invoice
//                     </button>

//                     {isComplete && (
//                       <button
//                         onClick={() => openRatingMenuaaa(row)}
//                         className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-purple-600 bg-purple-50 hover:bg-purple-100 transition-colors duration-200"
//                       >
//                         <FaStar className="text-purple-500" />
//                         <span>Rate Service</span>
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* // Tablet & Laptop View (Table) */}
//           <div className="hidden sm:block">
//             <div className="overflow-x-auto rounded-lg shadow">
//               <table className="min-w-full bg-white">
//                 <thead>
//                   <tr className="bg-gray-50 border-b border-gray-200">
//                     <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
//                       Order ID
//                     </th>
//                     <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
//                       Date
//                     </th>
//                     <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
//                       Time
//                     </th>
//                     <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
//                       Service Title
//                     </th>
//                     <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
//                       Booking Details
//                     </th>
//                     <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
//                       Actions
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-gray-200">
//                   {paginatedData.map((row, index) => {
//                     const daysDifference = calculateDaysDifference(row.booking_date_time);
//                     const isWithin15Days = daysDifference >= 0 && daysDifference <= 15;
//                     const isPastBooking = new Date(row.booking_date_time) < new Date();
//                     const orderDate = new Date(row.appointment_date);
//                     const orderDateFormatted = orderDate.toLocaleDateString();
//                     const orderTimeFormatted = row.appointment_time;
//                     const isComplete = row.booking_status === "CO";
//                     const currentDate = new Date();
//                     // const isPastBooking = orderDate < currentDate;

//                     return (
//                       <tr key={index} className="hover:bg-gray-50">
//                         <td className="px-4 py-3 text-sm text-gray-900 font-medium">
//                           {row.order_id}
//                         </td>
//                         <td className="px-4 py-3 text-sm text-gray-600">
//                           {orderDateFormatted}
//                         </td>
//                         <td className="px-4 py-3 text-sm text-gray-600">
//                           {orderTimeFormatted}
//                         </td>
//                         <td className="px-4 py-3 text-sm text-gray-600">
//                           {row?.title}
//                         </td>
//                         <td className="px-4 py-3">
//                           <div className="flex flex-wrap gap-2">
//                             <button
//                               className="flex items-center gap-1 px-2 py-1 text-xs rounded text-blue-600 bg-blue-50 hover:bg-blue-100 transition-colors duration-200"
//                               onClick={() => openAppointmentModal(row)}
//                             >
//                               <FaEye className="text-blue-500 " />
//                               <span className="text-sm">View Details</span>
//                             </button>

//                             {!isPastBooking && !isWithin15Days &&(
//                               <button
//                                 onClick={() => {
//                                   // seteditdataid(row.order_id)
//                                   getbooking(row.order_id);
//                                   openEditServiceModal(row);
//                                 }}
//                                 className="flex items-center gap-1 px-2 py-1 text-xs rounded text-amber-600 bg-amber-50 hover:bg-amber-100 transition-colors duration-200"
//                               >
//                                 <FaEdit className="text-amber-500" />
//                                 <span className="text-sm">Edit Service</span>
//                               </button>
//                             )}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3">
//                           <div className="flex flex-wrap gap-2">
//                             {row.recurrence_status === "Y" && (
//                               <button
//                                 onClick={openCancelRecurrencePopup}
//                                 className="flex items-center gap-1 px-2 py-1 text-xs rounded text-red-600 bg-red-50 hover:bg-red-100 transition-colors duration-200"
//                               >
//                                 <FaTimes className="text-red-500" />
//                                 <span>Cancel</span>
//                               </button>
//                             )}

//                             <button
//                               onClick={async () => {
//                                 const userId = sessionStorage.getItem("userId");

//                                 if (!userId) {
//                                   console.error(
//                                     "❌ User ID not found in localStorage"
//                                   );
//                                   return;
//                                 }

//                                 if (!row?.order_id) {
//                                   console.error(
//                                     "❌ Order ID missing in row data"
//                                   );
//                                   return;
//                                 }

//                                 try {
//                                   // 🛠️ Fetch booking data
//                                   const bookingData = await getbooking(
//                                     row.order_id
//                                   );

//                                   console.log(
//                                     "📢 bookingData received:",
//                                     bookingData
//                                   );

//                                   if (!bookingData) {
//                                     console.error(
//                                       "❌ Booking data is null or undefined"
//                                     );
//                                     return;
//                                   }

//                                   // 🛠️ Call generateInvoice with the correct data
//                                   generateInvoice(userId, bookingData);
//                                 } catch (error) {
//                                   console.error(
//                                     "🚨 Error fetching booking data:",
//                                     error
//                                   );
//                                 }
//                               }}
//                               className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-green-600 bg-green-50 hover:bg-green-100 transition-colors duration-200"
//                             >
//                               <FaDownload className="text-green-500" />
//                               Generate Invoice
//                             </button>

//                             {isComplete && (
//                               <button
//                                 onClick={() => openRatingMenuaaa(row)}
//                                 className="flex items-center gap-1 px-2 py-1 text-xs rounded text-purple-600 bg-purple-50 hover:bg-purple-100 transition-colors duration-200"
//                               >
//                                 <FaStar className="text-purple-500" />
//                                 <span className="text-sm">Rate</span>
//                               </button>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {isRatingModalOpen && selectedAppointment && (
//               <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
//                 <div className="bg-white p-6 rounded-lg sm:w-[500px] md:w-[600px] lg:w-[700px]">
//                   {filteredRatings.length > 0 ? (
//                     <div className="mt-4">
//                       <h3 className="text-lg font-semibold">Ratings:</h3>
//                       <ul>
//                         {filteredRatings.map((ratingItem) => (
//                           <li key={ratingItem.id} className="border-b border-gray-200 py-2">
//                             <div className="flex items-center">
//                               <div className="flex">
//                                 {renderStars(ratingItem.rating)}
//                               </div>
//                               <div className="ml-2">{ratingItem.review}</div>
//                             </div>
//                           </li>
//                         ))}
//                       </ul>
//                       <button
//                         onClick={handleCancelRating}
//                         className="px-4 py-2 mt-4 bg-gray-500 text-white rounded-md"
//                       >
//                         Cancel
//                       </button>
//                     </div>
//                   ) : (
//                     <>
//                       <div className="flex items-center mt-4">
//                     {[1, 2, 3, 4, 5].map((star) => (
//                       <div key={star} className="relative">
//                         {/* Full star button */}
//                         <button
//                           onClick={() => handleRatingChange(star)}
//                           onMouseEnter={() => setHoveredRating(star)}
//                           onMouseLeave={() => setHoveredRating(null)}
//                           className="focus:outline-none relative z-10"
//                         >
//                           {renderStars(hoveredRating || rating)[star - 1]}
//                         </button>

//                         {/* Half star button - overlay on left half */}
//                         <button
//                           onClick={() => handleRatingChange(star, true)}
//                           onMouseEnter={() => setHoveredRating(star - 0.5)}
//                           onMouseLeave={() => setHoveredRating(null)}
//                           className="absolute left-0 top-0 w-1/2 h-full focus:outline-none z-20"
//                         />
//                       </div>
//                     ))}

//                     {/* Rating display */}
//                     <div className="ml-4 p-2 border border-gray-300 rounded-md text-lg font-semibold text-gray-700">
//                       {hoveredRating ? hoveredRating.toFixed(1) : rating.toFixed(1)}
//                     </div>
//                   </div>

//                   <div className="mt-4">
//                     <textarea
//                       value={review}
//                       onChange={handleReviewChange}
//                       rows="4"
//                       placeholder="Write your review..."
//                       className="w-full p-2 border border-gray-300 rounded-md mt-2"
//                     />
//                   </div>
//                     <div className="flex justify-end mt-4 space-x-4">
//                       <button
//                         onClick={handleCancelRating}
//                         className="px-4 py-2 bg-gray-500 text-white rounded-md"
//                       >
//                         Cancel
//                       </button>
//                       <button
//                         onClick={handleSaveRating}
//                         className="px-4 py-2 bg-blue-500 text-white rounded-md"
//                       >
//                         Save
//                       </button>
//                     </div>
//                     </>
//                   )}
//                 </div>
//               </div>
//             )}

//           <div className="flex justify-end items-center space-x-4 p-2">
//             <button
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//               className="px-4 py-2 bg-blue-500 text-white rounded-md"
//             >
//               Previous
//             </button>
//             <span>{`Page ${currentPage} of ${totalPages}`}</span>
//             <button
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages}
//               className="px-4 py-2 bg-blue-500 text-white rounded-md"
//             >
//               Next
//             </button>
//           </div>
//           {showAppointmentModal && (  
//             <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50 p-4">
//               <div
//                 className="bg-white p-6 rounded-lg w-full max-w-xs sm:max-w-md md:max-w-lg lg:max-w-2xl xl:max-w-4xl max-h-[90vh] overflow-y-auto"
//                 style={{ zIndex: showRescheduleModal ? 49 : 50 }}
//               >
//                 {(() => {
//         const daysDifference = calculateDaysDifference(selectedAppointment.booking_date_time);
//         const isWithin15Days = daysDifference >= 0 && daysDifference <= 15;
//         const isPastBooking = new Date(selectedAppointment.booking_date_time) < new Date();

//         return (
//           <>
//             {/* Header */}
//             <div className="flex justify-between items-center">
//               <h2 className="text-xl font-semibold">Appointment Details</h2>
//               <button onClick={closeModal} className="text-red-500">
//                 <FaTimesCircle />
//               </button>
//             </div>
              

//                 {/* Mobile View (Cards) */}
//                 <div className="block sm:hidden">
//                   <div className="flex flex-col space-y-3 mt-4">
//                     <div>
//                       <strong>Order:</strong> {selectedAppointment.order_id}
//                     </div>
//                     <div>
//                       <strong>Service:</strong> {selectedAppointment.title}
//                     </div>
//                     <div>
//                       <strong>Booking Date & Time:</strong>{" "}
//                       {new Date(
//                         selectedAppointment?.booking_date_time
//                       ).toLocaleString()}
//                     </div>
//                     <div>
//                       <strong>More Details:</strong>
//                       <div className="space-y-1">
//                         <div>
//                           <strong>Method:</strong>{" "}
//                           {selectedAppointment.method_name}
//                         </div>
//                         <div>
//                           <strong>Units:</strong> {selectedAppointment.units}
//                         </div>
//                         <div>
//                           <strong>Add-ons:</strong> {selectedAppointment.addons}
//                         </div>
//                       </div>
//                     </div>
//                     <div>
//                       <strong>Status:</strong>{" "}
//                       {selectedAppointment.booking_status === "A"
//                         ? "Active"
//                         : selectedAppointment.booking_status === "RS"
//                         ? "Rescheduled"
//                         : selectedAppointment.booking_status === "C"
//                         ? "Confirm"
//                         : selectedAppointment.booking_status === "CO"
//                         ? "Completed"
//                         : selectedAppointment.booking_status === "CS"
//                         ? "Rejected By Provider"
//                         : selectedAppointment.booking_status === "R"
//                         ? `Rejected: ${
//                             selectedAppointment.reject_reason ||
//                             "No reason provided"
//                           }`
//                         : ""}
//                     </div>
//                     <div className="flex space-x-2">
//                     {selectedAppointment.booking_status === "A" && !isPastBooking && !isWithin15Days && (
//                           <>
//                             <button
//                               onClick={openRescheduleModal}
//                               className="text-yellow-500 flex items-center gap-2 p-2 border rounded-md hover:bg-yellow-100"
//                             >
//                               <FaEdit />
//                               Reschedule
//                             </button>
//                             <button
//                               onClick={handleCancel}
//                               className="text-red-500 flex items-center gap-2 p-2 border rounded-md hover:bg-red-100"
//                             >
//                               <FaTimesCircle />
//                               Cancel
//                             </button>
//                           </>
//                         )}
//                       {selectedAppointment.booking_status === "CO" && (
//                         <button className="text-green-500 flex items-center gap-2 p-2 border rounded-md hover:bg-green-100">
//                           <FaCheck /> Completed
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 {/* Tablet & Laptop View (Table) */}
//                 <div className="hidden sm:block mt-4">
//                   <div className="overflow-x-auto">
//                     <table className="w-full border-collapse border border-gray-300">
//                       <thead>
//                         <tr className="bg-gray-100">
//                           <th className="p-3 border text-left">Order</th>
//                           <th className="p-3 border text-left">Service</th>
//                           <th className="p-3 border text-left">
//                             Booking Date & Time
//                           </th>
//                           <th className="p-3 border text-left">More Details</th>
//                           <th className="p-3 border text-left">Status</th>
//                           <th className="p-3 border text-left">Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         <tr>
//                           <td className="p-3 border">
//                             {selectedAppointment.order_id}
//                           </td>
//                           <td className="p-3 border">
//                             {selectedAppointment.title}
//                           </td>
//                           <td className="p-3 border">
//                             {new Date(
//                               selectedAppointment?.booking_date_time
//                             ).toLocaleString()}
//                           </td>
//                           <td className="p-3 border">
//                             <div className="space-y-1">
//                               <div>
//                                 <strong>Method:</strong>{" "}
//                                 {selectedAppointment.method_name}
//                               </div>
//                               <div>
//                                 <strong>Units:</strong>{" "}
//                                 {selectedAppointment.units}
//                               </div>
//                               <div>
//                                 <strong>Add-ons:</strong>{" "}
//                                 {selectedAppointment.addons}
//                               </div>
//                             </div>
//                           </td>
//                           <td className="p-3 border">
//                             {selectedAppointment.booking_status === "A"
//                               ? "Active"
//                               : selectedAppointment.booking_status === "RS"
//                               ? "Rescheduled"
//                               : selectedAppointment.booking_status === "C"
//                               ? "Confirm"
//                               : selectedAppointment.booking_status === "CO"
//                               ? "Completed"
//                               : selectedAppointment.booking_status === "CS"
//                               ? "Rejected By Provider"
//                               : selectedAppointment.booking_status === "R"
//                               ? `Rejected: ${
//                                   selectedAppointment.reject_reason ||
//                                   "No reason provided"
//                                 }`
//                               : ""}
//                           </td>
//                           <td className="p-3 border">
//                             <div className="flex space-x-2">
//                             {selectedAppointment.booking_status === "A" && !isPastBooking && !isWithin15Days && (
//                                   <>
//                                     <button
//                                       onClick={openRescheduleModal}
//                                       className="text-yellow-500 flex items-center gap-2 p-2 border rounded-md hover:bg-yellow-100"
//                                     >
//                                       <FaEdit />
//                                       Reschedule
//                                     </button>
//                                     <button
//                                       onClick={handleCancel}
//                                       className="text-red-500 flex items-center gap-2 p-2 border rounded-md hover:bg-red-100"
//                                     >
//                                       <FaTimesCircle />
//                                       Cancel
//                                     </button>
//                                   </>
//                                 )}
//                               {selectedAppointment.booking_status === "CO" && (
//                                 <button className="text-green-500 flex items-center gap-2 p-2 border rounded-md hover:bg-green-100">
//                                   <FaCheck /> Completed
//                                 </button>
//                               )}
//                             </div>
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//                 </>
//               );
//             })()}
//               </div>
//             </div>
//           )}

//           {showCancelModal && (
//             <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-60">
//               <div className="bg-white p-6 rounded-lg sm:w-96 md:w-[400px] lg:w-[500px]">
//                 <div className="flex justify-between items-center">
//                   <h2 className="text-xl font-semibold">Cancel Appointment</h2>
//                   <button
//                     onClick={() => setShowCancelModal(false)}
//                     className="text-red-500"
//                   >
//                     <FaTimesCircle />
//                   </button>
//                 </div>
//                 <div className="mt-4">
//                   <label className="block">Cancellation Reason</label>
//                   <textarea
//                     className="w-full p-2 border border-gray-300 rounded-md mb-4"
//                     placeholder="Enter cancellation reason..."
//                     value={cancelReason}
//                     onChange={(e) => setCancelReason(e.target.value)}
//                   />
//                   <div className="flex justify-end">
//                     <button
//                       onClick={() => {
//                         handleSaveCancel();
//                       }}
//                       className="bg-green-500 text-white py-2 px-4 rounded-md mr-2"
//                     >
//                       Save
//                     </button>
//                     <button
//                       onClick={() => setShowCancelModal(false)}
//                       className="bg-gray-300 text-black py-2 px-4 rounded-md"
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//           {showEditServiceModal && (
//             <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
//               <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl h-auto max-h-[90vh] overflow-y-auto">
//                 <div className="sticky top-0 bg-white z-10 px-6 py-4 border-b flex justify-between items-center">
//                   <h2 className="text-xl font-semibold text-gray-800">
//                     Edit Booking
//                   </h2>
//                   <button
//                     onClick={handleClosebookingSummary}
//                     className="text-gray-500 hover:text-gray-700 transition-colors p-2 rounded-full hover:bg-gray-100"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="24"
//                       height="24"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     >
//                       <line x1="18" y1="6" x2="6" y2="18"></line>
//                       <line x1="6" y1="6" x2="18" y2="18"></line>
//                     </svg>
//                   </button>
//                 </div>

//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 p-6">
//                   {/* Left Column - Booking Form */}
//                   <div className="lg:col-span-2">
//                     <form onSubmit={handleSubmit} className="space-y-6">
//                       {/* Service Selection Panel */}
//                       <div className="bg-white rounded-lg shadow-md border border-gray-100">
//                         <div
//                           className="flex justify-between items-center bg-gradient-to-r from-blue-500 to-blue-600 p-4 rounded-t-lg cursor-pointer text-white"
//                           onClick={toggleServicePanel}
//                         >
//                           <h3 className="font-medium">Choose Services</h3>
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             width="20"
//                             height="20"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="2"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           >
//                             <polyline points="6 9 12 15 18 9"></polyline>
//                           </svg>
//                         </div>

//                         <div className="p-4">
//                           {/* Services Grid */}
//                           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
//                             {services?.map((service) => (
//                               <div
//                                 key={service.service_id}
//                                 onClick={() => {
//                                   if (service.service_id) {
//                                     setSelectedService(service.service_id);
//                                   } else {
//                                     console.error(
//                                       "Service ID is missing",
//                                       service
//                                     );
//                                   }
//                                 }}
//                                 className={`cursor-pointer border rounded-lg overflow-hidden shadow-sm transition-all duration-200 hover:shadow-md ${
//                                   userSelectedMethods.includes(
//                                     service.service_id
//                                   )
//                                     ? "ring-2 ring-blue-400"
//                                     : ""
//                                 } ${
//                                   selectedService === service.service_id
//                                     ? "ring-2 ring-blue-500 transform scale-[1.02]"
//                                     : ""
//                                 }`}
//                               >
//                                 <div className="relative">
//                                   <img
//                                     src={service?.service_image}
//                                     className="w-full h-32 object-cover"
//                                     // alt={service?.service_title || "Service"}
//                                   />
//                                   <div className="absolute inset-0 flex items-center justify-center text-white font-medium bg-black bg-opacity-40 text-center p-2">
//                                     {service?.service_title}
//                                   </div>
//                                 </div>
//                               </div>
//                             ))}
//                           </div>

//                           {/* Selected Service Details */}
//                           {selectedService && (
//                             <div className="mt-6 space-y-6">
//                               {services
//                                 .filter((s) => s.service_id === selectedService)
//                                 ?.map((service) => (
//                                   <div key={service.service_id}>
//                                     {/* Units Section */}
//                                     {service.units &&
//                                       service.units.length > 0 && (
//                                         <div className="bg-gray-50 p-4 rounded-lg mb-6">
//                                           <h3 className="font-medium text-gray-700 mb-4">
//                                             Units
//                                           </h3>
//                                           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                             {service.units?.map((unit) => (
//                                               <div
//                                                 key={unit.units_id}
//                                                 className="flex items-center space-x-4"
//                                               >
//                                                 <div className="w-full">
//                                                   <div className="flex items-center space-x-2 mb-2">
//                                                     <label className="block font-medium text-gray-700">
//                                                       {unit.unit_title}
//                                                     </label>
//                                                     <img
//                                                       src={Bed}
//                                                       className="w-5 h-5"
//                                                       alt="Unit Icon"
//                                                     />
//                                                   </div>
//                                                   <select
//                                                     className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 bg-white"
//                                                     value={
//                                                       bedroom[unit.units_id] ||
//                                                       unit.unit_min
//                                                     }
//                                                     onChange={(e) =>
//                                                       handleBedroomChange(
//                                                         unit.units_id,
//                                                         parseInt(e.target.value)
//                                                       )
//                                                     }
//                                                   >
//                                                     {Array.from(
//                                                       {
//                                                         length:
//                                                           unit.unit_max -
//                                                           unit.unit_min +
//                                                           1,
//                                                       },
//                                                       (_, i) => (
//                                                         <option
//                                                           key={
//                                                             i + unit.unit_min
//                                                           }
//                                                           value={
//                                                             i + unit.unit_min
//                                                           }
//                                                         >
//                                                           {i}
//                                                         </option>
//                                                       )
//                                                     )}
//                                                   </select>
//                                                 </div>
//                                               </div>
//                                             ))}
//                                           </div>
//                                         </div>
//                                       )}

//                                     {/* Methods Section */}
//                                     {service.methods &&
//                                       service.methods.length > 0 && (
//                                         <div className="space-y-6">
//                                           <div>
//                                             <h3 className="font-medium text-gray-700 mb-3">
//                                               Methods
//                                             </h3>
//                                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//                                               {service.methods?.map(
//                                                 (method) => (
//                                                   <button
//                                                     type="button"
//                                                     key={method.method_id}
//                                                     onClick={() => {
//                                                       handleMethodSelection(
//                                                         method,
//                                                         method.method_id
//                                                       );
//                                                     }}
//                                                     className={`p-3 border rounded-lg text-center transition-all duration-200 ${
//                                                       (selectedMethod &&
//                                                         selectedMethod.method_id ===
//                                                           method.method_id) ||
//                                                       userSelectedMethodsId.includes(
//                                                         method.method_id
//                                                       )
//                                                         ? "bg-blue-500 text-white border-blue-500 shadow-md"
//                                                         : "bg-white hover:bg-blue-50 border-gray-200"
//                                                     }`}
//                                                   >
//                                                     {method?.method_title}
//                                                   </button>
//                                                 )
//                                               )}
//                                             </div>
//                                           </div>
//                                           {/* {selectedMethod && (
//                                             <div className="mt-6">
//                                               {selectedMethod.submethods &&
//                                               selectedMethod.submethods.length >
//                                                 0 ? (
//                                                 <div className="space-y-4">
//                                                   <h3 className="font-medium text-gray-700">
//                                                     Options
//                                                   </h3>
//                                                   {selectedMethod.submethods.map(
//                                                     (submethod) => (
//                                                       <div
//                                                         key={submethod.unit_id}
//                                                         className={`${
//                                                           userSelectedMethodsUnitsId.includes(
//                                                             submethod.unit_id
//                                                           )
//                                                             ? "border-blue-200 bg-blue-50"
//                                                             : "border-gray-200"
//                                                         } p-4 border rounded-lg shadow-sm transition-all duration-300`}
//                                                       >
//                                                         <h4 className="font-medium text-gray-700 mb-3">
//                                                           {submethod.unit_title} (₹{submethod.unit_price})
//                                                         </h4>

//                                                         <div className="mb-4">
//                                                           <label className="block font-medium mb-2">
//                                                             Select Quantity
//                                                           </label>
//                                                           <select
//                                                             className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                             onChange={(e) => {
//                                                               const quantity =
//                                                                 parseInt(
//                                                                   e.target
//                                                                     .value,
//                                                                   10
//                                                                 );
//                                                               addItemToBill(
//                                                                 submethod.unit_id,
//                                                                 submethod.unit_title,
//                                                                 quantity,
//                                                                 submethod.unit_price
//                                                               );
//                                                             }}
//                                                           >
//                                                             <option value="">
//                                                               Select Quantity
//                                                             </option>
//                                                             {[
//                                                               ...Array(
//                                                                 submethod.unit_max -
//                                                                   submethod.unit_min +
//                                                                   1
//                                                               ).keys(),
//                                                             ].map((qty) => {
//                                                               const quantity =
//                                                                 1 + qty;
//                                                               return (
//                                                                 <option
//                                                                   key={quantity}
//                                                                   value={
//                                                                     quantity
//                                                                   }
//                                                                 >
//                                                                   {quantity}
//                                                                 </option>
//                                                               );
//                                                             })}
//                                                           </select>
//                                                         </div>
                                                      
//                                                       </div>
//                                                     )
//                                                   )}
//                                                 </div>
//                                               ) : (
//                                                 <p className="text-gray-500 italic">
//                                                   No options available for this
//                                                   method.
//                                                 </p>
//                                               )}
//                                             </div>
//                                           )} */}
//                                          {selectedMethod && (
//                                           <div className="mt-6">
//                                             {selectedMethod.submethods && selectedMethod.submethods.length > 0 ? (
//                                               <div className="space-y-4">
//                                                 <h3 className="font-medium text-gray-700">Options</h3>
//                                                 {selectedMethod.submethods.map((submethod) => {
//                                                   const bookedItem = bookingBill.find(
//                                                     (item) => item.units_id === submethod.unit_id && item.type === "method_units"
//                                                   );
//                                                   return (
//                                                     <div
//                                                       key={submethod.unit_id}
//                                                       className={`${
//                                                         userSelectedMethodsUnitsId.includes(submethod.unit_id)
//                                                           ? "border-blue-200 bg-blue-50"
//                                                           : "border-gray-200"
//                                                       } p-4 border rounded-lg shadow-sm transition-all duration-300`}
//                                                     >
//                                                       <h4 className="font-medium text-gray-700 mb-3">
//                                                         {submethod.unit_title} (₹{submethod.unit_price})
//                                                       </h4>
//                                                       <div className="mb-4">
//                                                         <label className="block font-medium mb-2">Select Quantity</label>
//                                                         <select
//                                                           className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                           value={bookedItem?.s_m_qty || ""}
//                                                           onChange={(e) => {
//                                                             const quantity = parseInt(e.target.value, 10) || 0;
//                                                             addItemToBill(
//                                                               submethod.unit_id,
//                                                               submethod.unit_title,
//                                                               quantity,
//                                                               submethod.unit_price
//                                                             );
//                                                           }}
//                                                         >
//                                                           <option value="">Select Quantity</option>
//                                                           {[...Array(submethod.unit_max - submethod.unit_min + 1).keys()].map(
//                                                             (qty) => {
//                                                               const quantity = qty + 1;
//                                                               return (
//                                                                 <option key={quantity} value={quantity}>
//                                                                   {quantity}
//                                                                 </option>
//                                                               );
//                                                             }
//                                                           )}
//                                                         </select>
//                                                       </div>
//                                                     </div>
//                                                   );
//                                                 })}
//                                               </div>
//                                             ) : (
//                                               <p className="text-gray-500 italic">No options available for this method.</p>
//                                             )}
//                                           </div>
//                                         )}
//                                         </div>
//                                       )}

//                                     {/* Add-ons Section */}
//                                     {/* {selectedMethod &&
//                                       service.addons?.length > 0 && (
//                                         <div className="mt-8">
//                                           <h3 className="font-medium text-gray-700 mb-4">
//                                             Add-ons
//                                           </h3>
//                                           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//                                             {service.addons.map(
//                                               (addon, index) => (
//                                                 <div
//                                                   key={addon.addon_id}
//                                                   className={`border rounded-lg overflow-hidden shadow-sm transition-all duration-200 ${
//                                                     userSelectedAddon.includes(
//                                                       addon.addon_id
//                                                     )
//                                                       ? "border-blue-300 bg-blue-50"
//                                                       : "border-gray-200 bg-white hover:border-blue-200"
//                                                   }`}
//                                                   onClick={() =>
//                                                     handleAddonSelection(
//                                                       addon.addon_id
//                                                     )
//                                                   }
//                                                 >
//                                                   <div className="p-4">
//                                                     <div className="text-center mb-3">
//                                                       <p className="font-medium text-gray-800">
//                                                         {addon.addon_name}
//                                                       </p>
//                                                     </div>
//                                                     <div className="text-center mb-4">
//                                                       <p className="text-blue-600 font-medium">
//                                                         ₹{addon.addon_price}
//                                                       </p>
//                                                     </div>

//                                                     <div className="flex items-center justify-center gap-3">
//                                                       <button
//                                                         type="button"
//                                                         onClick={(e) => {
//                                                           e.stopPropagation();
//                                                           handleQuantityChange(
//                                                             index,
//                                                             false,
//                                                             addon.addon_name,
//                                                             addon.addon_price,
//                                                             addon.addon_maxqty
//                                                           );
//                                                         }}
//                                                         className="p-1 w-8 h-8 flex items-center justify-center bg-red-100 text-red-600 rounded-full hover:bg-red-200 transition-colors"
//                                                       >
//                                                         -
//                                                       </button>
//                                                       <span className="text-lg font-medium w-8 text-center">
//                                                         {quantities[index]}
//                                                       </span>
//                                                       <button
//                                                         type="button"
//                                                         onClick={(e) => {
//                                                           e.stopPropagation();
//                                                           handleQuantityChange(
//                                                             index,
//                                                             true,
//                                                             addon.addon_name,
//                                                             addon.addon_price,
//                                                             addon.addon_maxqty
//                                                           );
//                                                         }}
//                                                         className="p-1 w-8 h-8 flex items-center justify-center bg-green-100 text-green-600 rounded-full hover:bg-green-200 transition-colors"
//                                                       >
//                                                         +
//                                                       </button>
//                                                     </div>
//                                                   </div>
//                                                 </div>
//                                               )
//                                             )}
//                                           </div>
//                                         </div>
//                                       )} */}
//                                       {selectedMethod && service.addons?.length > 0 && (
//                                         <div className="mt-8">
//                                           <h3 className="font-medium text-gray-700 mb-4">Add-ons</h3>
//                                           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//                                             {service.addons.map((addon, index) => (
//                                               <div
//                                                 key={addon.addon_id}
//                                                 className={`border rounded-lg overflow-hidden shadow-sm transition-all duration-200 ${
//                                                   userSelectedAddon.includes(addon.addon_id)
//                                                     ? "border-blue-300 bg-blue-50"
//                                                     : "border-gray-200 bg-white hover:border-blue-200"
//                                                 }`}
//                                                 onClick={() => handleAddonSelection(addon.addon_id)}
//                                               >
//                                                 <div className="p-4">
//                                                   <div className="text-center mb-3">
//                                                     <p className="font-medium text-gray-800">{addon.addon_name}</p>
//                                                   </div>
//                                                   <div className="text-center mb-4">
//                                                     <p className="text-blue-600 font-medium">₹{addon.addon_price}</p>
//                                                   </div>
//                                                   <div className="flex items-center justify-center gap-3">
//                                                     <button
//                                                       type="button"
//                                                       onClick={(e) => {
//                                                         e.stopPropagation();
//                                                         handleQuantityChange(
//                                                           index,
//                                                           false,
//                                                           addon.addon_name,
//                                                           addon.addon_price,
//                                                           addon.addon_maxqty
//                                                         );
//                                                       }}
//                                                       className="p-1 w-8 h-8 flex items-center justify-center bg-red-100 text-red-600 rounded-full hover:bg-red-200 transition-colors"
//                                                     >
//                                                       -
//                                                     </button>
//                                                     <span className="text-lg font-medium w-8 text-center">
//                                                       {quantities[index]}
//                                                     </span>
//                                                     <button
//                                                       type="button"
//                                                       onClick={(e) => {
//                                                         e.stopPropagation();
//                                                         handleQuantityChange(
//                                                           index,
//                                                           true,
//                                                           addon.addon_name,
//                                                           addon.addon_price,
//                                                           addon.addon_maxqty
//                                                         );
//                                                       }}
//                                                       className="p-1 w-8 h-8 flex items-center justify-center bg-green-100 text-green-600 rounded-full hover:bg-green-200 transition-colors"
//                                                     >
//                                                       +
//                                                     </button>
//                                                   </div>
//                                                 </div>
//                                               </div>
//                                             ))}
//                                           </div>
//                                         </div>
//                                       )}
                                                                
//                               {selectedAppointment && (
//                                 <div className="mt-8">
//                                   <h3 className="font-medium text-gray-700 mb-4">Select Provider</h3>
//                                   <div className="flex flex-wrap gap-4">
//                                     {selectedAppointment.staff_ids && selectedAppointment.staff_names ? (
//                                       selectedAppointment.staff_ids.split(",").map((id, index) => (
//                                         <div key={id} className="text-center">
//                                           <div className="w-20 h-20 bg-blue-500 text-white rounded-full flex items-center justify-center text-xl font-semibold">
//                                           Provider
//                                           </div>
//                                           <p className="mt-2 text-gray-700">
//                                             {selectedAppointment.staff_names.split(",")[index] || "N/A"}
//                                           </p>
//                                         </div>
//                                       ))
//                                     ) : (
//                                       <p className="text-gray-500 italic">No staff assigned.</p>
//                                     )}
//                                   </div>
//                                 </div>
//                               )}
//                                   </div>
//                                 ))}
//                             </div>
//                           )}

//                           {/* Frequency Selection */}
//                         </div>
//                       </div>

//                       {/* Submit Button */}
//                       <div className="flex justify-center">
//                         <button
//                           type="submit"
//                           className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition duration-200 shadow-md hover:shadow-lg"
//                         >
//                           Submit Booking
//                         </button>
//                       </div>
//                     </form>
//                   </div>

//                   {/* Right Column - Booking Summary */}
//                   <div className="lg:col-span-1">
//                     <div className="bg-white border rounded-lg shadow-lg p-6 sticky top-24">
//                       <h2 className="text-lg font-bold text-gray-800 border-b pb-3 mb-4">
//                         Booking Summary
//                       </h2>

//                       {/* Date and Time */}
//                       <div className="space-y-4 mb-6">
//                         <div className="flex items-center text-sm text-gray-600">
//                           <div className="flex items-center space-x-2">
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               width="18"
//                               height="18"
//                               viewBox="0 0 24 24"
//                               fill="none"
//                               stroke="currentColor"
//                               strokeWidth="2"
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                             >
//                               <rect
//                                 x="3"
//                                 y="4"
//                                 width="18"
//                                 height="18"
//                                 rx="2"
//                                 ry="2"
//                               ></rect>
//                               <line x1="16" y1="2" x2="16" y2="6"></line>
//                               <line x1="8" y1="2" x2="8" y2="6"></line>
//                               <line x1="3" y1="10" x2="21" y2="10"></line>
//                             </svg>
//                             <span className="font-medium text-gray-700">
//                               Date & Time:
//                             </span>
//                             <div>
//                               {selectedDate && selectedTime ? (
//                                 <p>
//                                   {selectedDate} @ {selectedTime}
//                                 </p>
//                               ) : allsetdata?.booking_date_time ? (
//                                 <p>{allsetdata?.booking_date_time}</p>
//                               ) : (
//                                 <p className="text-gray-400 italic">
//                                   Not selected
//                                 </p>
//                               )}
//                             </div>
//                           </div>
//                         </div>

//                         {/* Frequency */}
//                         <div className="flex items-center text-sm text-gray-600">
//                           <div className="flex items-center space-x-2">
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               width="18"
//                               height="18"
//                               viewBox="0 0 24 24"
//                               fill="none"
//                               stroke="currentColor"
//                               strokeWidth="2"
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                             >
//                               <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
//                             </svg>
//                             <span className="font-medium text-gray-700">
//                               Frequency:
//                             </span>
//                             <p>
//                               {allsetdata?.discount_typename
//                                 ? allsetdata?.discount_typename
//                                 : selectedFrequency
//                                 ? selectedFrequency
//                                 : "N/A"}
//                             </p>
//                           </div>
//                         </div>

//                         {/* Duration */}
//                         <div className="flex items-center text-sm text-gray-600">
//                           <div className="flex items-center space-x-2">
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               width="18"
//                               height="18"
//                               viewBox="0 0 24 24"
//                               fill="none"
//                               stroke="currentColor"
//                               strokeWidth="2"
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                             >
//                               <circle cx="12" cy="12" r="10"></circle>
//                               <polyline points="12 6 12 12 16 14"></polyline>
//                             </svg>
//                             <span className="font-medium text-gray-700">
//                               Duration:{" "}
//                               {allsetdata?.order_duration
//                                 ? `${Math.round(
//                                     allsetdata?.order_duration / 60
//                                   )} Hours`
//                                 : "-"}
//                             </span>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Cart Items */}
//                       {/* <div className="mb-6">
//                         <h3 className="font-bold text-gray-800 mb-3">
//                           Cart Items:
//                         </h3>
//                         {bookingBill.length === 0 ? (
//                           <div>
                        
//                             <div className="flex items-center text-sm text-gray-600">
//                               <div className="flex items-center space-x-2">
//                                 <span className="font-medium text-gray-700">
//                                   Service:
//                                 </span>
//                                 <p>
//                                   {allsetdata?.service_title
//                                     ? allsetdata?.service_title
//                                     : "N/A"}
//                                 </p>
//                               </div>
//                             </div>

                        
//                             <div className="flex items-center text-sm text-gray-600">
//                               <div className="flex items-center space-x-2">
//                                 <span className="font-medium text-gray-700">
//                                   Method:
//                                 </span>
//                                 <p>
//                                   {allsetdata?.method_title
//                                     ? allsetdata?.method_title
//                                     : "N/A"}
//                                 </p>
//                               </div>
//                             </div>

                          
//                             <div className="flex items-center text-sm text-gray-600">
//                               <div className="flex items-center space-x-2">
//                                 <span className="font-medium text-gray-700">
//                                   Units:
//                                 </span>
//                                 <p>
//                                   {allsetdata?.units_title
//                                     ? allsetdata?.units_title
//                                     : "N/A"}
//                                 </p>
//                               </div>
//                             </div>
//                             <div className="flex items-center text-sm text-gray-600">
//                               <div className="flex items-center space-x-2">
//                                 <span className="font-medium text-gray-700">
//                                   Addon:
//                                 </span>
//                                 <p>
//                                   {allsetdata?.addon_service_name
//                                     ? allsetdata?.addon_service_name
//                                     : "N/A"}
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                         ) : (
//                           <ul className="space-y-2">
//                             {bookingBill?.map((item, idx) => (
//                               <li
//                                 key={idx}
//                                 className="flex justify-between items-center py-2 border-b border-gray-100"
//                               >
//                                 <span className="text-gray-700">
//                                 {item.name} 
//                                 </span>
//                                 <span className="text-gray-700">
//                                   {item.type}
//                                   <span className="text-gray-500 text-sm">
//                                     (x{item.s_m_qty})
//                                   </span>
//                                 </span>

//                                 <div className="flex gap-4">
//                                   <span> ₹{item.s_m_rate}</span>
//                                   <span
//                                     onClick={() => removeItem(idx)}
//                                     className="text-red-500 cursor-pointer"
//                                   >
//                                     X
//                                   </span>
//                                 </div>
//                               </li>
//                             ))}
//                           </ul>
//                         )}
//                       </div> */}
//                       {/* <div className="mb-6">
//                                 <h3 className="font-bold text-gray-800 mb-3">Cart Items:</h3>
//                                 {bookingBill.length === 0 ? (
//                                   <div>
//                                     <div className="flex items-center text-sm text-gray-600">
//                                       <div className="flex items-center space-x-2">
//                                         <span className="font-medium text-gray-700">Service:</span>
//                                         <p>{allsetdata?.service_title ? allsetdata?.service_title : "N/A"}</p>
//                                       </div>
//                                     </div>
//                                     <div className="flex items-center text-sm text-gray-600">
//                                       <div className="flex items-center space-x-2">
//                                         <span className="font-medium text-gray-700">Method:</span>
//                                         <p>{allsetdata?.method_title ? allsetdata?.method_title : "N/A"}</p>
//                                       </div>
//                                     </div>
//                                     <div className="flex items-center text-sm text-gray-600">
//                                       <div className="flex items-center space-x-2">
//                                         <span className="font-medium text-gray-700">Units:</span>
//                                         <p>{allsetdata?.units_title ? allsetdata?.units_title : "N/A"}</p>
//                                       </div>
//                                     </div>
//                                     <div className="flex items-center text-sm text-gray-600">
//                                       <div className="flex items-center space-x-2">
//                                         <span className="font-medium text-gray-700">Addon:</span>
//                                         <p>{allsetdata?.addon_service_name ? allsetdata?.addon_service_name : "N/A"}</p>
//                                       </div>
//                                     </div>
//                                   </div> */}
//                               <div className="mb-6">
//                                 <h3 className="font-bold text-gray-800 mb-3">Cart Items:</h3>
//                                 {bookingBill.length === 0 ? (
//                                   <div>
//                                     <div className="flex items-center text-sm text-gray-600">
//                                       <span className="font-medium text-gray-700">Service:</span>
//                                       <p>{allsetdata?.service_id || "N/A"}</p>
//                                     </div>
//                                     {allsetdata?.cart_items?.map((item, idx) => (
//                                       <div key={idx} className="flex items-center text-sm text-gray-600">
//                                         <span className="font-medium text-gray-700">
//                                           {item.type === "method_units" ? "Method" : "Addon"}:
//                                         </span>
//                                         <p>{item.method_name || "N/A"} (x{item.s_m_qty}) - ₹{item.s_m_rate}</p>
//                                       </div>
//                                     ))}
//                                   </div>
//                                 ) : (
//                               //     <ul className="space-y-2">
//                               //       {bookingBill?.map((item, idx) => (
//                               //         <li
//                               //           key={idx}
//                               //           className="flex justify-between items-center py-2 border-b border-gray-100"
//                               //         >
//                               //           <span className="text-gray-700">{item.name}</span>
//                               //           <span className="text-gray-700">
//                               //             <span className="text-gray-500 text-sm">(x{item.s_m_qty})</span>
//                               //           </span>
//                               //           <div className="flex gap-4">
//                               //             <span>₹{item.s_m_rate}</span>
//                               //             <span
//                               //               onClick={() => removeItem(idx)}
//                               //               className="text-red-500 cursor-pointer"
//                               //             >
//                               //               X
//                               //             </span>
//                               //           </div>
//                               //         </li>
//                               //       ))}
//                               //     </ul>
//                               //   )}
//                               // </div>
//                               <ul className="space-y-2">
//                               {bookingBill.map((item, idx) => (
//                                 <li
//                                   key={idx}
//                                   className="flex justify-between items-center py-2 border-b border-gray-100"
//                                 >
//                                   <span className="text-gray-700">{item.name}</span>
//                                   <span className="text-gray-700">
//                                     <span className="text-gray-500 text-sm">(x{item.s_m_qty})</span>
//                                   </span>
//                                   <div className="flex gap-4">
//                                     <span>₹{item.s_m_rate}</span>
//                                     <span onClick={() => removeItem(idx)} className="text-red-500 cursor-pointer">
//                                       X
//                                     </span>
//                                   </div>
//                                 </li>
//                               ))}
//                             </ul>
//                           )}
//                         </div>

//                       {/* Pricing Summary */}
//                       {/* <div className="border-t pt-4 text-gray-700">
//                         <div className="flex justify-between mb-2">
//                           <p>Sub Total:</p>
//                           <p className="font-medium">
//                             ₹{allsetdata?.amount?.replace(/[^0-9.]/g, "")} + ₹
//                             {parseFloat(text)}
//                           </p>
//                         </div>

//                         <div className="flex justify-between mb-4">
//                           <p>Frequency Discount:</p>
//                           <p className="font-medium">-{discountedTotal}</p>
//                         </div>
//                         <div className="flex justify-between mb-4">
//                           <p>Tax:</p>
//                           <p className="font-medium">{allsetdata?.cart_tax}</p>
//                         </div>

//                         <div className="flex justify-between font-bold text-lg text-blue-800 pt-2 border-t">
//                           <p>Total:</p>
//                           <p>₹ */}
//                             {/* {parseFloat(
//                               allsetdata.total_amount.replace(/[^0-9.]/g, "")) + parseFloat(text)} */}
//                             {/* {finelamount}
//                           </p>
//                         </div> */}
//                         {/* </div> */}
//                       {/* </div> */}
//                       <div className="border-t pt-4 text-gray-700">
//                       <div className="flex justify-between mb-2">
//                         <p>Sub Total:</p>
//                         <p className="font-medium">₹{subtotale.toFixed(2)}</p>
//                       </div>
//                       <div className="flex justify-between mb-2">
//                         <p>Discount:</p>
//                         <p className="font-medium">-₹{discountedTotal.toFixed(2)}</p>
//                       </div>
//                       <div className="flex justify-between mb-4">
//                         <p>Tax:</p>
//                         <p className="font-medium">₹{tax.toFixed(2)}</p>
//                       </div>
//                       <div className="flex justify-between font-bold text-lg text-blue-800 pt-2 border-t">
//                         <p>Total:</p>
//                         <p>₹{finelamount.toFixed(2)}</p>
//                       </div>
//                     </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Cancel Recurrence Modal */}
//           {showCancelRecurrence && (
//             <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 p-4">
//               <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
//                 <div className="flex justify-between items-center mb-4">
//                   <h2 className="text-xl font-semibold text-gray-800">
//                     Cancel Recurrence?
//                   </h2>
//                   <button
//                     onClick={() => closeCancelRecurrencePopup(false)}
//                     className="text-gray-500 hover:text-red-500 transition-colors"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="20"
//                       height="20"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     >
//                       <circle cx="12" cy="12" r="10"></circle>
//                       <line x1="15" y1="9" x2="9" y2="15"></line>
//                       <line x1="9" y1="9" x2="15" y2="15"></line>
//                     </svg>
//                   </button>
//                 </div>
//                 <div className="mt-2 mb-6">
//                   <p className="text-gray-600">
//                     Are you sure you want to cancel the recurrence of this
//                     appointment?
//                   </p>
//                 </div>
//                 <div className="flex justify-end gap-3">
//                   <button
//                     onClick={() => setShowCancelRecurrence(false)}
//                     className="bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-4 rounded-lg transition-colors"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={() => {
//                       handleCancelRecurrence();
//                     }}
//                     className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg shadow-sm hover:shadow-md transition-all"
//                   >
//                     Confirm
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Reschedule Modal */}
//           {showRescheduleModal && (
//             <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 p-4">
//               <div className="bg-white rounded-xl shadow-xl max-w-lg w-full p-6">
//                 <div className="flex justify-between items-center mb-6">
//                   <h2 className="text-xl font-semibold text-gray-800">
//                     Reschedule Appointment
//                   </h2>
//                   <button
//                     onClick={closeModal}
//                     className="text-gray-500 hover:text-red-500 transition-colors"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="20"
//                       height="20"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     >
//                       <circle cx="12" cy="12" r="10"></circle>
//                       <line x1="15" y1="9" x2="9" y2="15"></line>
//                       <line x1="9" y1="9" x2="15" y2="15"></line>
//                     </svg>
//                   </button>
//                 </div>

//                 <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Amount
//                   </label>
//                   <input
//                     type="text"
//                     className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
//                     placeholder="Amount"
//                     value={amount} // Display the fetched amount
//                     onChange={(e) => setAmount(e.target.value)} // Allow user to modify if needed
//                     disabled // Disable input since this value is fetched from the API  
//                   />
//                 </div>

//                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-1">
//                         Select Date
//                       </label>
//                       <input
//                         type="date"
//                         className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
//                         value={date}
//                         onChange={(e) => {
//                           setDate(e.target.value);
//                         }}
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-1">
//                         Select Time
//                       </label>
//                       <input
//                         type="time"
//                         className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
//                         value={time}
//                         onChange={(e) => {
//                           setTime(e.target.value);
//                         }}
//                       />
//                     </div>
//                   </div>

//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Note
//                     </label>
//                     <textarea
//                       className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 min-h-24"
//                       placeholder="Write a note..."
//                       value={notes}
//                       onChange={(e) => setNote(e.target.value)}
//                     ></textarea>
//                   </div>

//                   <div className="flex justify-end mt-6">
//                     <button
//                       onClick={() => {
//                         handleUpdate();
//                       }}
//                       className="bg-green-600 hover:bg-green-700 text-white py-2 px-6 rounded-lg shadow-sm hover:shadow-md transition-all"
//                     >
//                       Update
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }
// export default AppointmentS;








// import React, { useState, useEffect, useRef } from "react";
// import {FaEye,FaEdit,FaDownload,FaTimes,FaTimesCircle,FaCheck,FaStar, FaStarHalfAlt,FaRegStar,} from "react-icons/fa";
// import image1 from "../assets/house.png";
// import { CiSearch } from "react-icons/ci";
// import { jsPDF } from "jspdf";
// import * as XLSX from "xlsx";
// import { useNavigate } from "react-router-dom";
// import Bed from "../assets/beds.png";
// import "jspdf-autotable"; // Import the autotable plugin
// import { FaFileExcel, FaFilePdf } from "react-icons/fa";
// import axios from "axios"; // Import axios
// import { BaseUrl } from "../App";
// 
// import { Circles } from "react-loader-spinner";

// function AppointmentS() {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [entriesPerPage, setEntriesPerPage] = useState(10);
//   const [showAppointmentModal, setShowAppointmentModal] = useState(false);
//   const [showRescheduleModal, setShowRescheduleModal] = useState(false);
//   const [selectedAppointment, setSelectedAppointment] = useState(null);
//   console.log(selectedAppointment);
//   const [abcdiscountedTotal, setdiscountedTotal] = useState(null);
//   const [abcfinelamount, setfinelamount] = useState(null);
//   const [abctotelamount, settotelamount] = useState(null);
//   const [order_id_appointment, setorder_id_appointment] = useState(0);
//   const [showCancelModal, setShowCancelModal] = useState(false);
//   const [cancelReason, setCancelReason] = useState("");
//   const [totalTime, setTotalTime] = useState(0); // To track total time
//   const [showCancelRecurrence, setShowCancelRecurrence] = useState(false);
//   const [isServiceOpen, setIsServiceOpen] = useState(false); // Toggle "Choose Services"
//   const [isCalendarOpen, setIsCalendarOpen] = useState(false);
//   const [isFormOpen, setIsFormOpen] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [selectedTime, setSelectedTime] = useState(null);
//   const [selectedFrequency, setSelectedFrequency] = useState("Weekly");
//   const [officeresidential, setofficeResidential] = useState(false);
//   const [officecommercial, officesetCommercial] = useState(false);
//   const [showEditServiceModal, setShowEditServiceModal] = useState(false);
//   const [residential, setResidential] = useState(false);
//   const [commercial, setCommercial] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [ratings, setRatings] = useState();
//   const [appointments, setAppointments] = useState([]);
//   const [selectedDiscount, setSelectedDiscount] = useState(0);
//   const [text, setText] = useState();
//   const [showBookingSummary, setShowBookingSummary] = useState(false);
//   const [showBookingSummary2, setShowBookingSummary2] = useState(false);
//   const [editdataid, seteditdataid] = useState();
//   console.log(editdataid);
//   const [services, setServices] = useState([]);
//   const [damagedFloors, setDamagedFloors] = useState(0);
//   const [doorJams, setDoorJams] = useState(0);
//   const [packing, setPacking] = useState(0);
//   const [storeroom, setStoreroom] = useState(0);
//   const [selectedservices, setselectedservices] = useState(0);
//   const [area, setArea] = useState(0);
//   const [officearea, setOfficeArea] = useState(0);
//   const [extraDamagedFloors, setExtraDamagedFloors] = useState(0);
//   const [extraDoorJams, setExtraDoorJams] = useState(0);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [error, setError] = useState("");
//   const [Disamount, setDisamount] = useState(0);
//   const [officeextraDamagedFloors, setofficeExtraDamagedFloors] = useState(0);
//   const [officeextraDoorJams, setofficeExtraDoorJams] = useState(0);
//   const [showImageSection, setShowImageSection] = useState(false);
//   const [selectedService, setSelectedService] = useState(null);
//   const [bookingBill, setBookingBill] = useState([]);
//   const [bedroom, setBedroom] = useState(0);
//   const [bathroom, setBathroom] = useState(0);
//   const [tax, settax] = useState(0);
//   const [quantities, setQuantities] = useState([0, 0, 0]);
//   const [selectedMethod, setSelectedMethod] = useState(null);
//   const [maintotelamount, setmaintotelamount] = useState(0);
//   const [userDetails, setUserDetails] = useState(null);
//   const [bookingappointment, setbookingappointment] = useState([]);
//   const [subtotale, setsubtotale] = useState(0);
//   const [adminData, setAdminData] = useState(null);
//   const [userSelectedMethods, setUserSelectedMethods] = useState(null);
//   const [userSelectedMethodsId, setUserSelectedMethodsId] = useState(null);
//   const [userSelectedMethodsUnitsId, setUserSelectedMethodsUnitsId] =
//     useState(null);
//   const [userSelectedMethodsSmqty, setUserSelectedMethodsSmqty] =
//     useState(null);
//   const [isRatingModalOpen, setIsRatingModalOpen] = useState(false);
//   const [showRatingModal, setShowRatingModal] = useState(false);
//   const [rating, setRating] = useState(0); // Rating value (1 to 5)
//   const [hoveredRating, setHoveredRating] = useState(null); // To track hover state
//   const [review, setReview] = useState(""); // Review text
//   const [userSelectedAddon, setUserSelectedAddon] = useState(null);
//   const [amount, setAmount] = useState("");
//   const [date, setDate] = useState("");
//   const [notes, setNote] = useState("");
//   const [time, setTime] = useState("");
//   const currentDate = new Date();
//   const bookingDate = new Date(selectedAppointment?.booking_date_time);
//   const [allsetdata, setallsetdata] = useState();
//   console.log(allsetdata);
//   const calculateTotal = () => {
//     const existingTotal = bookingBill.reduce(
//       (total, item) => total + item.s_m_rate,
//       0
//     );
   
//     return existingTotal;
//   };

//   const getbooking = async (id) => {
//     if (!id) {
//       console.error("❌ No order_id provided for get_service_cart_list API");
//       return null;
//     }

//     setLoading(true);
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         {
//           action: "get_service_cart_list",
//           api_key: "1",
//           order_id: id,
//         }
//       );

//       if (response.status === 200 && response.data.status === "true") {
//         return response.data.response; // Return fresh data
//       } else {
//         console.error("❌ Unexpected response:", response.data);
//         return null;
//       }
//     } catch (error) {
//       console.error("🚨 Error fetching get_service_cart_list:", error);
//       return null;
//     } finally {
//       setLoading(false);
//     }
//   };
//   const parseCurrency = (str) => parseFloat(str?.replace(/[^0-9.-]+/g, ""));

//   const totalAmount = parseCurrency(allsetdata?.amount);
//   const discountAmount = parseCurrency(allsetdata?.discount);
//   const taxAmount = parseCurrency(allsetdata?.cart_tax);

//   const total2 = calculateTotal();

//   console.log(totalAmount, discountAmount, taxAmount);

//   const subTotalEdit = totalAmount + total2;

//   const disEdit = (subTotalEdit * 10) / 100;

//   const subm = subTotalEdit - disEdit;

//   console.log(subm, "submmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm");

//   const totelamount2 = subm + taxAmount;

//   console.log(
//     totelamount2,
//     "totelamountmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm"
//   );

//   const frequencyMap = {
//     Once: 0,
//     Weekly: 15,
//     "Bi-Weekly": 12.5,
//     Monthly: 10,
//   };

//   // allsetdata.discount_typename ka corresponding value nikalna
//   const abcdata = frequencyMap[allsetdata?.discount_typename] || 0;

//   console.log(abcdata);

//   const toatelfinalamount = parseCurrency(allsetdata?.total_amount);

//   const total = calculateTotal();

//   const discountPercentage = (discountAmount / totalAmount) * 100;
//   const finalDiscount = discountPercentage.toFixed(2);
//   // const finalDiscount = 10;

//   const totelamount = totalAmount + total;

//   const discountedTotal = (subTotalEdit * abcdata) / 100;

//   const totalfinalamount = totelamount - discountedTotal;

//   const finelamount = totalfinalamount + taxAmount;

//   console.log(totalfinalamount, "totalfinalamount");

//   console.log(totelamount, "totelamount");
//   console.log(finelamount, "finelamount");
//   console.log(discountedTotal, "discountedTotal");
//   const diffInMonths =
//     (bookingDate.getFullYear() - currentDate.getFullYear()) * 12 +
//     bookingDate.getMonth() -
//     currentDate.getMonth();

//   // Check if the booking is more than one month in the future
//   const isMoreThanOneMonthAway =
//     diffInMonths > 1 ||
//     (diffInMonths === 1 && bookingDate.getDate() > currentDate.getDate());

//     const calculateDaysDifference = (appointmentDate) => {
//       const currentDate = new Date();
//       const bookingDate = new Date(appointmentDate);
//       const timeDiff = bookingDate - currentDate;
//       const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
//       return daysDiff;
//     };
//   const methodSelectedRef = useRef(false);
//   const [Services_frequently_discount, setServices_frequently_discount] =
//     useState([]);
//   const [propertyQuantities, setPropertyQuantities] = useState({
//     Build_walls: 0,
//     Build_doors: 0,
//     Build_windows: 0,
//   });
//   const [officeQuantities, setOfficeQuantities] = useState({
//     desk: 0,
//     window: 0,
//   });
 
//   const fetchRatings = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       const response = await axios.post(`${BaseUrl}/backend/api/accept.appointment.php`, {
//         action: 'get_ratings',
//       }, {
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       });
//       console.log(response.data)

//       // Check if the response is successful
//       if (response.data.status === 'true' && response.data.statuscode === 200) {
//         setRatings(response.data.response); // Store the ratings data
//       } else {
//         setError(response.data.response || 'Failed to fetch ratings');
//       }
//     } catch (err) {
//       setError(err.message || 'An error occurred while fetching ratings');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch ratings when the component mounts
//   useEffect(() => {
//     fetchRatings();
//   }, []);

//   const addItemToBill = (units_id, itemName, quantity, pricePerItem) => {
//     setBookingBill((prevBill) => {
//       const existingItemIndex = prevBill.findIndex(
//         (item) => item.name === itemName
//       );
//       let updatedBill;
//       if (existingItemIndex !== -1) {
//         updatedBill = [...prevBill];
//         updatedBill[existingItemIndex].quantity += quantity;
//         updatedBill[existingItemIndex].price += quantity * pricePerItem;
//       } else {
//         updatedBill = [
//           ...prevBill,
//           {
//             type: "method_units",
//             service_id: selectedService,
//             method_id: selectedMethod.method_id,
//             units_id: units_id,
//             name: itemName,
//             s_m_qty: quantity,
//             s_m_rate: quantity * pricePerItem,
//           },
//         ];
//       }
//       // Calculate the new total time (add 60 minutes for each new unit added)
//       const newTotalTime =
//         prevBill.reduce(
//           (time, item) => time + (item.s_m_qty ? item.s_m_qty : 0) * 60,
//           0
//         ) +
//         quantity * 60;
//       setTotalTime(newTotalTime);
//       return updatedBill;
//     });
//   };

//   const calculateDiscountedTotal = (data) => {
//     const total = calculateTotal(); // Get the total price
//     //(total);

//     console.log("total", total);

//     setsubtotale(total);
//     if (isNaN(total)) {
//       console.error("Total calculation resulted in NaN:", total);
//       return 0;
//     }
//     setSelectedDiscount(finalDiscount);
//     const discountPercentage = selectedDiscount;
//     // Get the discount based on the frequency
//     console.log("totaltotaltotal", total);

//     const discountAmount = (total * discountPercentage) / 100; // Calculate the discount
//     const totalAfterDiscount = total; // Subtract the discount from the total
//     const taxsum = total === 0 ? 0 : 10;
//     setDisamount(discountAmount);
//     settax(taxsum);

//     console.log(totalAfterDiscount);

//     setText(totalAfterDiscount);
//     return totalAfterDiscount;
//   };
//   //(adminData, "adminData");
//   const [icon, setIcon] = useState("+"); // State to control the icon (either "+" or "-")
//   const handleImageSectionToggle = () => {
//     setShowImageSection((prevState) => !prevState); // Toggle the visibility of the image section
//     setIcon((prevIcon) => (prevIcon === "+" ? "-" : "+"));
//   };
//   const [formData, setFormData] = useState({
//     serviceLocation: "",
//     zipCode: "",
//     selectedService: "",
//     image: image1,
//     showHouseOptions: false,
//     showPlumbingOptions: false,
//     showCarpenterOptions: false,
//     showOfficeOptions: false,
//     bedroomCount: "",
//     bathroomCount: "",
//   });
//   const navigate = useNavigate();

//   const filteredData = appointments.filter(
//     (row) =>
//       row.order_id.toLowerCase().includes(searchQuery.toLowerCase()) || // Filter by order_id
//       row.appointment_date.includes(searchQuery) || // Filter by appointment_date
//       row.appointment_time.includes(searchQuery) // Filter by appointment_time
//   );
//   const totalEntries = filteredData.length;
//   const startIndex =
//     (currentPage - 1) *
//     (entriesPerPage === "All" ? totalEntries : entriesPerPage);
//   const paginatedData = (
//     entriesPerPage === "All"
//       ? filteredData
//       : filteredData.slice(startIndex, startIndex + entriesPerPage)
//   )
//     .filter((item, index, self) => {
//       const uniqueKey = `${item.order_id}-${item.appointment_date}`;
//       return (
//         index ===
//         self.findIndex(
//           (t) => `${t.order_id}-${t.appointment_date}` === uniqueKey
//         )
//       );
//     })
//     .sort((a, b) => {
//       const dateA = new Date(b.appointment_date);
//       const dateB = new Date(a.appointment_date);
//       if (dateA > dateB) return -1; // Descending order for dates
//       if (dateA < dateB) return 1;
//       if (a.order_id > b.order_id) return -1; // Descending order for order_id
//       if (a.order_id < b.order_id) return 1;
//       return 0;
//     });

//   console.log(paginatedData);

//   const totalPages = Math.ceil(filteredData.length / entriesPerPage);
//   const handleSearch = (e) => setSearchQuery(e.target.value);
//   const handleEntriesChange = (e) => {
//     setEntriesPerPage(
//       e.target.value === "All" ? "All" : Number(e.target.value)
//     );
//     setCurrentPage(1); // Reset to the first page
//   };
//   const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
//   const handleNextPage = () =>
//     setCurrentPage((prev) => Math.min(prev + 1, totalPages));



//   const generateInvoice = async (userId, allsetdata) => {
//     console.log(allsetdata);
//     // Retrieve user details from your state (ensure this returns an object)
//     const user = userDetails;
//     if (!user) {
//       console.error("User details not found");
//       return; // Exit if user details are not available
//     }
//     //("Appointment Data:", appointment);
//     const doc = new jsPDF();

//     // Company details (static in this example)
//     const companyDetails = {
//       name: "MegaClean",
//       address: "123 Clean St, Riyadh",
//       phone: "+1005555555",
//     };
//     // **Company Header**
//     doc.setFontSize(16);
//     doc.setFont("helvetica", "bold");
//     doc.text(companyDetails.name, 20, 20);
//     doc.setFontSize(10);
//     doc.setFont("helvetica", "normal");
//     doc.text(companyDetails.address, 20, 30);
//     doc.text(companyDetails.phone, 20, 37);

//     // **Invoice Header**
//     doc.setFontSize(14);
//     doc.setFont("helvetica", "bold");
//     // Adjust x-coordinate based on page width for right alignment
//     doc.text("INVOICE", doc.internal.pageSize.width - 60, 20);
//     doc.setFontSize(10);
//     doc.setFont("helvetica", "normal");
//     // Use dynamic date if available, or fallback to current date
//     const invoiceDate =
//       allsetdata?.invoice_date || new Date().toLocaleDateString();
//     doc.text(
//       `Invoice Date: ${invoiceDate}`,
//       doc.internal.pageSize.width - 60,
//       30
//     );
//     // Use dynamic order ID from allsetdata? data
//     doc.text(
//       `Order ID: ${allsetdata?.order_id || "N/A"}`,
//       doc.internal.pageSize.width - 60,
//       37
//     );

//     // **Customer Details**
//     doc.setFontSize(12);
//     doc.setFont("helvetica", "bold");
//     doc.text("Customer Details", 20, 55);
//     doc.setFontSize(10);
//     doc.setFont("helvetica", "normal");
//     doc.text(
//       `Name: ${user.first_name || "N/A"} ${user.last_name || ""}`,
//       20,
//       65
//     );
//     doc.text(`Email: ${user.user_email || "N/A"}`, 20, 72);
//     doc.text(`Phone: ${user.phone || "N/A"}`, 20, 79);
//     // Concatenate address fields ensuring commas only if fields exist
//     const addressParts = [user.address, user.city, user.state, user.zip].filter(
//       Boolean
//     );
//     doc.text(`Address: ${addressParts.join(", ") || "N/A"}`, 20, 86);

//     let yPosition = 105;

//     // **Service Table Header**
//     const tableTop = yPosition;
//     doc.setFillColor(51, 51, 51);
//     doc.setTextColor(255, 255, 255);

//     // Draw table header background cells
//     doc.rect(20, tableTop, 100, 8, "F"); // Service Name column
//     doc.rect(120, tableTop, 25, 8, "F"); // Quantity column
//     doc.rect(145, tableTop, 25, 8, "F"); // Unit Price column
//     doc.rect(170, tableTop, 25, 8, "F"); // Total column

//     // Add table header texts
//     doc.setFontSize(10);
//     doc.setFont("helvetica", "bold");
//     doc.text("Service Name", 22, tableTop + 6);
//     doc.text("Qty", 128, tableTop + 6);
//     doc.text("Unit Price", 147, tableTop + 6);
//     doc.text("Total", 172, tableTop + 6);

//     // Reset text color for the table body
//     doc.setTextColor(0, 0, 0);
//     yPosition = tableTop + 15;

//     // **Service Details** (dynamic values with fallbacks)
//     const serviceTitle = allsetdata?.service_title || "N/A";
//     const serviceUnit = allsetdata?.units_title || "";
//     const serviceQty = allsetdata?.method_unit_id || "N/A";
//     const unitPrice = allsetdata?.method_unit_qty_rate || "N/A";
//     const totalPrice =
//       allsetdata?.method_unit_id && allsetdata?.method_unit_qty_rate
//         ? `$${(
//             parseFloat(allsetdata?.method_unit_id) *
//             parseFloat(allsetdata?.method_unit_qty_rate)
//           ).toFixed(2)}`
//         : "N/A";

//     doc.setFont("helvetica", "normal");
//     doc.text(
//       `${serviceTitle} ${serviceUnit ? `(${serviceUnit})` : ""}`,
//       22,
//       yPosition
//     );
//     doc.text(String(serviceQty), 128, yPosition);
//     doc.text(String(unitPrice), 147, yPosition);
//     doc.text(String(totalPrice), 172, yPosition);

//     // **Add-ons Section**
//     yPosition += 20;
//     doc.setFont("helvetica", "bold");
//     doc.text("Add-ons", 20, yPosition);
//     doc.setFont("helvetica", "normal");
//     yPosition += 10;

//     // Process add-ons if available
//     if (allsetdata?.addon_service_name) {
//       const addons = allsetdata?.addon_service_name.split(",");
//       const addonQty = allsetdata?.addons_service_qty
//         ? allsetdata?.addons_service_qty.split(",")
//         : [];
//       const addonRate = allsetdata?.addons_service_rate
//         ? allsetdata?.addons_service_rate.split(",")
//         : [];
//       const addonUnits = allsetdata?.addon_service_name
//         ? allsetdata?.addon_service_name.split(",")
//         : [];
//       const addonPrice = allsetdata?.addons_service_rate
//         ? allsetdata?.addons_service_rate.split(",")
//         : [];

//       addons.forEach((addon, i) => {
//         const currentUnit = addonUnits[i] || "N/A";
//         const currentQty = addonQty[i] || "N/A";
//         const currentRate = addonRate[i] || "N/A";
//         const crrentprice = addonPrice[i] || "N/A";
//         doc.text(String(currentQty), 128, yPosition);
//         doc.text(`${addon} (${currentUnit})`, 22, yPosition);
//         doc.text(String(crrentprice), 147, yPosition);

//         doc.text(String(currentRate), 172, yPosition);

//         yPosition += 10;
//       });
//     } else {
//       doc.text("No Add-ons available", 22, yPosition);
//       yPosition += 10;
//     }
//     yPosition += 15;
//     doc.setFont("helvetica", "bold");
//     doc.text("Summary", 20, yPosition);
//     yPosition += 10;

//     const cleanCurrency = (value) => {
//       if (!value) return 0;
//       return parseFloat(value.toString().replace(/[^0-9.]/g, "")) || 0;
//     };

//     // Dynamic summary items using API response values directly
//     const subtotal = cleanCurrency(allsetdata?.amount) || 0; // Using amount as subtotal
//     const frequently_discount_amount =
//       cleanCurrency(allsetdata?.discount) || 0; // Direct discount value
//     // const couponDiscount = cleanCurrency(allsetdata?.frequent_discount) || 0;  // Using frequent_discount as coupon
//     const taxAmount = cleanCurrency(allsetdata?.cart_tax) || 0; // Direct tax value

//     const summaryItems = [
//       { label: "Subtotal", value: `${Number(subtotal).toFixed(2)}` },

//       {
//         label: "Discount",
//         value: `${Number(frequently_discount_amount).toFixed(2)}`,
//       },
//       { label: "Tax", value: `${Number(taxAmount).toFixed(2)}` },
//     ];
//     doc.setFont("helvetica", "normal");
//     summaryItems.forEach((item) => {
//       doc.text(item.label, 120, yPosition);
//       doc.text(item.value, 172, yPosition);
//       yPosition += 8;
//     });

//     // **Total Calculation**
//     yPosition += 5;
//     doc.setFillColor(240, 240, 240);
//     doc.rect(115, yPosition - 6, 80, 8, "F");
//     doc.setFont("helvetica", "bold");
//     // Use total_amount directly from API response instead of calculating
//     const totalPayment = cleanCurrency(allsetdata?.total_amount) || 0;
//     doc.text("Total", 120, yPosition);
//     doc.text(`${Number(totalPayment).toFixed(2)}`, 172, yPosition);

//     // **Footer with Booking Date**
//     yPosition += 25;
//     doc.setFont("helvetica", "normal");
//     const bookingDate = allsetdata?.booking_date_time || "N/A";
//     doc.text(`Booked On: ${bookingDate}`, 20, yPosition);

//     yPosition += 10;
//     doc.setFont("helvetica", "bold");
//     doc.text("Thank you for choosing MegaClean!", 20, yPosition);

//     // Page number at bottom right
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(10);
//     doc.text(
//       "Page 1 of 1",
//       doc.internal.pageSize.width - 30,
//       doc.internal.pageSize.height - 10
//     );

//     // Save the generated invoice as a PDF file
//     doc.save(`Invoice_${userId}.pdf`);
//   };

//   const toggleServicePanel = () => {
//     setIsServiceOpen((prev) => !prev); // Toggle this panel
//     if (!isServiceOpen) {
//       // If opening this panel
//       setIsCalendarOpen(false); // Close others
//       setIsFormOpen(false);
//     }
//   };
//   const openRatingMenuaaa = (row) => {
//     //("hello");
//     setSelectedAppointment(row); // Store the selected row data
//     setIsRatingModalOpen(true); // Open the modal
//   };
//   const closeRatingMenu = () => {
//     setIsRatingModalOpen(false); // Close the modal
//   };
//   const handleSaveRating = async () => {
//     setLoading(true);

//     // Ensure selectedAppointment has valid data
//     if (!selectedAppointment) {
//       console.error("No appointment selected.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/accept.appointment.php`,
//         {
//           action: "add_rating_review",
//           api_key: "1", // Your API key
//           order_id: selectedAppointment.order_id, // Pass order_id
//           staff_id: selectedAppointment.staff_ids, // Pass staff_id
//           rating: rating, // Convert rating to string if necessary
//           review: review, // User review text
//         }
//       );

//       // Check if the response is successful
//       if (response.data.status === "true") {
//         setSuccessMessage("Add Rating Review Successfully!");
//         setShowRatingModal(false); // Close the modal
//         fetchRatings()
//         // Reset rating and review state
//         setRating(0);
//         setReview("");

//         // Refresh appointment list
//         fetchAppointments(sessionStorage.getItem("userId"));
//       } else {
//         console.error("Error saving rating:", response.data);
//       }
//     } catch (error) {
//       console.error("Error during API call:", error);
//     } finally {
//       setLoading(false); // Ensure loading is stopped in all cases
//       closeRatingModal();
//     }
//   };

//   // Close rating modal
//   const closeRatingModal = () => {
//     setIsRatingModalOpen(false);
//     setRating(0);
//     setReview("");
//   };
//   const handleSaveCancel = async () => {
//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_reject.php`,
//         {
//           action: "reject_appointment",
//           api_key: "1",
//           order_id: selectedAppointment.order_id,
//           reject_reason: cancelReason,
//         }
//       );

//       if (response.data.response) {
//         setSuccessMessage("Reject Appointment Successfully!");
//       } else {
//         console.error("Error rejecting appointment:", response.data);
//       }
//     } catch (error) {
//       console.error("Error during API call:", error);
//     } finally {
//       setLoading(false); // Ensure loading stops in all cases
//       setShowCancelModal(false); // Ensure modal is closed
//     }
//   };

//   const handleUpdate = async () => {
//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_reshedule.php`,
//         {
//           action: "reschedule_appointment",
//           api_key: "1",
//           order_id: selectedAppointment.order_id,
//           date,
//           notes,
//           time,
//         }
//       );

//       if (response.data.response) {
//         setSuccessMessage("Reschedule Appointment Successfully!");
//       } else {
//         console.error("Error rescheduling appointment:", response.data);
//       }
//     } catch (error) {
//       console.error("Error during API call:", error);
//     } finally {
//       setLoading(false); // Ensure loading stops in all cases
//       closeModal(); // Ensure modal is closed
//     }
//   };

//   const handleReviewChange = (e) => {
//     setReview(e.target.value);
//   };
//   // Handle Cancel
//   const handleCancelRating = () => {
//     setIsRatingModalOpen(false);
//   };

//   const removeItem = (idx) => {
//     setBookingBill((prevBill) => prevBill.filter((_, index) => index !== idx));
//   };
//   const handleMethodSelection = (method, id) => {
//     //("****************************", method, id);
//     switch ((method?.method_title, id)) {
//       case "Residential Services":
//         setResidential(true);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Commercial Services":
//         setResidential(false);
//         setCommercial(true);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Property Based":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(true);
//         officesetCommercial(false);
//         break;
//       case "Area Based (Feet)":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(true);
//         break;
//       default:
//         // Reset all states if no match is found
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//     }
//     setSelectedMethod(method, id);
//   };
//   const handleCancel = () => {
//     setShowAppointmentModal(false); // Close the appointment modal
//     setShowCancelModal(true); // Open the cancel modal
//   };
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });

//     // Log the value for the selected bedroom
//     if (name === "bedroomCount") {
//       //(`Selected Bedroom: ${value}`);
//     }
//   };
//   useEffect(() => {
//     calculateDiscountedTotal(); // Calculate discounted total whenever discount or total changes
//   }, [
//     selectedService,
//     bookingBill,
//     propertyQuantities,
//     area,
//     damagedFloors,
//     doorJams,
//     officeQuantities,
//     officearea,
//     packing,
//     storeroom,
//   ]);
//   useEffect(() => {
//     const updateOrAddToBill = (itemName, quantity, pricePerItem) => {
//       const existingItemIndex = bookingBill.findIndex(
//         (item) => item.name === itemName
//       );
//       if (existingItemIndex !== -1) {
//         const updatedBill = [...bookingBill];
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             ...updatedBill[existingItemIndex],
//             quantity,
//             price: quantity * pricePerItem,
//           };
//         } else {
//           updatedBill.splice(existingItemIndex, 1); // Remove the item if quantity is zero
//         }
//         setBookingBill(updatedBill);
//       } else if (quantity > 0) {
//         setBookingBill([
//           ...bookingBill,
//           {
//             type: "addon",
//             s_m_qty: quantity,
//             s_m_rate: quantity * pricePerItem,
//           },
//         ]);
//       }
//     };
//     updateOrAddToBill("Bedrooms", bedroom, 5);
//     updateOrAddToBill("Bathrooms", bathroom, 5);
//   }, [bedroom, bathroom]);
//   const handleBedroomChange = (unitId, value) => {
//     setBedroom((prevSelections) => ({
//       ...prevSelections,
//       [unitId]: value,
//     }));
//   };
//   const openEditServiceModal = async (row) => {
//     setLoading(true);
//     setorder_id_appointment(row.order_id);

//     // Reset states to ensure fresh data
//     setBookingBill([]);
//     setTotalTime(0);
//     setSelectedService(null);
//     setSelectedMethod(null);
//     setUserSelectedMethods([]);
//     setUserSelectedMethodsId([]);
//     setUserSelectedMethodsUnitsId([]);
//     setUserSelectedMethodsSmqty([]);
//     setUserSelectedAddon([]);
//     setQuantities([0, 0, 0]);
//     setallsetdata(null); // Reset allsetdata

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         {
//           action: "get_edit_booking_info",
//           api_key: "1",
//           order_id: row.order_id,
//         }
//       );

//       if (response.data.status === "true") {
//         const bookingData = response.data.response.ct_cart.method;
//         setSelectedAppointment(bookingData);
//         setShowEditServiceModal(true);

//         // Extract data from response
//         const serviceIds = bookingData.map((item) => item.service_id);
//         const methodIds = bookingData.map((item) => item.method_id);
//         const unitsIds = bookingData.map((item) => item.units_id);
//         const s_m_qty = bookingData.map((item) => item.s_m_qty);
//         const addonIds = bookingData
//           .filter((item) => item.type === "addon")
//           .map((item) => item.units_id);

//         // Set states with fresh data
//         setUserSelectedMethods(serviceIds);
//         setUserSelectedMethodsId(methodIds);
//         setUserSelectedMethodsUnitsId(unitsIds);
//         setUserSelectedMethodsSmqty(s_m_qty);
//         setUserSelectedAddon(addonIds);

//         // Fetch and set latest booking data
//         const bookingResponse = await getbooking(row.order_id);
//         if (bookingResponse) {
//           setallsetdata(bookingResponse);
//           // Set selected service from fresh data
//           setSelectedService(bookingResponse.service_id || serviceIds[0]);
//         }

//         // Process methods and set selected method
//         const data = services
//           .filter((id) => serviceIds.includes(id.service_id))
//           .map((md) => md.methods)[0];
//         if (data && data[0]) {
//           handleMethodSelection(data[0], data[0].method_id);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching booking details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAddonSelection = (addonId) => {
//     // Check if the add-on is already selected
//     if (userSelectedAddon.includes(addonId)) {
//       // If selected, remove it
//       setUserSelectedAddon(userSelectedAddon.filter((id) => id !== addonId));
//     } else {
//       // If not selected, add it
//       setUserSelectedAddon([...userSelectedAddon, addonId]);
//     }
//   };

//   const closeEditServiceModal = () => {
//     setShowEditServiceModal(false);
//   };
//   const openCancelRecurrencePopup = () => {
//     setShowCancelRecurrence(true);
//     setShowAppointmentModal(false);
//   };
//   const closeCancelRecurrencePopup = () => {
//     setShowCancelRecurrence(false);
//     setShowAppointmentModal(false);
//   };
//   const openAppointmentModal = (appointment) => {
//     // console.log(appointment);
//     setSelectedAppointment(appointment);
//     setShowAppointmentModal(true);
//     setShowRescheduleModal(false); // Ensure Reschedule modal is closed when Appointment modal is opened
//   };
//   const openRescheduleModal = () => {
//     setShowAppointmentModal(false); // Close My Appointment modal
//     setShowRescheduleModal(true);
//     if (selectedAppointment && selectedAppointment.amount) {
//       setAmount(selectedAppointment.amount);
//     }
//   };
//   const closeModal = () => {
//     setShowAppointmentModal(false);
//     setShowRescheduleModal(false);
//     setShowEditServiceModal(false);
//   };
//   const handleClick = () => {
//     navigate("admin");
//   };
//   const handleShowBookingSummary = () => {
//     setShowBookingSummary(true);
//   };
//   const handleSubmit = async () => {
//     setLoading(true);

//     const hasAtLeastOneUnit = bookingBill.some((item) => item.method_id);
//     if (!hasAtLeastOneUnit) {
//       alert("You must select at least one unit.");
//       setLoading(false);
//       return;
//     }

//     const formattedBookingBill = bookingBill.map((item) => ({
//       type: item.type || "method_units",
//       service_id: selectedService,
//       method_id: item.method_id,
//       units_id: item.units_id,
//       s_m_qty: item.s_m_qty,
//       s_m_rate: item.s_m_rate,
//     }));

//     const frequencyMap = {
//       Once: 1,
//       Weekly: 2,
//       "Bi-Weekly": 3,
//       Monthly: 4,
//     };

//     const frequent_discount1 =
//       allsetdata?.discount_typename || selectedFrequency;
//     const discountID = frequencyMap[frequent_discount1] || null;

//     const formattedData = {
//       action: "edit_booking_info",
//       api_key: "1",
//       order_id: order_id_appointment,
//       amount: totelamount,
//       taxes: tax.toFixed(2),
//       discount: disEdit,
//       net_amount: finelamount,
//       frequent_discount: discountID,
//       frequent_discount_amount: discountedTotal,
//       ct_cart: {
//         method: formattedBookingBill,
//       },
//       time_duration: "40",
//     };

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         formattedData
//       );

//       if (response.data.status === "true") {
//         setSuccessMessage("Appointment Updated successfully!");

//         // Fetch fresh data after successful update
//         const updatedBookingData = await getbooking(order_id_appointment);
//         if (updatedBookingData) {
//           setallsetdata(updatedBookingData);

//           // Update appointments list
//           setAppointments((prevAppointments) =>
//             prevAppointments.map((appointment) =>
//               appointment.order_id === order_id_appointment
//                 ? {
//                     ...appointment,
//                     amount: updatedBookingData?.amount,
//                     discount: updatedBookingData?.discount,
//                     total_amount: updatedBookingData?.total_amount,
//                     booking_date_time: updatedBookingData?.booking_date_time,
//                     method_name: updatedBookingData?.method_title,
//                     units: updatedBookingData?.units_title,
//                     addons: updatedBookingData?.addon_service_name,
//                   }
//                 : appointment
//             )
//           );
//         }

//         handleClosebookingSummary();
//       } else {
//         console.error("Error updating booking:", response.data);
//         alert("Failed to update booking. Please try again.");
//       }
//     } catch (error) {
//       console.error("API call failed:", error);
//       alert("An error occurred while updating the booking.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleQuantityChange = (
//     idx,
//     increment,
//     addon_name,
//     addon_price,
//     max_quantity
//   ) => {
//     console.log(`Addon Name: ${addon_name}`);

//     // Copy the quantities array to update
//     const newQuantities = [...quantities];

//     // Increment or decrement quantity based on user action
//     if (increment) {
//       if (newQuantities[idx] >= max_quantity) {
//         alert(`Maximum quantity of ${max_quantity} reached for ${addon_name}`);
//       } else {
//         newQuantities[idx] += 1; // Increase quantity
//       }
//     } else {
//       newQuantities[idx] = Math.max(0, newQuantities[idx] - 1); // Prevent negative quantities
//     }

//     setQuantities(newQuantities);

//     // Extract updated quantity and calculate total price dynamically using addon_price
//     const quantity = newQuantities[idx];
//     const totalPrice = quantity * addon_price;

//     console.log(`Quantity: ${quantity}, Price: ${totalPrice}`);

//     // Update bookingBill
//     const updatedBill = [...bookingBill];
//     const existingItemIndex = updatedBill.findIndex(
//       (item) => item.type === addon_name
//     );

//     if (existingItemIndex !== -1) {
//       if (quantity > 0) {
//         // Update existing item in the bill
//         updatedBill[existingItemIndex] = {
//           ...updatedBill[existingItemIndex],
//           s_m_qty: quantity,
//           s_m_rate: totalPrice,
//           units_id: idx,
//         };
//       } else {
//         // Remove item if quantity is zero
//         updatedBill.splice(existingItemIndex, 1);
//       }
//     } else if (quantity > 0) {
//       // Add new item to bookingBill
//       updatedBill.push({
//         type: "addon",
//         s_m_qty: quantity,
//         s_m_rate: totalPrice,
//         units_id: idx,
//       });
//     }

//     setBookingBill(updatedBill);

//     // Update total time by adding or subtracting 60 minutes for each selected addon
//     if (quantity > 0) {
//       setTotalTime((prevTime) => prevTime + 60); // Add 60 minutes for each addon
//     } else {
//       setTotalTime((prevTime) => prevTime - 60); // Subtract 60 minutes when addon is removed
//     }

//     console.log("Updated Booking Bill:", updatedBill);
//     console.log("Total Time:", totalTime);
//   };
//   const handleClosebookingSummary = () => {
//     setShowBookingSummary(false);
//     setShowBookingSummary2(false);
//     setShowEditServiceModal(false);

//     // Reset states to clear stale data
//     setBookingBill([]);
//     setTotalTime(0);
//     setSelectedService(null);
//     setSelectedMethod(null);
//     setUserSelectedMethods([]);
//     setUserSelectedMethodsId([]);
//     setUserSelectedMethodsUnitsId([]);
//     setUserSelectedMethodsSmqty([]);
//     setUserSelectedAddon([]);
//     setQuantities([0, 0, 0]);
//     setallsetdata(null);
//   };
//   const handleExcelExport = () => {
//     const columns = ["Order", "Service Name", "Order Date", "Order Time"];
//     const rows = appointments.map((row) => [
//       row.order_id, // Dynamic order_id
//       row.title,
//       row.appointment_date, // Dynamic appointment_date
//       row.appointment_time, // Dynamic appointment_time
//     ]);
//     const ws = XLSX.utils.aoa_to_sheet([columns, ...rows]);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "appointments");
//     XLSX.writeFile(wb, "appointments.xlsx");
//   };
//   const handlePdfExport = () => {
//     const doc = new jsPDF();
//     const columns = ["Order", "Service Name", "Order Date", "Order Time"];
//     const rows = appointments.map((row) => [
//       row.order_id, // Dynamic order_id
//       row.title,
//       row.appointment_date, // Dynamic appointment_date
//       row.appointment_time, // Dynamic appointment_time
//     ]);
//     doc.autoTable({
//       head: [columns],
//       body: rows,
//       startY: 20,
//       theme: "grid",
//       margin: { horizontal: 10 },
//       headStyles: { fillColor: [0, 123, 255], textColor: 255 },
//     });
//     doc.save("appointments.pdf");
//   };

//   const handleCancelRecurrence = async () => {
//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/accept.appointment.php`,
//         {
//           action: "add_rec",
//           api_key: "1",
//           order_id: selectedAppointment.order_id,
//           rec_id: selectedAppointment.recurring_id,
//           status: "P",
//         }
//       );

//       if (response.data.response) {
//         setSuccessMessage("Add Recurring Successfully!");
//       } else {
//         console.error("Error adding recurring:", response.data);
//       }
//     } catch (error) {
//       console.error("Error during API call:", error);
//     } finally {
//       setLoading(false); // Ensure loading stops in all cases
//       closeCancelRecurrencePopup(); // Ensure popup is closed
//     }
//   };

//   useEffect(() => {
//     const userId = sessionStorage.getItem("userId"); // Retrieve user ID from sessionStorage
//     //console.log("Retrieved userId from sessionStorage: ", userId); // Log userId to check if it's correct
//     if (userId) {
//       fetchAppointments(userId); // Fetch appointments first
//       fetchUserDetails(userId); // Fetch user details after
//     } else {
//       // console.log("No user ID found, handle accordingly");
//       setLoading(false); // Stop loading spinner if no user ID
//     }
//   }, []);
//   const fetchAppointments = async (userId) => {
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/user_appointment_list.php`,
//         {
//           action: "get_user_appointments_list",
//           api_key: "1",
//           user_type: "client",
//           user_id: userId,
//         }
//       );

//       if (response.data.status === "true") {
//         setAppointments(response.data.response); // Set appointments list
//         const userAppointment = response.data.response[0]; // Get the first appointment (or select based on your needs)
//         if (userAppointment) {
//           const selectedService = userAppointment.service_id; // assuming 'service_id' is available
//           setSelectedService(selectedService); // Set the service that was booked by the user
//           setAmount(userAppointment.amount || ""); // Assuming 'amount' is a field in the response
//         }
//       } else {
//         console.error("Error fetching appointments:", response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching appointments:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const fetchUserDetails = async (userId) => {
//     setLoading(true);
//     // console.log("Fetching user details for userId:", userId); // Log userId to verify it's passed correctly
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/customer_list.php`,
//         {
//           action: "all_customer_list", // Action key to get all customer details
//           api_key: "1", // API key
//         }
//       );
//       // console.log("API response for user details:", response.data); // Log the response to see what's returned
//       const user = response.data.response.find((user) => user.id === userId);
//       if (user) {
//         setUserDetails(user); // Set the user details if found
//       } else {
//         console.error("User not found in the response");
//       }
//     } catch (error) {
//       console.error("Error fetching user details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     const userId = sessionStorage.getItem("userId"); // Retrieve user ID from localStorage
//     // console.log("Retrieved userId from localStorage: ", userId);
//     if (userId) {
//       fetchAppointments(userId); // Fetch appointments
//       fetchServices(); // Fetch services
//     } else {
//       // console.log("No user ID found, handle accordingly");
//       setLoading(false); // Stop loading spinner if no user ID
//     }
//   }, [showEditServiceModal]); // Dependency on modal open state
//   const fetchServices = async () => {
//     // console.log("Fetching services...");
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/services.php`,
//         { action: "all_services", api_key: "1" },
//         { headers: { "Content-Type": "application/json" } }
//       );
//       // console.log("API response for services:", response.data);
//       if (response.data.status === "true") {
//         setServices(response.data.response);
//       } else {
//         console.error("Error fetching services:", response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching services:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handleRatingChange = (value, isHalf = false) => {
//     const rating = isHalf ? value - 0.5 : value;
//     setRating(rating);
//     console.log(rating)
//   };
//   const renderStars = (value) => {
//     const stars = [];
//     const fullStars = Math.floor(value);
//     const hasHalfStar = value % 1 !== 0;

//     // Full stars
//     for (let i = 1; i <= 5; i++) {
//       if (i <= fullStars) {
//         stars.push(
//           <FaStar key={`star-${i}`} className="text-yellow-500 text-3xl" />
//         );
//       } else if (i === fullStars + 1 && hasHalfStar) {
//         stars.push(
//           <FaStarHalfAlt
//             key={`star-${i}`}
//             className="text-yellow-500 text-3xl"
//           />
//         );
//       } else {
//         stars.push(
//           <FaRegStar key={`star-${i}`} className="text-gray-300 text-3xl" />
//         );
//       }
//     }
//     return stars;
//   };

//   console.log(selectedAppointment?.order_id)

//   const filteredRatings = ratings?.filter(
//     (ratingItem) => String(ratingItem?.order_id) === String(selectedAppointment?.order_id)
//   );
  
//   console.log(filteredRatings)


//   return (
//     <div>
//       {loading ? (
//         <div className="flex flex-col items-center justify-center min-h-screen">
//           <Circles height="80" width="80" color="grey" ariaLabel="loading" />
//           <h1 className="mt-2">Please wait...</h1>
//         </div>
//       ) : (
//         <div className="container mx-auto p-6">
//           {successMessage && (
//             <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
//               <span className="block sm:inline">{successMessage}</span>
//             </div>
//           )}

//           {error && (
//             <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
//               <span className="block sm:inline">{error}</span>
//             </div>
//           )}

//           <h1 className="text-2xl font-semibold mb-6">My Appointment</h1>
//           <div className="flex flex-col sm:flex-row justify-between items-center mb-4 space-y-4 sm:space-y-0">
//             <div className="flex flex-col sm:flex-row sm:items-center w-full space-y-4 sm:space-y-0 sm:space-x-6">
//               {/* Search Bar */}
//               <div className="relative w-full sm:w-80 md:w-96">
//                 <input
//                   type="text"
//                   placeholder="Search Staff..."
//                   value={searchQuery}
//                   onChange={handleSearch}
//                   className="p-3 w-full rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 pl-10"
//                 />
//                 <CiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
//               </div>

//               {/* Buttons (Excel & PDF) */}
//               <div className="flex flex-wrap justify-center sm:justify-start space-x-2 sm:ml-4">
//                 <button
//                   onClick={handleExcelExport}
//                   className="bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold text-sm sm:text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-blue-600 hover:to-blue-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
//                 >
//                   <FaFileExcel className="text-2xl" />
//                   Excel
//                 </button>
//                 <button
//                   onClick={handlePdfExport}
//                   className="bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold text-sm sm:text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-red-600 hover:to-red-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
//                 >
//                   <FaFilePdf className="text-2xl" /> PDF
//                 </button>
//               </div>
//             </div>

//             {/* Entries Per Page */}
//             <div className="flex items-center space-x-2">
//               <span>Show</span>
//               <select
//                 value={entriesPerPage}
//                 onChange={handleEntriesChange}
//                 className="p-2 border border-gray-300 rounded-md"
//               >
//                 <option value={10}>10</option>
//                 <option value={25}>25</option>
//                 <option value={50}>50</option>
//                 <option value="All">All</option>
//               </select>
//               <span>entries</span>
//             </div>
//           </div>

//           {/* // Mobile View (Cards) */}
//           <div className="block sm:hidden">
//             {paginatedData.map((row, index) => {
//               const orderDate = new Date(row.appointment_date);
//               const orderDateFormatted = orderDate.toLocaleDateString();
//               const orderTimeFormatted = orderDate.toLocaleTimeString();
//               const isComplete = row.booking_status === "CO";
//               const currentDate = new Date();
//               const daysDifference = calculateDaysDifference(row.booking_date_time);
//               const isWithin15Days = daysDifference >= 0 && daysDifference <= 15;
//               const isPastBooking = new Date(row.booking_date_time) < new Date();

//               return (
//                 <div
//                   key={index}
//                   className="bg-white rounded-lg shadow-md p-4 mb-4 border border-gray-100 hover:shadow-lg transition-shadow duration-200"
//                 >
//                   <div className="mb-3 pb-2 border-b border-gray-100">
//                     <h2 className="text-lg font-semibold text-gray-800">
//                       Order ID: {row.order_id}
//                     </h2>
//                     <div className="text-sm text-gray-600 mt-1 flex flex-col gap-1">
//                       <p>Date: {orderDateFormatted}</p>
//                       <p>Time: {orderTimeFormatted}</p>
//                     </div><div className="text-sm text-gray-600 mt-1 flex flex-col gap-1">
//                       Service Title :{row.title}
//                       </div>
//                   </div>

//                   <div className="flex flex-wrap gap-2 mb-2">
//                     <button
//                       className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-blue-600 bg-blue-50 hover:bg-blue-100 transition-colors duration-200"
//                       onClick={() => openAppointmentModal(row)}
//                     >
//                       <FaEye className="text-blue-500" />
//                       <span>View Details</span>
//                     </button>

//                     {!isPastBooking && !isWithin15Days && (
//                       <button
//                         onClick={() => openEditServiceModal(row)}
//                         className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-amber-600 bg-amber-50 hover:bg-amber-100 transition-colors duration-200"
//                       >
//                         <FaEdit className="text-amber-500" />
//                         <span>Edit Booking</span>
//                       </button>
//                     )}
//                   </div>

//                   <div className="flex flex-wrap gap-2">
//                     {row.recurrence_status === "Y" && (
//                       <button
//                         onClick={openCancelRecurrencePopup}
//                         className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-red-600 bg-red-50 hover:bg-red-100 transition-colors duration-200"
//                       >
//                         <FaTimes className="text-red-500" />
//                         <span>Cancel Recurrence</span>
//                       </button>
//                     )}

//                     <button
//                       onClick={async () => {
//                         const userId = sessionStorage.getItem("userId");

//                         if (!userId) {
//                           console.error("❌ User ID not found in localStorage");
//                           return;
//                         }

//                         if (!row?.order_id) {
//                           console.error("❌ Order ID missing in row data");
//                           return;
//                         }

//                         try {
//                           // 🛠️ Fetch booking data
//                           const bookingData = await getbooking(row.order_id);

//                           console.log("📢 bookingData received:", bookingData);

//                           if (!bookingData) {
//                             console.error(
//                               "❌ Booking data is null or undefined"
//                             );
//                             return;
//                           }

//                           // 🛠️ Call generateInvoice with the correct data
//                           generateInvoice(userId, bookingData);
//                         } catch (error) {
//                           console.error(
//                             "🚨 Error fetching booking data:",
//                             error
//                           );
//                         }
//                       }}
//                       className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-green-600 bg-green-50 hover:bg-green-100 transition-colors duration-200"
//                     >
//                       <FaDownload className="text-green-500" />
//                       Generate Invoice
//                     </button>

//                     {isComplete && (
//                       <button
//                         onClick={() => openRatingMenuaaa(row)}
//                         className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-purple-600 bg-purple-50 hover:bg-purple-100 transition-colors duration-200"
//                       >
//                         <FaStar className="text-purple-500" />
//                         <span>Rate Service</span>
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* // Tablet & Laptop View (Table) */}
//           <div className="hidden sm:block">
//             <div className="overflow-x-auto rounded-lg shadow">
//               <table className="min-w-full bg-white">
//                 <thead>
//                   <tr className="bg-gray-50 border-b border-gray-200">
//                     <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
//                       Order ID
//                     </th>
//                     <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
//                       Date
//                     </th>
//                     <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
//                       Time
//                     </th>
//                     <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
//                       Service Title
//                     </th>
//                     <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
//                       Booking Details
//                     </th>
//                     <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
//                       Actions
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-gray-200">
//                   {paginatedData.map((row, index) => {
//                     const daysDifference = calculateDaysDifference(row.booking_date_time);
//                     const isWithin15Days = daysDifference >= 0 && daysDifference <= 15;
//                     const isPastBooking = new Date(row.booking_date_time) < new Date();
//                     const orderDate = new Date(row.appointment_date);
//                     const orderDateFormatted = orderDate.toLocaleDateString();
//                     const orderTimeFormatted = row.appointment_time;
//                     const isComplete = row.booking_status === "CO";
//                     const currentDate = new Date();
//                     // const isPastBooking = orderDate < currentDate;

//                     return (
//                       <tr key={index} className="hover:bg-gray-50">
//                         <td className="px-4 py-3 text-sm text-gray-900 font-medium">
//                           {row.order_id}
//                         </td>
//                         <td className="px-4 py-3 text-sm text-gray-600">
//                           {orderDateFormatted}
//                         </td>
//                         <td className="px-4 py-3 text-sm text-gray-600">
//                           {orderTimeFormatted}
//                         </td>
//                         <td className="px-4 py-3 text-sm text-gray-600">
//                           {row?.title}
//                         </td>
//                         <td className="px-4 py-3">
//                           <div className="flex flex-wrap gap-2">
//                             <button
//                               className="flex items-center gap-1 px-2 py-1 text-xs rounded text-blue-600 bg-blue-50 hover:bg-blue-100 transition-colors duration-200"
//                               onClick={() => openAppointmentModal(row)}
//                             >
//                               <FaEye className="text-blue-500 " />
//                               <span className="text-sm">View Details</span>
//                             </button>

//                             {!isPastBooking && !isWithin15Days &&(
//                               <button
//                                 onClick={() => {
//                                   // seteditdataid(row.order_id)
//                                   getbooking(row.order_id);
//                                   openEditServiceModal(row);
//                                 }}
//                                 className="flex items-center gap-1 px-2 py-1 text-xs rounded text-amber-600 bg-amber-50 hover:bg-amber-100 transition-colors duration-200"
//                               >
//                                 <FaEdit className="text-amber-500" />
//                                 <span className="text-sm">Edit Service</span>
//                               </button>
//                             )}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3">
//                           <div className="flex flex-wrap gap-2">
//                             {row.recurrence_status === "Y" && (
//                               <button
//                                 onClick={openCancelRecurrencePopup}
//                                 className="flex items-center gap-1 px-2 py-1 text-xs rounded text-red-600 bg-red-50 hover:bg-red-100 transition-colors duration-200"
//                               >
//                                 <FaTimes className="text-red-500" />
//                                 <span>Cancel</span>
//                               </button>
//                             )}

//                             <button
//                               onClick={async () => {
//                                 const userId = sessionStorage.getItem("userId");

//                                 if (!userId) {
//                                   console.error(
//                                     "❌ User ID not found in localStorage"
//                                   );
//                                   return;
//                                 }

//                                 if (!row?.order_id) {
//                                   console.error(
//                                     "❌ Order ID missing in row data"
//                                   );
//                                   return;
//                                 }

//                                 try {
//                                   // 🛠️ Fetch booking data
//                                   const bookingData = await getbooking(
//                                     row.order_id
//                                   );

//                                   console.log(
//                                     "📢 bookingData received:",
//                                     bookingData
//                                   );

//                                   if (!bookingData) {
//                                     console.error(
//                                       "❌ Booking data is null or undefined"
//                                     );
//                                     return;
//                                   }

//                                   // 🛠️ Call generateInvoice with the correct data
//                                   generateInvoice(userId, bookingData);
//                                 } catch (error) {
//                                   console.error(
//                                     "🚨 Error fetching booking data:",
//                                     error
//                                   );
//                                 }
//                               }}
//                               className="flex items-center gap-1 px-3 py-2 text-sm rounded-md text-green-600 bg-green-50 hover:bg-green-100 transition-colors duration-200"
//                             >
//                               <FaDownload className="text-green-500" />
//                               Generate Invoice
//                             </button>

//                             {isComplete && (
//                               <button
//                                 onClick={() => openRatingMenuaaa(row)}
//                                 className="flex items-center gap-1 px-2 py-1 text-xs rounded text-purple-600 bg-purple-50 hover:bg-purple-100 transition-colors duration-200"
//                               >
//                                 <FaStar className="text-purple-500" />
//                                 <span className="text-sm">Rate</span>
//                               </button>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {isRatingModalOpen && selectedAppointment && (
//   <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
//     <div className="bg-white p-6 rounded-lg sm:w-[500px] md:w-[600px] lg:w-[700px]">
//       {filteredRatings.length > 0 ? (
//         <div className="mt-4">
//           <h3 className="text-lg font-semibold">Ratings:</h3>
//           <ul>
//             {filteredRatings.map((ratingItem) => (
//               <li key={ratingItem.id} className="border-b border-gray-200 py-2">
//                 <div className="flex items-center">
//                   <div className="flex">
//                     {renderStars(ratingItem.rating)}
//                   </div>
//                   <div className="ml-2">{ratingItem.review}</div>
//                 </div>
//               </li>
//             ))}
//           </ul>
//           <button
//             onClick={handleCancelRating}
//             className="px-4 py-2 mt-4 bg-gray-500 text-white rounded-md"
//           >
//             Cancel
//           </button>
//         </div>
//       ) : (
//         <>
//           <div className="flex items-center mt-4">
//         {[1, 2, 3, 4, 5].map((star) => (
//           <div key={star} className="relative">
//             {/* Full star button */}
//             <button
//               onClick={() => handleRatingChange(star)}
//               onMouseEnter={() => setHoveredRating(star)}
//               onMouseLeave={() => setHoveredRating(null)}
//               className="focus:outline-none relative z-10"
//             >
//               {renderStars(hoveredRating || rating)[star - 1]}
//             </button>

//                       {/* Half star button - overlay on left half */}
//                       <button
//                         onClick={() => handleRatingChange(star, true)}
//                         onMouseEnter={() => setHoveredRating(star - 0.5)}
//                         onMouseLeave={() => setHoveredRating(null)}
//                         className="absolute left-0 top-0 w-1/2 h-full focus:outline-none z-20"
//                       />
//                     </div>
//                   ))}

//                   {/* Rating display */}
//                   <div className="ml-4 p-2 border border-gray-300 rounded-md text-lg font-semibold text-gray-700">
//                     {hoveredRating ? hoveredRating.toFixed(1) : rating.toFixed(1)}
//                   </div>
//                 </div>

//                 <div className="mt-4">
//                   <textarea
//                     value={review}
//                     onChange={handleReviewChange}
//                     rows="4"
//                     placeholder="Write your review..."
//                     className="w-full p-2 border border-gray-300 rounded-md mt-2"
//                   />
//                 </div>
//                   <div className="flex justify-end mt-4 space-x-4">
//                     <button
//                       onClick={handleCancelRating}
//                       className="px-4 py-2 bg-gray-500 text-white rounded-md"
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       onClick={handleSaveRating}
//                       className="px-4 py-2 bg-blue-500 text-white rounded-md"
//                     >
//                       Save
//                     </button>
//                   </div>
//                   </>
//                 )}
//               </div>
//             </div>
//           )}
//           <div className="flex justify-end items-center space-x-4 p-2">
//             <button
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//               className="px-4 py-2 bg-blue-500 text-white rounded-md"
//             >
//               Previous
//             </button>
//             <span>{`Page ${currentPage} of ${totalPages}`}</span>
//             <button
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages}
//               className="px-4 py-2 bg-blue-500 text-white rounded-md"
//             >
//               Next
//             </button>
//           </div>
//           {showAppointmentModal && (  
//             <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50 p-4">
//               <div
//                 className="bg-white p-6 rounded-lg w-full max-w-xs sm:max-w-md md:max-w-lg lg:max-w-2xl xl:max-w-4xl max-h-[90vh] overflow-y-auto"
//                 style={{ zIndex: showRescheduleModal ? 49 : 50 }}
//               >
//                 {(() => {
//         const daysDifference = calculateDaysDifference(selectedAppointment.booking_date_time);
//         const isWithin15Days = daysDifference >= 0 && daysDifference <= 15;
//         const isPastBooking = new Date(selectedAppointment.booking_date_time) < new Date();

//         return (
//           <>
//             {/* Header */}
//             <div className="flex justify-between items-center">
//               <h2 className="text-xl font-semibold">Appointment Details</h2>
//               <button onClick={closeModal} className="text-red-500">
//                 <FaTimesCircle />
//               </button>
//             </div>
//                 {/* Mobile View (Cards) */}
//                 <div className="block sm:hidden">
//                   <div className="flex flex-col space-y-3 mt-4">
//                     <div>
//                       <strong>Order:</strong> {selectedAppointment.order_id}
//                     </div>
//                     <div>
//                       <strong>Service:</strong> {selectedAppointment.title}
//                     </div>
//                     <div>
//                       <strong>Booking Date & Time:</strong>{" "}
//                       {new Date(
//                         selectedAppointment?.booking_date_time
//                       ).toLocaleString()}
//                     </div>
//                     <div>
//                       <strong>More Details:</strong>
//                       <div className="space-y-1">
//                         <div>
//                           <strong>Method:</strong>{" "}
//                           {selectedAppointment.method_name}
//                         </div>
//                         <div>
//                           <strong>Units:</strong> {selectedAppointment.units}
//                         </div>
//                         <div>
//                           <strong>Add-ons:</strong> {selectedAppointment.addons}
//                         </div>
//                       </div>
//                     </div>
//                     <div>
//                       <strong>Status:</strong>{" "}
//                       {selectedAppointment.booking_status === "A"
//                         ? "Active"
//                         : selectedAppointment.booking_status === "RS"
//                         ? "Rescheduled"
//                         : selectedAppointment.booking_status === "C"
//                         ? "Confirm"
//                         : selectedAppointment.booking_status === "CS"
//                         ? "Rejected By Provider"
//                         : selectedAppointment.booking_status === "R"
//                         ? `Rejected: ${
//                             selectedAppointment.reject_reason ||
//                             "No reason provided"
//                           }`
//                         : ""}
//                     </div>
//                     <div className="flex space-x-2">
//                     {selectedAppointment.booking_status === "A" && !isPastBooking && !isWithin15Days && (
//                           <>
//                             <button
//                               onClick={openRescheduleModal}
//                               className="text-yellow-500 flex items-center gap-2 p-2 border rounded-md hover:bg-yellow-100"
//                             >
//                               <FaEdit />
//                               Reschedule
//                             </button>
//                             <button
//                               onClick={handleCancel}
//                               className="text-red-500 flex items-center gap-2 p-2 border rounded-md hover:bg-red-100"
//                             >
//                               <FaTimesCircle />
//                               Cancel
//                             </button>
//                           </>
//                         )}
//                       {selectedAppointment.booking_status === "CO" && (
//                         <button className="text-green-500 flex items-center gap-2 p-2 border rounded-md hover:bg-green-100">
//                           <FaCheck /> Confirmed
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 {/* Tablet & Laptop View (Table) */}
//                 <div className="hidden sm:block mt-4">
//                   <div className="overflow-x-auto">
//                     <table className="w-full border-collapse border border-gray-300">
//                       <thead>
//                         <tr className="bg-gray-100">
//                           <th className="p-3 border text-left">Order</th>
//                           <th className="p-3 border text-left">Service</th>
//                           <th className="p-3 border text-left">
//                             Booking Date & Time
//                           </th>
//                           <th className="p-3 border text-left">More Details</th>
//                           <th className="p-3 border text-left">Status</th>
//                           <th className="p-3 border text-left">Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         <tr>
//                           <td className="p-3 border">
//                             {selectedAppointment.order_id}
//                           </td>
//                           <td className="p-3 border">
//                             {selectedAppointment.title}
//                           </td>
//                           <td className="p-3 border">
//                             {new Date(
//                               selectedAppointment?.booking_date_time
//                             ).toLocaleString()}
//                           </td>
//                           <td className="p-3 border">
//                             <div className="space-y-1">
//                               <div>
//                                 <strong>Method:</strong>{" "}
//                                 {selectedAppointment.method_name}
//                               </div>
//                               <div>
//                                 <strong>Units:</strong>{" "}
//                                 {selectedAppointment.units}
//                               </div>
//                               <div>
//                                 <strong>Add-ons:</strong>{" "}
//                                 {selectedAppointment.addons}
//                               </div>
//                             </div>
//                           </td>
//                           <td className="p-3 border">
//                             {selectedAppointment.booking_status === "A"
//                               ? "Active"
//                               : selectedAppointment.booking_status === "RS"
//                               ? "Rescheduled"
//                               : selectedAppointment.booking_status === "C"
//                               ? "Confirm"
//                               : selectedAppointment.booking_status === "CS"
//                               ? "Rejected By Provider"
//                               : selectedAppointment.booking_status === "R"
//                               ? `Rejected: ${
//                                   selectedAppointment.reject_reason ||
//                                   "No reason provided"
//                                 }`
//                               : ""}
//                           </td>
//                           <td className="p-3 border">
//                             <div className="flex space-x-2">
//                             {selectedAppointment.booking_status === "A" && !isPastBooking && !isWithin15Days && (
//                                   <>
//                                     <button
//                                       onClick={openRescheduleModal}
//                                       className="text-yellow-500 flex items-center gap-2 p-2 border rounded-md hover:bg-yellow-100"
//                                     >
//                                       <FaEdit />
//                                       Reschedule
//                                     </button>
//                                     <button
//                                       onClick={handleCancel}
//                                       className="text-red-500 flex items-center gap-2 p-2 border rounded-md hover:bg-red-100"
//                                     >
//                                       <FaTimesCircle />
//                                       Cancel
//                                     </button>
//                                   </>
//                                 )}
//                               {selectedAppointment.booking_status === "CO" && (
//                                 <button className="text-green-500 flex items-center gap-2 p-2 border rounded-md hover:bg-green-100">
//                                   <FaCheck /> Confirmed
//                                 </button>
//                               )}
//                             </div>
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//                 </>
//               );
//             })()}
//               </div>
//             </div>
//           )}

//           {showCancelModal && (
//             <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-60">
//               <div className="bg-white p-6 rounded-lg sm:w-96 md:w-[400px] lg:w-[500px]">
//                 <div className="flex justify-between items-center">
//                   <h2 className="text-xl font-semibold">Cancel Appointment</h2>
//                   <button
//                     onClick={() => setShowCancelModal(false)}
//                     className="text-red-500"
//                   >
//                     <FaTimesCircle />
//                   </button>
//                 </div>
//                 <div className="mt-4">
//                   <label className="block">Cancellation Reason</label>
//                   <textarea
//                     className="w-full p-2 border border-gray-300 rounded-md mb-4"
//                     placeholder="Enter cancellation reason..."
//                     value={cancelReason}
//                     onChange={(e) => setCancelReason(e.target.value)}
//                   />
//                   <div className="flex justify-end">
//                     <button
//                       onClick={() => {
//                         handleSaveCancel();
//                       }}
//                       className="bg-green-500 text-white py-2 px-4 rounded-md mr-2"
//                     >
//                       Save
//                     </button>
//                     <button
//                       onClick={() => setShowCancelModal(false)}
//                       className="bg-gray-300 text-black py-2 px-4 rounded-md"
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//           {showEditServiceModal && (
//             <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
//               <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl h-auto max-h-[90vh] overflow-y-auto">
//                 <div className="sticky top-0 bg-white z-10 px-6 py-4 border-b flex justify-between items-center">
//                   <h2 className="text-xl font-semibold text-gray-800">
//                     Edit Booking
//                   </h2>
//                   <button
//                     onClick={handleClosebookingSummary}
//                     className="text-gray-500 hover:text-gray-700 transition-colors p-2 rounded-full hover:bg-gray-100"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="24"
//                       height="24"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     >
//                       <line x1="18" y1="6" x2="6" y2="18"></line>
//                       <line x1="6" y1="6" x2="18" y2="18"></line>
//                     </svg>
//                   </button>
//                 </div>

//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 p-6">
//                   {/* Left Column - Booking Form */}
//                   <div className="lg:col-span-2">
//                     <form onSubmit={handleSubmit} className="space-y-6">
//                       {/* Service Selection Panel */}
//                       <div className="bg-white rounded-lg shadow-md border border-gray-100">
//                         <div
//                           className="flex justify-between items-center bg-gradient-to-r from-blue-500 to-blue-600 p-4 rounded-t-lg cursor-pointer text-white"
//                           onClick={toggleServicePanel}
//                         >
//                           <h3 className="font-medium">Choose Services</h3>
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             width="20"
//                             height="20"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="2"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           >
//                             <polyline points="6 9 12 15 18 9"></polyline>
//                           </svg>
//                         </div>

//                         <div className="p-4">
//                           {/* Services Grid */}
//                           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
//                             {services?.map((service) => (
//                               <div
//                                 key={service.service_id}
//                                 onClick={() => {
//                                   if (service.service_id) {
//                                     setSelectedService(service.service_id);
//                                   } else {
//                                     console.error(
//                                       "Service ID is missing",
//                                       service
//                                     );
//                                   }
//                                 }}
//                                 className={`cursor-pointer border rounded-lg overflow-hidden shadow-sm transition-all duration-200 hover:shadow-md ${
//                                   userSelectedMethods.includes(
//                                     service.service_id
//                                   )
//                                     ? "ring-2 ring-blue-400"
//                                     : ""
//                                 } ${
//                                   selectedService === service.service_id
//                                     ? "ring-2 ring-blue-500 transform scale-[1.02]"
//                                     : ""
//                                 }`}
//                               >
//                                 <div className="relative">
//                                   <img
//                                     src={service?.service_image}
//                                     className="w-full h-32 object-cover"
//                                     // alt={service?.service_title || "Service"}
//                                   />
//                                   <div className="absolute inset-0 flex items-center justify-center text-white font-medium bg-black bg-opacity-40 text-center p-2">
//                                     {service?.service_title}
//                                   </div>
//                                 </div>
//                               </div>
//                             ))}
//                           </div>

//                           {/* Selected Service Details */}
//                           {selectedService && (
//                             <div className="mt-6 space-y-6">
//                               {services
//                                 .filter((s) => s.service_id === selectedService)
//                                 ?.map((service) => (
//                                   <div key={service.service_id}>
//                                     {/* Units Section */}
//                                     {service.units &&
//                                       service.units.length > 0 && (
//                                         <div className="bg-gray-50 p-4 rounded-lg mb-6">
//                                           <h3 className="font-medium text-gray-700 mb-4">
//                                             Units
//                                           </h3>
//                                           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                             {service.units?.map((unit) => (
//                                               <div
//                                                 key={unit.units_id}
//                                                 className="flex items-center space-x-4"
//                                               >
//                                                 <div className="w-full">
//                                                   <div className="flex items-center space-x-2 mb-2">
//                                                     <label className="block font-medium text-gray-700">
//                                                       {unit.unit_title}
//                                                     </label>
//                                                     <img
//                                                       src={Bed}
//                                                       className="w-5 h-5"
//                                                       alt="Unit Icon"
//                                                     />
//                                                   </div>
//                                                   <select
//                                                     className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 bg-white"
//                                                     value={
//                                                       bedroom[unit.units_id] ||
//                                                       unit.unit_min
//                                                     }
//                                                     onChange={(e) =>
//                                                       handleBedroomChange(
//                                                         unit.units_id,
//                                                         parseInt(e.target.value)
//                                                       )
//                                                     }
//                                                   >
//                                                     {Array.from(
//                                                       {
//                                                         length:
//                                                           unit.unit_max -
//                                                           unit.unit_min +
//                                                           1,
//                                                       },
//                                                       (_, i) => (
//                                                         <option
//                                                           key={
//                                                             i + unit.unit_min
//                                                           }
//                                                           value={
//                                                             i + unit.unit_min
//                                                           }
//                                                         >
//                                                           {i}
//                                                         </option>
//                                                       )
//                                                     )}
//                                                   </select>
//                                                 </div>
//                                               </div>
//                                             ))}
//                                           </div>
//                                         </div>
//                                       )}

//                                     {/* Methods Section */}
//                                     {service.methods &&
//                                       service.methods.length > 0 && (
//                                         <div className="space-y-6">
//                                           <div>
//                                             <h3 className="font-medium text-gray-700 mb-3">
//                                               Methods
//                                             </h3>
//                                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//                                               {service.methods?.map(
//                                                 (method) => (
//                                                   <button
//                                                     type="button"
//                                                     key={method.method_id}
//                                                     onClick={() => {
//                                                       handleMethodSelection(
//                                                         method,
//                                                         method.method_id
//                                                       );
//                                                     }}
//                                                     className={`p-3 border rounded-lg text-center transition-all duration-200 ${
//                                                       (selectedMethod &&
//                                                         selectedMethod.method_id ===
//                                                           method.method_id) ||
//                                                       userSelectedMethodsId.includes(
//                                                         method.method_id
//                                                       )
//                                                         ? "bg-blue-500 text-white border-blue-500 shadow-md"
//                                                         : "bg-white hover:bg-blue-50 border-gray-200"
//                                                     }`}
//                                                   >
//                                                     {method?.method_title}
//                                                   </button>
//                                                 )
//                                               )}
//                                             </div>
//                                           </div>
//                                           {selectedMethod && (
//                                             <div className="mt-6">
//                                               {selectedMethod.submethods &&
//                                               selectedMethod.submethods.length >
//                                                 0 ? (
//                                                 <div className="space-y-4">
//                                                   <h3 className="font-medium text-gray-700">
//                                                     Options
//                                                   </h3>
//                                                   {selectedMethod.submethods.map(
//                                                     (submethod) => (
//                                                       <div
//                                                         key={submethod.unit_id}
//                                                         className={`${
//                                                           userSelectedMethodsUnitsId.includes(
//                                                             submethod.unit_id
//                                                           )
//                                                             ? "border-blue-200 bg-blue-50"
//                                                             : "border-gray-200"
//                                                         } p-4 border rounded-lg shadow-sm transition-all duration-300`}
//                                                       >
//                                                          <h4 className="font-medium text-gray-700 mb-3">
//                                                           {submethod.unit_title} (₹{submethod.unit_price})
//                                                         </h4>

//                                                         <div className="mb-4">
//                                                           <label className="block font-medium mb-2">
//                                                             Select Quantity
//                                                           </label>
//                                                           <select
//                                                             className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                             onChange={(e) => {
//                                                               const quantity =
//                                                                 parseInt(
//                                                                   e.target
//                                                                     .value,
//                                                                   10
//                                                                 );
//                                                               addItemToBill(
//                                                                 submethod.unit_id,
//                                                                 submethod.unit_title,
//                                                                 quantity,
//                                                                 submethod.unit_price
//                                                               );
//                                                             }}
//                                                           >
//                                                             <option value="">
//                                                               Select Quantity
//                                                             </option>
//                                                             {[
//                                                               ...Array(
//                                                                 submethod.unit_max -
//                                                                   submethod.unit_min +
//                                                                   1
//                                                               ).keys(),
//                                                             ].map((qty) => {
//                                                               const quantity =
//                                                                 1 + qty;
//                                                               return (
//                                                                 <option
//                                                                   key={quantity}
//                                                                   value={
//                                                                     quantity
//                                                                   }
//                                                                 >
//                                                                   {quantity}
//                                                                 </option>
//                                                               );
//                                                             })}
//                                                           </select>
//                                                         </div>
                                                       
//                                                       </div>
//                                                     )
//                                                   )}
//                                                 </div>
//                                               ) : (
//                                                 <p className="text-gray-500 italic">
//                                                   No options available for this
//                                                   method.
//                                                 </p>
//                                               )}
//                                             </div>
//                                           )}
//                                         </div>
//                                       )}

//                                     {/* Add-ons Section */}
//                                     {selectedMethod &&
//                                       service.addons?.length > 0 && (
//                                         <div className="mt-8">
//                                           <h3 className="font-medium text-gray-700 mb-4">
//                                             Add-ons
//                                           </h3>
//                                           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//                                             {service.addons.map(
//                                               (addon, index) => (
//                                                 <div
//                                                   key={addon.addon_id}
//                                                   className={`border rounded-lg overflow-hidden shadow-sm transition-all duration-200 ${
//                                                     userSelectedAddon.includes(
//                                                       addon.addon_id
//                                                     )
//                                                       ? "border-blue-300 bg-blue-50"
//                                                       : "border-gray-200 bg-white hover:border-blue-200"
//                                                   }`}
//                                                   onClick={() =>
//                                                     handleAddonSelection(
//                                                       addon.addon_id
//                                                     )
//                                                   }
//                                                 >
//                                                   <div className="p-4">
//                                                     <div className="text-center mb-3">
//                                                       <p className="font-medium text-gray-800">
//                                                         {addon.addon_name}
//                                                       </p>
//                                                     </div>
//                                                     <div className="text-center mb-4">
//                                                       <p className="text-blue-600 font-medium">
//                                                         ₹{addon.addon_price}
//                                                       </p>
//                                                     </div>

//                                                     <div className="flex items-center justify-center gap-3">
//                                                       <button
//                                                         type="button"
//                                                         onClick={(e) => {
//                                                           e.stopPropagation();
//                                                           handleQuantityChange(
//                                                             index,
//                                                             false,
//                                                             addon.addon_name,
//                                                             addon.addon_price,
//                                                             addon.addon_maxqty
//                                                           );
//                                                         }}
//                                                         className="p-1 w-8 h-8 flex items-center justify-center bg-red-100 text-red-600 rounded-full hover:bg-red-200 transition-colors"
//                                                       >
//                                                         -
//                                                       </button>
//                                                       <span className="text-lg font-medium w-8 text-center">
//                                                         {quantities[index]}
//                                                       </span>
//                                                       <button
//                                                         type="button"
//                                                         onClick={(e) => {
//                                                           e.stopPropagation();
//                                                           handleQuantityChange(
//                                                             index,
//                                                             true,
//                                                             addon.addon_name,
//                                                             addon.addon_price,
//                                                             addon.addon_maxqty
//                                                           );
//                                                         }}
//                                                         className="p-1 w-8 h-8 flex items-center justify-center bg-green-100 text-green-600 rounded-full hover:bg-green-200 transition-colors"
//                                                       >
//                                                         +
//                                                       </button>
//                                                     </div>
//                                                   </div>
//                                                 </div>
//                                               )
//                                             )}
//                                           </div>
//                                         </div>
//                                       )}
//                                   </div>
//                                 ))}
//                             </div>
//                           )}

//                           {/* Frequency Selection */}
//                         </div>
//                       </div>

//                       {/* Submit Button */}
//                       <div className="flex justify-center">
//                         <button
//                           type="submit"
//                           className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition duration-200 shadow-md hover:shadow-lg"
//                         >
//                           Submit Booking
//                         </button>
//                       </div>
//                     </form>
//                   </div>

//                   {/* Right Column - Booking Summary */}
//                   <div className="lg:col-span-1">
//                     <div className="bg-white border rounded-lg shadow-lg p-6 sticky top-24">
//                       <h2 className="text-lg font-bold text-gray-800 border-b pb-3 mb-4">
//                         Booking Summary
//                       </h2>

//                       {/* Date and Time */}
//                       <div className="space-y-4 mb-6">
//                         <div className="flex items-center text-sm text-gray-600">
//                           <div className="flex items-center space-x-2">
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               width="18"
//                               height="18"
//                               viewBox="0 0 24 24"
//                               fill="none"
//                               stroke="currentColor"
//                               strokeWidth="2"
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                             >
//                               <rect
//                                 x="3"
//                                 y="4"
//                                 width="18"
//                                 height="18"
//                                 rx="2"
//                                 ry="2"
//                               ></rect>
//                               <line x1="16" y1="2" x2="16" y2="6"></line>
//                               <line x1="8" y1="2" x2="8" y2="6"></line>
//                               <line x1="3" y1="10" x2="21" y2="10"></line>
//                             </svg>
//                             <span className="font-medium text-gray-700">
//                               Date & Time:
//                             </span>
//                             <div>
//                               {selectedDate && selectedTime ? (
//                                 <p>
//                                   {selectedDate} @ {selectedTime}
//                                 </p>
//                               ) : allsetdata?.booking_date_time ? (
//                                 <p>{allsetdata?.booking_date_time}</p>
//                               ) : (
//                                 <p className="text-gray-400 italic">
//                                   Not selected
//                                 </p>
//                               )}
//                             </div>
//                           </div>
//                         </div>

//                         {/* Frequency */}
//                         <div className="flex items-center text-sm text-gray-600">
//                           <div className="flex items-center space-x-2">
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               width="18"
//                               height="18"
//                               viewBox="0 0 24 24"
//                               fill="none"
//                               stroke="currentColor"
//                               strokeWidth="2"
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                             >
//                               <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
//                             </svg>
//                             <span className="font-medium text-gray-700">
//                               Frequency:
//                             </span>
//                             <p>
//                               {allsetdata?.discount_typename
//                                 ? allsetdata?.discount_typename
//                                 : selectedFrequency
//                                 ? selectedFrequency
//                                 : "N/A"}
//                             </p>
//                           </div>
//                         </div>

//                         {/* Duration */}
//                         <div className="flex items-center text-sm text-gray-600">
//                           <div className="flex items-center space-x-2">
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               width="18"
//                               height="18"
//                               viewBox="0 0 24 24"
//                               fill="none"
//                               stroke="currentColor"
//                               strokeWidth="2"
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                             >
//                               <circle cx="12" cy="12" r="10"></circle>
//                               <polyline points="12 6 12 12 16 14"></polyline>
//                             </svg>
//                             <span className="font-medium text-gray-700">
//                               Duration:{" "}
//                               {allsetdata?.order_duration
//                                 ? `${Math.round(
//                                     allsetdata?.order_duration / 60
//                                   )} Hours`
//                                 : "-"}
//                             </span>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Cart Items */}
//                       <div className="mb-6">
//                         <h3 className="font-bold text-gray-800 mb-3">
//                           Cart Items:
//                         </h3>
//                         {bookingBill.length === 0 ? (
//                           <div>
//                             <div className="flex items-center text-sm text-gray-600">
//                               <div className="flex items-center space-x-2">
//                                 <span className="font-medium text-gray-700">
//                                   Service:
//                                 </span>
//                                 <p>
//                                   {allsetdata?.service_title
//                                     ? allsetdata?.service_title
//                                     : "N/A"}
//                                 </p>
//                               </div>
//                             </div>

//                             {/* Method Title */}
//                             <div className="flex items-center text-sm text-gray-600">
//                               <div className="flex items-center space-x-2">
//                                 <span className="font-medium text-gray-700">
//                                   Method:
//                                 </span>
//                                 <p>
//                                   {allsetdata?.method_title
//                                     ? allsetdata?.method_title
//                                     : "N/A"}
//                                 </p>
//                               </div>
//                             </div>

//                             {/* Units Title */}
//                             <div className="flex items-center text-sm text-gray-600">
//                               <div className="flex items-center space-x-2">
//                                 <span className="font-medium text-gray-700">
//                                   Units:
//                                 </span>
//                                 <p>
//                                   {allsetdata?.units_title
//                                     ? allsetdata?.units_title
//                                     : "N/A"}
//                                 </p>
//                               </div>
//                             </div>
//                             <div className="flex items-center text-sm text-gray-600">
//                               <div className="flex items-center space-x-2">
//                                 <span className="font-medium text-gray-700">
//                                   Addon:
//                                 </span>
//                                 <p>
//                                   {allsetdata?.addon_service_name
//                                     ? allsetdata?.addon_service_name
//                                     : "N/A"}
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                         ) : (
//                           <ul className="space-y-2">
//                             {bookingBill?.map((item, idx) => (
//                               <li
//                                 key={idx}
//                                 className="flex justify-between items-center py-2 border-b border-gray-100"
//                               >
//                                  <span className="text-gray-700">
//                                  {item.name} 
//                                  </span>
//                                 <span className="text-gray-700">
//                                   {item.type}
//                                   <span className="text-gray-500 text-sm">
//                                     (x{item.s_m_qty})
//                                   </span>
//                                 </span>

//                                 <div className="flex gap-4">
//                                   <span> ₹{item.s_m_rate}</span>
//                                   <span
//                                     onClick={() => removeItem(idx)}
//                                     className="text-red-500 cursor-pointer"
//                                   >
//                                     X
//                                   </span>
//                                 </div>
//                               </li>
//                             ))}
//                           </ul>
//                         )}
//                       </div>

//                       {/* Pricing Summary */}
//                       <div className="border-t pt-4 text-gray-700">
//                         <div className="flex justify-between mb-2">
//                           <p>Sub Total:</p>
//                           <p className="font-medium">
//                             ₹{allsetdata?.amount.replace(/[^0-9.]/g, "")} + ₹
//                             {parseFloat(text)}
//                           </p>
//                         </div>

//                         <div className="flex justify-between mb-4">
//                           <p>Frequency Discount:</p>
//                           <p className="font-medium">-{discountedTotal}</p>
//                         </div>
//                         <div className="flex justify-between mb-4">
//                           <p>Tax:</p>
//                           <p className="font-medium">{allsetdata?.cart_tax}</p>
//                         </div>

//                         <div className="flex justify-between font-bold text-lg text-blue-800 pt-2 border-t">
//                           <p>Total:</p>
//                           <p>₹
//                             {/* {parseFloat(
//                               allsetdata.total_amount.replace(/[^0-9.]/g, "")) + parseFloat(text)} */}
//                             {finelamount}
//                           </p>
//                         </div>
//                         {/* </div> */}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Cancel Recurrence Modal */}
//           {showCancelRecurrence && (
//             <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 p-4">
//               <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
//                 <div className="flex justify-between items-center mb-4">
//                   <h2 className="text-xl font-semibold text-gray-800">
//                     Cancel Recurrence?
//                   </h2>
//                   <button
//                     onClick={() => closeCancelRecurrencePopup(false)}
//                     className="text-gray-500 hover:text-red-500 transition-colors"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="20"
//                       height="20"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     >
//                       <circle cx="12" cy="12" r="10"></circle>
//                       <line x1="15" y1="9" x2="9" y2="15"></line>
//                       <line x1="9" y1="9" x2="15" y2="15"></line>
//                     </svg>
//                   </button>
//                 </div>
//                 <div className="mt-2 mb-6">
//                   <p className="text-gray-600">
//                     Are you sure you want to cancel the recurrence of this
//                     appointment?
//                   </p>
//                 </div>
//                 <div className="flex justify-end gap-3">
//                   <button
//                     onClick={() => setShowCancelRecurrence(false)}
//                     className="bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-4 rounded-lg transition-colors"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={() => {
//                       handleCancelRecurrence();
//                     }}
//                     className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg shadow-sm hover:shadow-md transition-all"
//                   >
//                     Confirm
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Reschedule Modal */}
//           {showRescheduleModal && (
//             <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 p-4">
//               <div className="bg-white rounded-xl shadow-xl max-w-lg w-full p-6">
//                 <div className="flex justify-between items-center mb-6">
//                   <h2 className="text-xl font-semibold text-gray-800">
//                     Reschedule Appointment
//                   </h2>
//                   <button
//                     onClick={closeModal}
//                     className="text-gray-500 hover:text-red-500 transition-colors"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="20"
//                       height="20"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     >
//                       <circle cx="12" cy="12" r="10"></circle>
//                       <line x1="15" y1="9" x2="9" y2="15"></line>
//                       <line x1="9" y1="9" x2="15" y2="15"></line>
//                     </svg>
//                   </button>
//                 </div>

//                 <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Amount
//                   </label>
//                   <input
//                     type="text"
//                     className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
//                     placeholder="Amount"
//                     value={amount} // Display the fetched amount
//                     onChange={(e) => setAmount(e.target.value)} // Allow user to modify if needed
//                     disabled // Disable input since this value is fetched from the API  
//                   />
//                 </div>

//                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-1">
//                         Select Date
//                       </label>
//                       <input
//                         type="date"
//                         className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
//                         value={date}
//                         onChange={(e) => {
//                           setDate(e.target.value);
//                         }}
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-1">
//                         Select Time
//                       </label>
//                       <input
//                         type="time"
//                         className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
//                         value={time}
//                         onChange={(e) => {
//                           setTime(e.target.value);
//                         }}
//                       />
//                     </div>
//                   </div>

//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Note
//                     </label>
//                     <textarea
//                       className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 min-h-24"
//                       placeholder="Write a note..."
//                       value={notes}
//                       onChange={(e) => setNote(e.target.value)}
//                     ></textarea>
//                   </div>

//                   <div className="flex justify-end mt-6">
//                     <button
//                       onClick={() => {
//                         handleUpdate();
//                       }}
//                       className="bg-green-600 hover:bg-green-700 text-white py-2 px-6 rounded-lg shadow-sm hover:shadow-md transition-all"
//                     >
//                       Update
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }
// export default AppointmentS;